import * as i0 from '@angular/core';
import { Component, Input, NgModule, Injectable, EventEmitter, Inject, Output } from '@angular/core';
import * as i1 from '@ft-alts/ui-components/src/lib/shared-lib';
import { getModelFromRef, Logger, isValidValue, EMDASH, DashIfEmptyPipe, PipesModule, TooltipModule, IconModule, DirectivesModule, SwitchModule, PagedRecords, createDateComparator, getCellObject, getColWidths, PaginationModule, ButtonModule } from '@ft-alts/ui-components/src/lib/shared-lib';
import * as i3 from '@angular/common';
import { CommonModule, DecimalPipe } from '@angular/common';
import { Subject, forkJoin } from 'rxjs';
import cloneDeep from 'lodash/cloneDeep';
import { takeUntil, take } from 'rxjs/operators';
import * as Highcharts from 'highcharts';
import Highcharts__default from 'highcharts';
import * as i1$1 from '@ft-alts/ui-components/src/lib/common-lib';
import { CalcTypeStd } from '@ft-alts/ui-components/src/lib/common-lib';
import sortedUniq from 'lodash/sortedUniq';
import dayjs from 'dayjs';
import Accessibility from 'highcharts/modules/accessibility';
import * as i3$1 from 'highcharts-angular';
import { HighchartsChartModule } from 'highcharts-angular';
import * as i2 from '@angular/router';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { WINDOW } from '@ng-web-apis/common';
import { cloneDeep as cloneDeep$1 } from '@apollo/client/utilities';

function PerfHeaderComponent_h2_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
function PerfHeaderComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subTitle, " ");
} }
function PerfHeaderComponent_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r2.link.href, i0.ɵɵsanitizeUrl)("target", ctx_r2.link.target);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.link.text, " ");
} }
const _c0$c = function (a0) { return { "perf-header__bg-color--default": a0 }; };
const _c1$6 = function (a0) { return { "perf-header__responsive": a0 }; };
class PerfHeaderComponent {
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
        /**
         * Optional prop to set background color of the section.
         */
        this.bgColor = 'default';
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having header content
     */
    mapContent(document) {
        var _a;
        const { title, subTitle, link, bgColor } = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        this.title = title;
        this.subTitle = subTitle;
        this.link = link;
        if (bgColor) {
            this.bgColor = bgColor;
        }
    }
}
PerfHeaderComponent.ɵfac = function PerfHeaderComponent_Factory(t) { return new (t || PerfHeaderComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService)); };
PerfHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfHeaderComponent, selectors: [["ft-alts-perf-header"]], inputs: { component: "component", page: "page" }, decls: 9, vars: 11, consts: [[1, "perf-header", 3, "ngClass"], [1, "grid"], [1, "row", "color--ft-white", 3, "ngClass"], [1, "col", "l7", "m6", "s4"], ["class", "spacing--xs", 4, "ngIf"], [4, "ngIf"], [1, "col", "l5", "m6", "s4", "link-section"], [3, "href", "target", 4, "ngIf"], [1, "spacing--xs"], [3, "href", "target"]], template: function PerfHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, PerfHeaderComponent_h2_5_Template, 2, 1, "h2", 4);
        i0.ɵɵtemplate(6, PerfHeaderComponent_p_6_Template, 2, 1, "p", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, PerfHeaderComponent_a_8_Template, 2, 3, "a", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$c, ctx.bgColor === "default"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$6, i0.ɵɵpipeBind1(3, 5, ctx.isHandheld$)));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subTitle);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.link);
    } }, directives: [i3.NgClass, i3.NgIf], pipes: [i3.AsyncPipe], styles: [".perf-header__bg-color--default[_ngcontent-%COMP%]{background-color:var(--ft-charts-alts-dark-blue)}.perf-header[_ngcontent-%COMP%]   .grid[_ngcontent-%COMP%]{margin:0}.perf-header[_ngcontent-%COMP%]   .grid[_ngcontent-%COMP%]   .col[_ngcontent-%COMP%]{padding:0}.perf-header[_ngcontent-%COMP%]   .link-section[_ngcontent-%COMP%]{text-align:right}.perf-header__responsive[_ngcontent-%COMP%]{flex-direction:column-reverse!important}.perf-header__responsive[_ngcontent-%COMP%]   .link-section[_ngcontent-%COMP%]{text-align:left!important;margin-bottom:var(--space-md)!important}.perf-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-family:var(--fonts-link-underline-font-family);font-size:var(--fonts-link-underline-font-size-small-desktop);font-weight:400;line-height:var(--fonts-link-underline-line-height);text-decoration:underline;color:var(--ft-white)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-header',
                templateUrl: './perf-header.component.html',
                styleUrls: ['./perf-header.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfHeaderModule {
}
PerfHeaderModule.ɵfac = function PerfHeaderModule_Factory(t) { return new (t || PerfHeaderModule)(); };
PerfHeaderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfHeaderModule });
PerfHeaderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfHeaderComponent],
                imports: [CommonModule],
                exports: [PerfHeaderComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfHeaderModule, { declarations: [PerfHeaderComponent], imports: [CommonModule], exports: [PerfHeaderComponent] }); })();

class PerfTabsService {
    constructor() {
        this.tabSelected = new Subject();
    }
    /**
     * Return selected tab event as observable.
     */
    getSelectedTabNumber$() {
        return this.tabSelected.asObservable();
    }
    /**
     * Emit the selected tab event with current tab number.
     * @param currentTabNumber current active tab
     */
    onPerfTabSelected(currentTabNumber) {
        this.tabSelected.next(currentTabNumber);
    }
}
PerfTabsService.ɵfac = function PerfTabsService_Factory(t) { return new (t || PerfTabsService)(); };
PerfTabsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PerfTabsService, factory: PerfTabsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0$b = function (a0) { return { active: a0 }; };
function PerfTabsComponent_div_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function PerfTabsComponent_div_3_button_1_Template_button_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const i_r3 = restoredCtx.index; const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.onPerfTabSelected(i_r3, $event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tabName_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$b, ctx_r1.activeTabNumber === i_r3));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", tabName_r2, " ");
} }
const _c1$5 = function (a0) { return { "perf-tabs__bg-color--default": a0 }; };
function PerfTabsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, PerfTabsComponent_div_3_button_1_Template, 2, 4, "button", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$5, ctx_r0.bgColor === "default"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.tabNames);
} }
class PerfTabsComponent {
    constructor(perfTabsService, analytics) {
        this.perfTabsService = perfTabsService;
        this.analytics = analytics;
        /**
         * Name of the tabs of type string array.
         */
        this.tabNames = [];
        /**
         * Optional param to set background color of the tabs.
         */
        this.bgColor = 'default';
        /**
         * Class variable to track current active tab.
         */
        this.activeTabNumber = 0;
    }
    ngOnInit() {
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having performance tabs content
     */
    mapContent(document) {
        var _a;
        const { tabNames, bgColor } = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        this.tabNames = tabNames;
        if (bgColor) {
            this.bgColor = bgColor;
        }
    }
    /**
     * Save current tab number and emit its "selected event", when tab is selected.
     * @param currentTabNumber current active tab
     */
    onPerfTabSelected(currentTabNumber, event) {
        var _a, _b;
        this.activeTabNumber = currentTabNumber;
        this.perfTabsService.onPerfTabSelected(currentTabNumber);
        // Track Analytics Event
        const target = this.analytics.checkLink(event);
        if (target instanceof HTMLAnchorElement ||
            target instanceof HTMLButtonElement) {
            let linkUrl = '';
            let linkText = target.textContent;
            if (target instanceof HTMLAnchorElement) {
                linkUrl = target.href;
            }
            const isOutbound = (_b = (_a = target === null || target === void 0 ? void 0 : target.classList) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.includes('external-link');
            const tabType = target.getAttribute('data-tab_type');
            this.analytics.trackEvent({
                event: "tab_click",
                detailed_event: "Tab Clicks",
                event_data: {
                    category: "",
                    index: "",
                    link_id: "",
                    link_text: linkText.trim(),
                    link_type: this.analytics.getLinkType(linkUrl, isOutbound),
                    link_url: "",
                    tab_type: tabType,
                },
                link_text: linkText.trim(),
                link_url: "",
                tab_type: tabType,
            });
        }
    }
}
PerfTabsComponent.ɵfac = function PerfTabsComponent_Factory(t) { return new (t || PerfTabsComponent)(i0.ɵɵdirectiveInject(PerfTabsService), i0.ɵɵdirectiveInject(i1.AnalyticsService)); };
PerfTabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabsComponent, selectors: [["ft-alts-perf-tabs"]], inputs: { component: "component", page: "page" }, decls: 4, vars: 1, consts: [[1, "grid"], [1, "row"], [1, "col", "l12", "m8", "s4"], ["class", "perf-tabs", 3, "ngClass", 4, "ngIf"], [1, "perf-tabs", 3, "ngClass"], ["data-tab_type", "contentTab", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["data-tab_type", "contentTab", 3, "ngClass", "click"]], template: function PerfTabsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, PerfTabsComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.tabNames == null ? null : ctx.tabNames.length);
    } }, directives: [i3.NgIf, i3.NgClass, i3.NgForOf], styles: [".grid[_ngcontent-%COMP%]{margin:0}.grid[_ngcontent-%COMP%]   .col[_ngcontent-%COMP%]{padding:0}.perf-tabs[_ngcontent-%COMP%]{display:flex;grid-gap:24px;gap:24px;overflow-x:auto;white-space:nowrap;padding-bottom:8px}.perf-tabs[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:1px solid var(--ft-sky-blue);border-radius:24px;padding:16px 24px;background-color:var(--ft-complementary-sky-blue-1);color:var(--ft-complementary-sky-blue-4);transition:background-color .3s,color .3s;cursor:pointer;outline-offset:-1px;font-size:var(--fonts-button-small-font-size-small-desktop);font-family:var(--fonts-button-small-font-family);font-weight:var(--fonts-button-small-font-weight);line-height:var(--fonts-button-small-line-height)}.perf-tabs[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .perf-tabs[_ngcontent-%COMP%]   button.active[_ngcontent-%COMP%]{background-color:var(--ft-sky-blue);color:var(--ft-white)}.perf-tabs__bg-color--default[_ngcontent-%COMP%]{background-color:var(--ft-charts-alts-dark-blue)}.perf-tabs[_ngcontent-%COMP%]::-webkit-scrollbar{height:6px}.perf-tabs[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:var(--ft-complementary-sky-blue-1);border-radius:3px}.perf-tabs[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:var(--ft-alts-dark-blue)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabsComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tabs',
                templateUrl: './perf-tabs.component.html',
                styleUrls: ['./perf-tabs.component.scss'],
            }]
    }], function () { return [{ type: PerfTabsService }, { type: i1.AnalyticsService }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfTabsModule {
}
PerfTabsModule.ɵfac = function PerfTabsModule_Factory(t) { return new (t || PerfTabsModule)(); };
PerfTabsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabsModule });
PerfTabsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [PerfTabsService], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabsModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabsComponent],
                imports: [CommonModule],
                exports: [PerfTabsComponent],
                providers: [PerfTabsService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabsModule, { declarations: [PerfTabsComponent], imports: [CommonModule], exports: [PerfTabsComponent] }); })();

const logger$1 = Logger.getLogger('PerfTabMapperService');
/**
 * ****************************************************************************************************
 * **************************************** PAGE CONFIGURATIONS ***************************************
 * ****************************************************************************************************
 */
/**
 * Default calc type(s).
 * Intentionally made it an array, as 'NAV' & 'NET' are used interchangeably across PDS services.
 * And, Gross is being used in avg annual too.
 */
const DEFAULT_CALC_TYPES = [CalcTypeStd.GROSS, CalcTypeStd.NAV, CalcTypeStd.NET];
// Fetch the available share class codes and map the relevant ones with their 'ytd' value.
const MONTHLY_CALENDAR_FIRST_YEAR_YTD_MAPPING = {
    I: '1.69',
    D: '1.62',
    S: '1.47',
    T: '1.47',
};
// Declare default switch button values for period ends.
const DEFAULT_SWITCH_DATA_TYPE_1_VALUES = {
    offLabel: 'Month End',
    offValue: 'monthEnd',
    onLabel: 'Quarter End',
    onValue: 'quarterEnd',
    state: 'off',
};
// Switch data to be used in three tabs - Average Annual, Monthly Calendar, Cumulative Total & Total Returns.
const SWITCH_DATA_TYPE_1 = {
    offLabel: null,
    offValue: null,
    onLabel: null,
    onValue: null,
    state: 'off',
};
// Switch data to be used in distributions tab.
const SWITCH_DATA_TYPE_2 = {
    offLabel: 'Chart',
    offValue: 'chart',
    onLabel: 'Table',
    onValue: 'table',
    state: 'off',
};
// Chart config to be used in Average Annual & Total Returns tab.
const CHART_CONFIG_AVERAGE_ANNUAL = {
    chartType: 'column',
    chartHeight: '300px',
    xAxis: {
        type: 'category',
        lineWidth: 0,
        labels: {
            useHTML: true,
            style: {
                fontFamily: 'TTCommonsProRegular',
                fontSize: '13',
                color: '#FFFFFF',
                paddingTop: '20px',
                paddingBottom: '10px',
            },
        },
    },
    yAxis: [
        {
            title: {
                text: null,
            },
            gridLineWidth: 0.3,
            gridLineDashStyle: 'Solid',
            tickInterval: 2,
            lineColor: '#BFBFBF',
            labels: {
                style: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#FFFFFF',
                },
                formatter: function () {
                    return Number(this.value).toFixed(1);
                },
            },
        },
    ],
    tooltipOptions: {
        enabled: false,
        backgroundColor: '#FFFFFF',
        padding: 8,
        borderRadius: 10,
        shadow: false,
        style: {
            fontFamily: 'TTCommonsProRegular',
            fontSize: '13px',
            color: '#212121',
        },
        formatter: function () {
            const formattedValue = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(this.y);
            return `<table><tr><td>${this.series.name}</td></tr><tr><td style="padding:0"><b>${formattedValue}</b></td></tr></table>`;
        },
        shared: false,
        useHTML: true,
    },
    legendItemMarginTop: 10,
    plotOptionsGroupPadding: 0.2,
};
// Chart config to be used in Monthly Calendar tab.
const CHART_CONFIG_MONTHLY_CALENDAR = {
    chartType: 'column',
    chartHeight: '300px',
    columnWidth: 12,
    xAxis: {
        type: 'category',
        lineWidth: 0,
        labels: {
            useHTML: true,
            style: {
                fontFamily: 'TTCommonsProRegular',
                fontSize: '13',
                color: '#FFFFFF',
                paddingTop: '20px',
                paddingBottom: '10px',
            },
        },
    },
    yAxis: [
        {
            title: {
                text: null,
            },
            gridLineWidth: 0.3,
            gridLineDashStyle: 'Solid',
            lineColor: '#BFBFBF',
            labels: {
                style: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#FFFFFF',
                },
                formatter: function () {
                    return Number(this.value).toFixed(1);
                },
            },
        },
    ],
    tooltipOptions: {
        backgroundColor: '#FFFFFF',
        padding: 8,
        borderRadius: 10,
        shadow: false,
        style: {
            fontFamily: 'TTCommonsProRegular',
            fontSize: '13px',
            color: '#212121',
        },
        headerFormat: '<table>',
        pointFormat: '<tr><td>{series.name} </td></tr>' + '<tr><td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: false,
        useHTML: true,
    },
    legendItemMarginTop: 10,
    plotOptionsGroupPadding: 0.1,
};
// Chart config to be used in Monthly Calendar tab.
const CHART_CONFIG_DISCRETE_ANNUAL = {
    chartType: 'column',
    chartHeight: '300px',
    columnWidth: 12,
    xAxis: {
        type: 'category',
        lineWidth: 0,
        labels: {
            useHTML: true,
            style: {
                fontFamily: 'TTCommonsProRegular',
                fontSize: '13',
                color: '#FFFFFF',
                paddingTop: '20px',
                paddingBottom: '10px',
            },
        },
    },
    yAxis: [
        {
            title: {
                text: null,
            },
            gridLineWidth: 0.3,
            gridLineDashStyle: 'Solid',
            lineColor: '#BFBFBF',
            labels: {
                style: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#FFFFFF',
                },
                formatter: function () {
                    return Number(this.value).toFixed(1);
                },
            },
        },
    ],
    tooltipOptions: {
        backgroundColor: '#FFFFFF',
        padding: 8,
        borderRadius: 10,
        shadow: false,
        style: {
            fontFamily: 'TTCommonsProRegular',
            fontSize: '13px',
            color: '#212121',
        },
        headerFormat: '<table>',
        pointFormat: '<tr><td>{series.name} </td></tr>' + '<tr><td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: false,
        useHTML: true,
    },
    legendItemMarginTop: 10,
    plotOptionsGroupPadding: 0.1,
};
// Chart config to be used in Cumulative Total tab.
const CHART_CONFIG_CUMULATIVE_TOTAL = {
    chartType: 'line',
    xAxis: {
        lineWidth: 0,
        labels: {
            useHTML: true,
            style: {
                fontFamily: 'TTCommonsProRegular',
                fontSize: '13',
                color: '#FFFFFF',
                paddingTop: '20px',
                paddingBottom: '10px',
            },
        },
    },
    yAxis: [
        {
            title: {
                text: null,
            },
            gridLineWidth: 0.3,
            gridLineDashStyle: 'Solid',
            lineColor: '#BFBFBF',
            labels: {
                style: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#FFFFFF',
                },
                formatter: function () {
                    return '$' + Highcharts__default.numberFormat(Math.floor(this.value), 0, '', ',');
                },
            },
        },
    ],
    tooltipOptions: {
        backgroundColor: 'transparent',
        padding: 0,
        borderColor: '#00BFB3',
        borderWidth: 0,
        borderRadius: 10,
        shadow: false,
        style: {
            fontFamily: 'TTCommonsProRegular',
            fontSize: '13px',
            color: '#212121',
        },
        headerFormat: null,
        footerFormat: null,
        formatter: function () {
            const formattedValue = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(this.y);
            return `<table style="border: 2px solid ${this.series.color}; border-radius: 10px; background-color: #ffffff; padding: 8px;">
                <tr><td>${this.series.name}: </td><td style="text-align: right;"><b>${formattedValue}</b></td>
                </tr></table>`;
        },
        shared: false,
        useHTML: true,
    },
    plotOptionsGroupPadding: 0.2,
    caveat: 'The hypothetical growth scenario of $10,000 does not reflect the deduction of brokerage commissions or taxes that investors may pay on distributions or the sale of shares. Had they been reflected hypothetical values would be lower.',
};
// Chart config to be used in Distributions tab.
const CHART_CONFIG_DISTRIBUTIONS = {
    chartType: 'line',
    chartHeight: '430px',
    xAxis: {
        type: 'category',
        lineWidth: 0,
        labels: {
            useHTML: true,
            style: {
                fontFamily: 'TTCommonsProRegular',
                fontSize: '13',
                color: '#FFFFFF',
                paddingTop: '20px',
                paddingBottom: '10px',
            },
        },
    },
    yAxis: [
        {
            title: {
                text: 'NAV',
                style: {
                    color: '#C042EA',
                    fontSize: '13px',
                    fontFamily: 'TTCommonsProRegular',
                },
            },
            minorGridLineWidth: 0.1,
            minorTickInterval: 'auto',
            minorGridLineDashStyle: 'Solid',
            minorGridLineColor: 'rgba(191, 191, 191, 0.2)',
            gridLineWidth: 0.3,
            gridLineDashStyle: 'Solid',
            lineColor: '#BFBFBF',
            labels: {
                style: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#C042EA',
                },
                formatter: function () {
                    return '$' + Highcharts__default.numberFormat(this.value, 2, '.', ',');
                },
            },
        },
        {
            opposite: true,
            title: {
                text: 'Total Distribution Per Share',
                align: 'low',
                rotation: 90,
                offset: 70,
                y: -140,
                x: 0,
                style: {
                    color: '#00BFB3',
                    fontSize: '13px',
                    fontFamily: 'TTCommonsProRegular',
                },
            },
            gridLineWidth: 0,
            labels: {
                style: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#00BFB3',
                },
                formatter: function () {
                    return '$' + Highcharts__default.numberFormat(this.value, 3, '.', ',');
                },
            },
        },
    ],
    tooltipOptions: {
        backgroundColor: '#FFFFFF',
        padding: 8,
        borderColor: '#00BFB3',
        borderWidth: 2,
        borderRadius: 10,
        shadow: false,
        style: {
            fontFamily: 'TTCommonsProRegular',
            fontSize: '13px',
            color: '#212121',
        },
        headerFormat: null,
        pointFormat: '<b>{point.name}</b><table style="color:{series.color};"><tr><td>{series.name}: </td><td style="text-align: right;"><b>${point.y}</b></td></tr></table>',
        footerFormat: null,
        shared: true,
        useHTML: true,
    },
    plotOptionsGroupPadding: 0.2,
};
class PerfTabMapperService {
    constructor(productSnapshotService, storageService) {
        this.productSnapshotService = productSnapshotService;
        this.storageService = storageService;
        this.unsubscribe$ = new Subject();
        this.perfTabTitle = {
            averageAnnual: {},
            monthlyCalendar: {},
            cumulative: {},
            distributions: {},
            riskMeasures: {},
            totalReturns: {},
        };
        this.perfTabData$ = new Subject();
        // Don't let this default values get changed on duplicate assignments or reference updates.
        Object.freeze(DEFAULT_SWITCH_DATA_TYPE_1_VALUES);
    }
    /**
     * ****************************************************************************************************
     * ********************************** STATE SUBSCRIPTION & DATA FETCH *********************************
     * ****************************************************************************************************
     */
    /**
     * Return performance tab data as observable.
     */
    getPerfTabData$() {
        return this.perfTabData$.asObservable();
    }
    /**
     * Map the raw products response into the expected tab type and finally publish it.
     * @param tabName the current tab name for which mapping has to be fetched
     * @param fundId the current fundId for which mapping has to be fetched
     * @param shareClassCode the current fundId for which mapping has to be fetched
     * @param brConfig tab configuration as a JSON from BR
     */
    populate(tabName, fundId, shareClassCode, brConfig) {
        // First of all, override declared configurations from BR, if present any.
        this.overrideConfig(fundId, tabName, brConfig);
        const dataKey = fundId + '_' + shareClassCode + '_tabs';
        let tabData;
        // Check session storage for tab data values
        if (this.storageService.getData(dataKey)) {
            logger$1.debug('rxjs: loaded from storage');
            tabData = this.storageService.getData(dataKey);
            this.formatTabData(fundId, tabName, tabData);
        }
        else {
            forkJoin([
                this.productSnapshotService.getProductOverview$().pipe(takeUntil(this.unsubscribe$), take(1)),
                this.productSnapshotService.getDistributionHistory$().pipe(takeUntil(this.unsubscribe$), take(1)),
                this.productSnapshotService.getCharts$().pipe(takeUntil(this.unsubscribe$), take(1)),
            ]).subscribe((tabData) => {
                logger$1.debug('rxjs: loaded from forkjoin');
                this.storageService.setData(dataKey, tabData);
                this.formatTabData(fundId, tabName, tabData);
            });
        }
    }
    /**
     * Override any class level declared configuration by BR one before processing further.
     * @param fundId the current fundId for which mapping is fetched
     * @param tabName the current tab name for which mapping is fetched
     * @param brConfig tab configuration as a JSON from BR
     */
    overrideConfig(fundId, tabName, brConfig) {
        var _a, _b, _c;
        // Check if perf tab title exists, if yes, save it.
        // Else, will use default hardcoded text later accordingly.
        if (((_b = (_a = brConfig === null || brConfig === void 0 ? void 0 : brConfig.tabTitle) === null || _a === void 0 ? void 0 : _a[tabName]) === null || _b === void 0 ? void 0 : _b[fundId]) && !this.perfTabTitle[tabName][fundId]) {
            this.perfTabTitle[tabName][fundId] = brConfig.tabTitle[tabName][fundId];
        }
        // Override switch "value/label" & 'order' for "period end" toggle.
        // But, first check if period end(s) exist.
        if ((_c = brConfig === null || brConfig === void 0 ? void 0 : brConfig.periodEnds) === null || _c === void 0 ? void 0 : _c.length) {
            brConfig.periodEnds.forEach((periodEnd, index) => {
                let switchValue;
                let switchLabel;
                // For each period end, assign the correct corresponding 'label'.
                if (isValidValue(periodEnd) && periodEnd === 'monthEnd') {
                    switchValue = 'monthEnd';
                    switchLabel = 'Month End'; // TODO: Ideally this should come from label resource bundle.
                }
                else if (isValidValue(periodEnd) && periodEnd === 'quarterEnd') {
                    switchValue = 'quarterEnd';
                    switchLabel = 'Quarter End';
                }
                // Now, assign the 'label' as per the 'order'.
                if (index === 0 && switchValue && switchLabel) {
                    SWITCH_DATA_TYPE_1.offValue = switchValue;
                    SWITCH_DATA_TYPE_1.offLabel = switchLabel;
                }
                else {
                    SWITCH_DATA_TYPE_1.onValue = switchValue;
                    SWITCH_DATA_TYPE_1.onLabel = switchLabel;
                }
            });
        }
        else {
            // Assign default values, if no br config found.
            SWITCH_DATA_TYPE_1.offLabel = DEFAULT_SWITCH_DATA_TYPE_1_VALUES.offLabel;
            SWITCH_DATA_TYPE_1.offValue = DEFAULT_SWITCH_DATA_TYPE_1_VALUES.offValue;
            SWITCH_DATA_TYPE_1.onLabel = DEFAULT_SWITCH_DATA_TYPE_1_VALUES.onLabel;
            SWITCH_DATA_TYPE_1.onValue = DEFAULT_SWITCH_DATA_TYPE_1_VALUES.onValue;
        }
    }
    /**
     * Format the tab details as required for particular component to view.
     * @param fundId the current fundId
     * @param tabName the current tab name
     * @param tabData the complete metadata for the particular tab
     */
    formatTabData(fundId, tabName, tabData) {
        var _a;
        switch (tabName) {
            case 'averageAnnual':
                this.prepareAverageAnnualTabData(fundId, tabName, tabData[0]);
                break;
            case 'monthlyCalendar':
                this.prepareMonthlyCalendarTabData(tabData[0], tabData[2]);
                break;
            case 'cumulative':
                this.prepareCumulativeTotalTabData(fundId, tabName, tabData[0], tabData[2]);
                break;
            case 'distributions':
                this.prepareDistributionsTabData(fundId, tabName, tabData[0], tabData[1]);
                break;
            case 'riskMeasures':
                const currentShareClassData = (_a = tabData[0]) === null || _a === void 0 ? void 0 : _a.shareClasses[0];
                this.prepareRiskMeasuresTabData(fundId, tabName, currentShareClassData === null || currentShareClassData === void 0 ? void 0 : currentShareClassData.shareClassName, currentShareClassData === null || currentShareClassData === void 0 ? void 0 : currentShareClassData.riskStatsSummary);
                break;
            case 'totalReturns':
                this.prepareTotalReturnsTabData(fundId, tabName, tabData[0]);
                break;
            case 'discreteAnnualPerformance':
                this.prepareDiscreteAnnualPerformanceTabData(tabData[0], tabData[2]);
                break;
        }
    }
    /**
     * ****************************************************************************************************
     * ******************************* TAB-1 # AVERAGE ANNUAL IMPLEMENTATION ******************************
     * ****************************************************************************************************
     */
    /**
     * Map the PDS product data into feasible tab data format for average annual.
     * @param fundId the current fundId
     * @param tabName the current tab name
     * @param product product data from PDS
     */
    prepareAverageAnnualTabData(fundId, tabName, product) {
        var _a, _b, _c;
        const currentShareClass = (_a = product.shareClasses) === null || _a === void 0 ? void 0 : _a[0];
        // Step 1: Proceed further when have valid share class object.
        if (currentShareClass) {
            // Step 2.1: Filter out perf data based upon default calc types defined above.
            const monthEndPerfData = currentShareClass.performance.monthEnd.filter((monthEndPerf) => DEFAULT_CALC_TYPES.includes(monthEndPerf.calcNameStd));
            const quarterEndPerfData = currentShareClass.performance.quarterEnd.filter((quarterEndPerf) => DEFAULT_CALC_TYPES.includes(quarterEndPerf.calcNameStd));
            // Step 2.2: Sort bm perf data based upon their 'label' post filtering through default calc types.
            const bmMonthEndPerfData = currentShareClass.benchmarkPerformance.monthEnd
                .filter((bmMonthEndPerf) => DEFAULT_CALC_TYPES.includes(bmMonthEndPerf.calcNameStd))
                .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
            const bmQuarterEndPerfData = currentShareClass.benchmarkPerformance.quarterEnd
                .filter((bmQuarterEndPerf) => DEFAULT_CALC_TYPES.includes(bmQuarterEndPerf.calcNameStd))
                .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
            const categories = [];
            const colors = [];
            let performanceMetadata;
            // Step 3: Based upon fund loaded, prepare perf meta data along with categories & colors (if any).
            //         Categories are x-axis values for charts and/or column headers values for tables.
            //         Colors are defined specifically for any particular fund, to be used in plots & legends.
            switch (product.fundId) {
                case '92083': {
                    categories.push(...['YTD', '1YR', '3YR', 'Since Inception']);
                    performanceMetadata = this.getAvgAnnualCPPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData);
                    break;
                }
                case '18120': {
                    categories.push(...['1YR', '3YR', '5YR', '10YR', 'Since Inception']);
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getAvgAnnualK2PerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData);
                    break;
                }
                case '18896': {
                    categories.push(...['1YR', '3YR', '5YR', '10YR', 'Since Inception']);
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getAvgAnnualK2PerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData);
                    break;
                }
                case '31293': {
                    categories.push(...['1YR', '3YR', '5YR', '10YR', 'Since Inception']);
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getAvgAnnualK2PerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData);
                    break;
                }
                case '31292': {
                    categories.push(...['1YR', '3YR', '5YR', '10YR', 'Since Inception']);
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getAvgAnnualK2PerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData);
                    break;
                }
                case 'COFDASCORE': {
                    categories.push(...['3-mo*', '6-mo*', '1-Yr', 'Since Inception']);
                    performanceMetadata = this.getAvgAnnualCoreSMAPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData);
                    break;
                }
                case 'COFDASCORECAP': {
                    categories.push(...['3-mo*', '6-mo*', '1-Yr', 'Since Inception']);
                    performanceMetadata = this.getAvgAnnualCoreCappedSMAPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData);
                    break;
                }
                case 'COFDASDYNAMIC': {
                    categories.push(...['3-mo*', '6-mo*', '1-Yr', 'Since Inception']);
                    performanceMetadata = this.getAvgAnnualCoreCappedSMAPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData);
                    break;
                }
                case '90022': {
                    categories.push(...['1 Year', 'Since Inception']);
                    performanceMetadata = this.getAvgAnnualBSPPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData);
                    break;
                }
            }
            // Step 4: Finally, prepare the tab data required for avg annual to load.
            this.perfTabData$.next({
                fundName: product.fundName,
                class: currentShareClass.shareClassName,
                title: ((_c = (_b = this.perfTabTitle) === null || _b === void 0 ? void 0 : _b[tabName]) === null || _c === void 0 ? void 0 : _c[fundId]) || 'Average Annual Total Returns',
                switchdata: SWITCH_DATA_TYPE_1,
                categories: categories,
                chartConfig: Object.assign({ colors: colors.length ? colors : undefined }, CHART_CONFIG_AVERAGE_ANNUAL),
                performanceMetadata,
            });
        }
    }
    /**
     * Prepare performance metadata for average annual tab for CP fund.
     * @param currentShareClass currently loaded fund's share class
     * @param monthEndPerfData month end performance data against default calc type
     * @param quarterEndPerfData quarter end performance data against default calc type
     */
    getAvgAnnualCPPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData) {
        var _a, _b;
        return {
            monthEnd: {
                asOfDate: `As of ${(_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(monthEndPerfDataObj.averageAnnualYearToDateReturn),
                                Number(monthEndPerfDataObj.averageAnnual1YearReturn),
                                Number(monthEndPerfDataObj.averageAnnual3YearReturn),
                                Number(monthEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${(_b = quarterEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(quarterEndPerfDataObj.averageAnnualYearToDateReturn),
                                Number(quarterEndPerfDataObj.averageAnnual1YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnual3YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                ],
            },
        };
    }
    /**
     * Prepare performance metadata for average annual tab for BSP fund.
     * @param currentShareClass currently loaded fund's share class
     * @param monthEndPerfData month end performance data against default calc type
     * @param quarterEndPerfData quarter end performance data against default calc type
     * @param bmMonthEndPerfData month end benchmark performance data against default calc type and sort order
     * @param bmQuarterEndPerfData quarter end benchmark performance data against default calc type and sort order
     */
    getAvgAnnualBSPPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData) {
        return {
            monthEnd: {
                asOfDate: `As of ${monthEndPerfData[0].performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(monthEndPerfDataObj.averageAnnual1YearReturn),
                                Number(monthEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                    ...bmMonthEndPerfData.map((bmMonthEndPerfDataObj) => {
                        return {
                            class: `${bmMonthEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnual1YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${quarterEndPerfData[0].performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(quarterEndPerfDataObj.averageAnnual1YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                    ...bmQuarterEndPerfData.map((bmQuarterEndPerfData) => {
                        return {
                            class: `${bmQuarterEndPerfData.benchmarkName} (%)`,
                            data: [
                                Number(bmQuarterEndPerfData.benchmarkAverageAnnual1YearReturn),
                                Number(bmQuarterEndPerfData.benchmarkAverageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                ],
            },
        };
    }
    /**
     * Prepare performance metadata for average annual tab for K2 fund.
     * @param currentShareClass currently loaded fund's share class
     * @param monthEndPerfData month end performance data against default calc type
     * @param quarterEndPerfData quarter end performance data against default calc type
     * @param bmMonthEndPerfData month end benchmark performance data against default calc type and sort order
     * @param bmQuarterEndPerfData quarter end benchmark performance data against default calc type and sort order
     */
    getAvgAnnualK2PerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData) {
        return {
            monthEnd: {
                asOfDate: `As of ${monthEndPerfData[0].performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(monthEndPerfDataObj.averageAnnual1YearReturn),
                                Number(monthEndPerfDataObj.averageAnnual3YearReturn),
                                Number(monthEndPerfDataObj.averageAnnual5YearReturn),
                                Number(monthEndPerfDataObj.averageAnnual10YearReturn),
                                Number(monthEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                            footnote: '6',
                        };
                    }),
                    ...bmMonthEndPerfData.map((bmMonthEndPerfDataObj) => {
                        return {
                            class: `${bmMonthEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnual1YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnual3YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnual5YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnual10YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnualSinceInceptionReturn),
                            ],
                            footnote: bmMonthEndPerfDataObj.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${quarterEndPerfData[0].performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(quarterEndPerfDataObj.averageAnnual1YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnual3YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnual5YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnual10YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                            footnote: '6',
                        };
                    }),
                    ...bmQuarterEndPerfData.map((bmQuarterEndPerfData) => {
                        return {
                            class: `${bmQuarterEndPerfData.benchmarkName} (%)`,
                            data: [
                                Number(bmQuarterEndPerfData.benchmarkAverageAnnual1YearReturn),
                                Number(bmQuarterEndPerfData.benchmarkAverageAnnual3YearReturn),
                                Number(bmQuarterEndPerfData.benchmarkAverageAnnual5YearReturn),
                                Number(bmQuarterEndPerfData.benchmarkAverageAnnual10YearReturn),
                                Number(bmQuarterEndPerfData.benchmarkAverageAnnualSinceInceptionReturn),
                            ],
                            footnote: bmQuarterEndPerfData.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
        };
    }
    /**
     * Prepare performance metadata for average annual tab for Core SMA fund.
     * @param currentShareClass currently loaded fund's share class
     * @param monthEndPerfData month end performance data against default calc type
     * @param quarterEndPerfData quarter end performance data against default calc type
     */
    getAvgAnnualCoreSMAPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData) {
        var _a, _b;
        return {
            monthEnd: {
                asOfDate: `As of ${(_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...monthEndPerfData
                        // 'Gross' to be placed at first row.
                        .sort((curr, next) => (curr.calcNameStd === CalcTypeStd.GROSS ? -1 : 1))
                        .map((monthEndPerfDataObj) => {
                        return {
                            class: monthEndPerfDataObj.calcNameStd === CalcTypeStd.GROSS
                                ? 'Gross of Fees (USD)'
                                : monthEndPerfDataObj.calcNameStd === CalcTypeStd.NET
                                    ? 'Net of Fees (USD)'
                                    : monthEndPerfDataObj.calcNameStd,
                            data: [
                                `${monthEndPerfDataObj.cumulative3MonthReturn}%`,
                                `${monthEndPerfDataObj.cumulative6MonthReturn}%`,
                                `${monthEndPerfDataObj.averageAnnual1YearReturn}%`,
                                `${monthEndPerfDataObj.averageAnnualSinceInceptionReturn}%`,
                            ],
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${(_b = quarterEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...quarterEndPerfData
                        // 'Gross' to be placed at first row.
                        .sort((curr, next) => (curr.calcNameStd === CalcTypeStd.GROSS ? -1 : 1))
                        .map((quarterEndPerfDataObj) => {
                        return {
                            class: quarterEndPerfDataObj.calcNameStd === CalcTypeStd.GROSS
                                ? 'Gross of Fees (USD)'
                                : quarterEndPerfDataObj.calcNameStd === CalcTypeStd.NET
                                    ? 'Net of Fees (USD)'
                                    : quarterEndPerfDataObj.calcNameStd,
                            data: [
                                `${quarterEndPerfDataObj.cumulative3MonthReturn}%`,
                                `${quarterEndPerfDataObj.cumulative6MonthReturn}%`,
                                `${quarterEndPerfDataObj.averageAnnual1YearReturn}%`,
                                `${quarterEndPerfDataObj.averageAnnualSinceInceptionReturn}%`,
                            ],
                        };
                    }),
                ],
            },
        };
    }
    /**
     * Prepare performance metadata for average annual tab for Core Capped SMA fund.
     * @param currentShareClass currently loaded fund's share class
     * @param monthEndPerfData month end performance data against default calc type
     * @param quarterEndPerfData quarter end performance data against default calc type
     */
    getAvgAnnualCoreCappedSMAPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData) {
        var _a, _b;
        return {
            monthEnd: {
                asOfDate: `As of ${(_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...monthEndPerfData
                        // 'Gross' to be placed at first row.
                        .sort((curr, next) => (curr.calcNameStd === CalcTypeStd.GROSS ? -1 : 1))
                        .map((monthEndPerfDataObj) => {
                        return {
                            class: monthEndPerfDataObj.calcNameStd === CalcTypeStd.GROSS
                                ? 'Gross of Fees (USD)'
                                : monthEndPerfDataObj.calcNameStd === CalcTypeStd.NET
                                    ? 'Net of Fees (USD)'
                                    : monthEndPerfDataObj.calcNameStd,
                            data: [
                                `${monthEndPerfDataObj.cumulative3MonthReturn}%`,
                                `${monthEndPerfDataObj.cumulative6MonthReturn}%`,
                                `${monthEndPerfDataObj.averageAnnual1YearReturn}%`,
                                `${monthEndPerfDataObj.averageAnnualSinceInceptionReturn}%`,
                            ],
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${(_b = quarterEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...quarterEndPerfData
                        // 'Gross' to be placed at first row.
                        .sort((curr, next) => (curr.calcNameStd === CalcTypeStd.GROSS ? -1 : 1))
                        .map((quarterEndPerfDataObj) => {
                        return {
                            class: quarterEndPerfDataObj.calcNameStd === CalcTypeStd.GROSS
                                ? 'Gross of Fees (USD)'
                                : quarterEndPerfDataObj.calcNameStd === CalcTypeStd.NET
                                    ? 'Net of Fees (USD)'
                                    : quarterEndPerfDataObj.calcNameStd,
                            data: [
                                `${quarterEndPerfDataObj.cumulative3MonthReturn}%`,
                                `${quarterEndPerfDataObj.cumulative6MonthReturn}%`,
                                `${quarterEndPerfDataObj.averageAnnual1YearReturn}%`,
                                `${quarterEndPerfDataObj.averageAnnualSinceInceptionReturn}%`,
                            ],
                        };
                    }),
                ],
            },
        };
    }
    /**
     * ****************************************************************************************************
     * ****************************** TAB-2 # MONTHLY CALENDAR IMPLEMENTATION *****************************
     * ****************************************************************************************************
     */
    /**
     * Map the PDS product & charts data into feasible tab data format for monthly calendar.
     * @param product product data from PDS
     * @param charts timeline charts data from PDS
     */
    prepareMonthlyCalendarTabData(product, charts) {
        var _a, _b, _c, _d, _e, _f, _g;
        const currentShareClass = (_a = product.shareClasses) === null || _a === void 0 ? void 0 : _a[0];
        const fund10kCumulativeChartMonthlyRecords = (_d = (_c = (_b = charts === null || charts === void 0 ? void 0 : charts.cumulativePerformanceHistory) === null || _b === void 0 ? void 0 : _b._10k) === null || _c === void 0 ? void 0 : _c.sinceInception) === null || _d === void 0 ? void 0 : _d.fund;
        const fund10kCumulativeChartQuarterlyRecords = (_g = (_f = (_e = charts === null || charts === void 0 ? void 0 : charts.cumulativePerformanceHistory) === null || _e === void 0 ? void 0 : _e._10k) === null || _f === void 0 ? void 0 : _f.sinceInception) === null || _g === void 0 ? void 0 : _g.fundQuarterly;
        // Step 1: Proceed further when have valid share class object & cumulative historical records.
        if (currentShareClass && (fund10kCumulativeChartMonthlyRecords === null || fund10kCumulativeChartMonthlyRecords === void 0 ? void 0 : fund10kCumulativeChartMonthlyRecords.length)) {
            const categories = [];
            const colors = [];
            let performanceMetadata;
            // Step 2: Based upon fund loaded, prepare perf meta data along with categories & colors (if any).
            //         Categories are x-axis values for charts and/or column headers values for tables.
            //         Colors are defined specifically for any particular fund, to be used in plots & legends.
            switch (product.fundId) {
                case '92083': {
                    // Mapping is used to compare month name with their numeric representation in historical records.
                    const monthCountMapping = {
                        Jan: '01',
                        Feb: '02',
                        Mar: '03',
                        Apr: '04',
                        May: '05',
                        Jun: '06',
                        Jul: '07',
                        Aug: '08',
                        Sep: '09',
                        Oct: '10',
                        Nov: '11',
                        Dec: '12',
                        YTD: '00',
                    };
                    categories.push(...Object.keys(monthCountMapping));
                    performanceMetadata = this.getMonthlyCalendarCPPerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords, monthCountMapping, categories);
                    break;
                }
                case '18120': {
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getMonthlyCalendarK2PerfMetadata(currentShareClass, categories);
                    break;
                }
                case '18896': {
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getMonthlyCalendarK2PerfMetadata(currentShareClass, categories);
                    break;
                }
                case '31293': {
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getMonthlyCalendarK2PerfMetadata(currentShareClass, categories);
                    break;
                }
                case '31292': {
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getMonthlyCalendarK2PerfMetadata(currentShareClass, categories);
                    break;
                }
            }
            // Step 3: Finally, prepare the tab data required for monthly calendar to load.
            this.perfTabData$.next({
                class: currentShareClass.shareClassName,
                switchdata: SWITCH_DATA_TYPE_1,
                categories: categories,
                chartConfig: Object.assign({ colors: colors.length ? colors : undefined }, CHART_CONFIG_MONTHLY_CALENDAR),
                performanceMetadata,
            });
        }
    }
    /**
     * Prepare performance metadata for monthly calendar tab for CP fund.
     * @param currentShareClass currently loaded fund's share class
     * @param fund10kCumulativeChartMonthlyRecords cumulative performance historical monthly data from PDS
     * @param fund10kCumulativeChartQuarterlyRecords cumulative performance historical quarterly data from PDS
     * @param monthCountMapping month mapping with numeric order
     * @param categories x-axis data for chart or column header data for table
     */
    getMonthlyCalendarCPPerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords, monthCountMapping, categories) {
        var _a, _b;
        // Step 1: Filter out monthly perf data based upon default calc types defined above.
        const monthEndPerfData = currentShareClass.performance.monthEnd.filter((monthEndPerf) => DEFAULT_CALC_TYPES.includes(monthEndPerf.calcNameStd));
        const quarterEndPerfData = currentShareClass.performance.quarterEnd.filter((quarterEndPerf) => DEFAULT_CALC_TYPES.includes(quarterEndPerf.calcNameStd));
        // Step 2: Extract unique year list from cumulative historical records.
        //         And, sort them in descending order.
        const availableYearsMonthly = sortedUniq(fund10kCumulativeChartMonthlyRecords.map((cumulativeMonthlyRecord) => { var _a; return Number((_a = cumulativeMonthlyRecord === null || cumulativeMonthlyRecord === void 0 ? void 0 : cumulativeMonthlyRecord.asOfDateStd) === null || _a === void 0 ? void 0 : _a.split('-')[0]); })).sort((curr, next) => next - curr);
        const availableYearsQuarterly = sortedUniq(fund10kCumulativeChartQuarterlyRecords.map((cumulativeQuarterlyRecord) => { var _a; return Number((_a = cumulativeQuarterlyRecord === null || cumulativeQuarterlyRecord === void 0 ? void 0 : cumulativeQuarterlyRecord.asOfDateStd) === null || _a === void 0 ? void 0 : _a.split('-')[0]); })).sort((curr, next) => next - curr);
        const sortedPerfMetaDataMonthEnd = [];
        const sortedPerfMetaDataQuarterEnd = [];
        // Step 3: Iterate through every year and map values for ytd and monthly returns.
        availableYearsMonthly.forEach((year, yearIndex) => {
            var _a, _b, _c, _d;
            const monthlyPerfRecords = [];
            let currentYearYTDReturn;
            // *****************************************************************************************************
            // *********** DCE-1598: LAST YEAR YTD COLUMN HAS TRICKY LOGIC, HENCE MADE IT IN AN ALGO WAY ***********
            // *****************************************************************************************************
            // For first row.
            if (yearIndex === 0) {
                // Its always cumulative ytd return.
                currentYearYTDReturn = (_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.cumulativeYearToDateReturn;
            }
            // For last row.
            else if (yearIndex === availableYearsMonthly.length - 1) {
                // DCE-1550: Hardcode YTD value for first year perf.
                currentYearYTDReturn = MONTHLY_CALENDAR_FIRST_YEAR_YTD_MAPPING[currentShareClass.shareClassCode];
            }
            // For any other middle row(s).
            else {
                // Now, if the record is a last year 'dec' data, i.e., its a month of 'Jan' for "current year".
                if (dayjs((_b = monthEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.performanceAsOfDateStd).month() === 11) {
                    // Its calendar year one more than actual count, as data is still not updated for current year.
                    currentYearYTDReturn = (_c = monthEndPerfData[0]) === null || _c === void 0 ? void 0 : _c[`calendarYear${yearIndex + 1}YearReturn`];
                }
                // Else, its ">= feb" for "current year" and updated record for current year is available [ASSUMPTION].
                else {
                    // Its calendar year as an actual count, as last year data is not available as one year return.
                    currentYearYTDReturn = (_d = monthEndPerfData[0]) === null || _d === void 0 ? void 0 : _d[`calendarYear${yearIndex}YearReturn`];
                }
            }
            categories.forEach((month) => {
                var _a;
                monthlyPerfRecords.push(month === 'YTD'
                    ? currentYearYTDReturn
                    : (_a = fund10kCumulativeChartMonthlyRecords.find((cumulativeMonthlyRecord) => cumulativeMonthlyRecord.asOfDateStd.includes(`${year}-${monthCountMapping[month]}`))) === null || _a === void 0 ? void 0 : _a.cumulativeMonthlyReturnActualStd);
            });
            sortedPerfMetaDataMonthEnd.push(monthlyPerfRecords);
        });
        availableYearsQuarterly.forEach((year, yearIndex) => {
            var _a, _b, _c, _d;
            const quarterlyPerfRecords = [];
            let currentYearYTDReturn;
            // *****************************************************************************************************
            // *********** DCE-1598: LAST YEAR YTD COLUMN HAS TRICKY LOGIC, HENCE MADE IT IN AN ALGO WAY ***********
            // *****************************************************************************************************
            // For first row.
            if (yearIndex === 0) {
                // Its always cumulative ytd return.
                currentYearYTDReturn = (_a = quarterEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.cumulativeYearToDateReturn;
            }
            // For last row.
            else if (yearIndex === availableYearsQuarterly.length - 1) {
                // DCE-1550: Hardcode YTD value for first year perf.
                currentYearYTDReturn = MONTHLY_CALENDAR_FIRST_YEAR_YTD_MAPPING[currentShareClass.shareClassCode];
            }
            // For any other middle row(s).
            else {
                // Now, if the record is last year 'dec' data, i.e., its still not in 2nd quarter of the current year.
                //      i.e., month is between "jan-mar" of a current year.
                if (dayjs((_b = quarterEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.performanceAsOfDateStd).month() === 11) {
                    // Its calendar year one more than actual count, as data is still not updated for current year.
                    currentYearYTDReturn = (_c = quarterEndPerfData[0]) === null || _c === void 0 ? void 0 : _c[`calendarYear${yearIndex + 1}YearReturn`];
                }
                // Else, its at least the 2nd quarter for current year & the data is now available [ASSUMPTION].
                else {
                    // Its calendar year as an actual count, as last year data is not available as one year return.
                    currentYearYTDReturn = (_d = quarterEndPerfData[0]) === null || _d === void 0 ? void 0 : _d[`calendarYear${yearIndex}YearReturn`];
                }
            }
            categories.forEach((month) => {
                var _a;
                quarterlyPerfRecords.push(month === 'YTD'
                    ? currentYearYTDReturn
                    : (_a = fund10kCumulativeChartQuarterlyRecords.find((cumulativeQuarterlyRecord) => cumulativeQuarterlyRecord.asOfDateStd.includes(`${year}-${monthCountMapping[month]}`))) === null || _a === void 0 ? void 0 : _a.cumulativeMonthlyReturnActualStd);
            });
            sortedPerfMetaDataQuarterEnd.push(quarterlyPerfRecords);
        });
        // Step 4: Finally, prepare the perf meta data for month and quarter end accordingly.
        return {
            monthEnd: {
                asOfDate: `As of ${(_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDate}`,
                tableData: sortedPerfMetaDataMonthEnd.map((perfMetaData, yearIndex) => {
                    return {
                        year: String(availableYearsMonthly[yearIndex]),
                        data: perfMetaData,
                    };
                }),
            },
            quarterEnd: {
                asOfDate: `As of ${(_b = quarterEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.performanceAsOfDate}`,
                tableData: sortedPerfMetaDataQuarterEnd.map((perfMetaData, yearIndex) => {
                    return {
                        year: String(availableYearsQuarterly[yearIndex]),
                        data: perfMetaData,
                    };
                }),
            },
        };
    }
    /**
     * Prepare performance metadata for monthly calendar tab for K2 fund.
     * @param currentShareClass currently loaded fund's share class
     * @param categories x-axis data for chart or column header data for table
     */
    getMonthlyCalendarK2PerfMetadata(currentShareClass, categories) {
        var _a, _b, _c, _d;
        // Step 1.1: Sort perf data based upon their available calc types.
        const monthEndPerfData = currentShareClass.performance.monthEnd.sort((curr, next) => next.calcNameStd.localeCompare(curr.calcNameStd));
        const quarterEndPerfData = currentShareClass.performance.quarterEnd.sort((curr, next) => next.calcNameStd.localeCompare(curr.calcNameStd));
        // Step 1.2: Sort bm perf data based upon their 'label' post filtering through default calc type.
        //           [Ref. Alts Prod Site] Here we need only 'NET'/'NAV' calc type for bm data.
        const bmMonthEndPerfData = currentShareClass.benchmarkPerformance.monthEnd
            .filter((bmMonthEndPerf) => bmMonthEndPerf.calcNameStd === CalcTypeStd.NET)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        const bmQuarterEndPerfData = currentShareClass.benchmarkPerformance.quarterEnd
            .filter((bmQuarterEndPerf) => bmQuarterEndPerf.calcNameStd === CalcTypeStd.NET)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        // Step 2.1: Retrieve the current year value as per the data present in PDS feed.
        const currentYear = Number((_b = (_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDateStd) === null || _b === void 0 ? void 0 : _b.split('-')[0]);
        // Step 2.2: Prepare category data for charts x-axis & table column header.
        //           Referring US .com site, ytd + 10 calendar data for 2024.
        //           While, alts current (old 2023) data ytd + have 9 calendar data.
        //           Hence, going for full set of data as per .com.
        new Array(11).fill(0).forEach((val, index) => {
            if (index === 0) {
                categories.push('YTD'); // First plot will be YTD, having cumulative ytd data for current year.
            }
            else {
                categories.push(String(currentYear - index)); // Rest plots will be respective calendar years.
            }
        });
        // Step 3: Finally, prepare the perf meta data for month and quarter end accordingly.
        return {
            monthEnd: {
                asOfDate: `As of ${(_c = monthEndPerfData[0]) === null || _c === void 0 ? void 0 : _c.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                tableData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        const rowHeader = monthEndPerfDataObj.calcNameStd === CalcTypeStd.POP
                            ? `${currentShareClass.shareClassName} - With Sales Charge (POP) (%)`
                            : `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`;
                        return {
                            name: rowHeader,
                            data: [
                                Number(monthEndPerfDataObj.cumulativeYearToDateReturn),
                                Number(monthEndPerfDataObj.calendarYear1YearReturn),
                                Number(monthEndPerfDataObj.calendarYear2YearReturn),
                                Number(monthEndPerfDataObj.calendarYear3YearReturn),
                                Number(monthEndPerfDataObj.calendarYear4YearReturn),
                                Number(monthEndPerfDataObj.calendarYear5YearReturn),
                                Number(monthEndPerfDataObj.calendarYear6YearReturn),
                                Number(monthEndPerfDataObj.calendarYear7YearReturn),
                                Number(monthEndPerfDataObj.calendarYear8YearReturn),
                                Number(monthEndPerfDataObj.calendarYear9YearReturn),
                                Number(monthEndPerfDataObj.calendarYear10YearReturn),
                            ],
                            inceptionDate: currentShareClass.performanceInceptionDate,
                            footnote: monthEndPerfDataObj.calcNameStd === CalcTypeStd.POP ? '5' : '6',
                        };
                    }),
                    ...bmMonthEndPerfData.map((bmMonthEndPerfDataObj) => {
                        return {
                            name: `${bmMonthEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                Number(bmMonthEndPerfDataObj.benchmarkCumulativeYearToDateReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear1YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear2YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear3YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear4YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear5YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear6YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear7YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear8YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear9YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCalendarYear10YearReturn),
                            ],
                            footnote: bmMonthEndPerfDataObj.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${(_d = quarterEndPerfData[0]) === null || _d === void 0 ? void 0 : _d.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                tableData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        const rowHeader = quarterEndPerfDataObj.calcNameStd === CalcTypeStd.POP
                            ? `${currentShareClass.shareClassName} - With Sales Charge (POP) (%)`
                            : `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`;
                        return {
                            name: rowHeader,
                            data: [
                                Number(quarterEndPerfDataObj.cumulativeYearToDateReturn),
                                Number(quarterEndPerfDataObj.calendarYear1YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear2YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear3YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear4YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear5YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear6YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear7YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear8YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear9YearReturn),
                                Number(quarterEndPerfDataObj.calendarYear10YearReturn),
                            ],
                            inceptionDate: currentShareClass.performanceInceptionDate,
                            footnote: quarterEndPerfDataObj.calcNameStd === CalcTypeStd.POP ? '5' : '6',
                        };
                    }),
                    ...bmQuarterEndPerfData.map((bmQuarterEndPerfDataObj) => {
                        return {
                            name: `${bmQuarterEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                Number(bmQuarterEndPerfDataObj.benchmarkCumulativeYearToDateReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear1YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear2YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear3YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear4YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear5YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear6YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear7YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear8YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear9YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCalendarYear10YearReturn),
                            ],
                            footnote: bmQuarterEndPerfDataObj.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
        };
    }
    /**
     * ****************************************************************************************************
     * ****************************** TAB-3 # CUMULATIVE TOTAL IMPLEMENTATION *****************************
     * ****************************************************************************************************
     */
    /**
     * Map the PDS product & charts data into feasible tab data format for cumulative total.
     * @param fundId the current fundId
     * @param tabName the current tab name
     * @param product product data from PDS
     * @param charts timeline charts data from PDS
     */
    prepareCumulativeTotalTabData(fundId, tabName, product, charts) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const currentShareClass = (_a = product.shareClasses) === null || _a === void 0 ? void 0 : _a[0];
        const fund10kCumulativeChartMonthlyRecords = (_d = (_c = (_b = charts === null || charts === void 0 ? void 0 : charts.cumulativePerformanceHistory) === null || _b === void 0 ? void 0 : _b._10k) === null || _c === void 0 ? void 0 : _c.sinceInception) === null || _d === void 0 ? void 0 : _d.fund;
        const fund10kCumulativeChartQuarterlyRecords = (_g = (_f = (_e = charts === null || charts === void 0 ? void 0 : charts.cumulativePerformanceHistory) === null || _e === void 0 ? void 0 : _e._10k) === null || _f === void 0 ? void 0 : _f.sinceInception) === null || _g === void 0 ? void 0 : _g.fundQuarterly;
        const bm10kCumulativeChartMonthlyRecords = (_k = (_j = (_h = charts === null || charts === void 0 ? void 0 : charts.cumulativePerformanceHistory) === null || _h === void 0 ? void 0 : _h._10k) === null || _j === void 0 ? void 0 : _j.sinceInception) === null || _k === void 0 ? void 0 : _k.benchmark;
        const bm10kCumulativeChartQuarterlyRecords = (_o = (_m = (_l = charts === null || charts === void 0 ? void 0 : charts.cumulativePerformanceHistory) === null || _l === void 0 ? void 0 : _l._10k) === null || _m === void 0 ? void 0 : _m.sinceInception) === null || _o === void 0 ? void 0 : _o.benchmarkQuarterly;
        // Step 1: Proceed further when have valid share class object & cumulative historical records.
        if (currentShareClass && (fund10kCumulativeChartMonthlyRecords === null || fund10kCumulativeChartMonthlyRecords === void 0 ? void 0 : fund10kCumulativeChartMonthlyRecords.length) && bm10kCumulativeChartMonthlyRecords) {
            const categories = [];
            const colors = [];
            let performanceMetadata;
            // Step 2: Based upon fund loaded, prepare perf meta data along with categories & colors (if any).
            //         Categories are x-axis values for charts and/or column headers values for tables.
            //         Colors are defined specifically for any particular fund, to be used in plots & legends.
            switch (product.fundId) {
                case '92083': {
                    // Prepare category data having dates from each historical record.
                    // Date format should be like - "Jan '24".
                    categories.push(...fund10kCumulativeChartMonthlyRecords.map((cumulativeMonthlyRecord) => dayjs(cumulativeMonthlyRecord.asOfDateStd).format(`MMM 'YY`)));
                    performanceMetadata = this.getCumulativeTotalCPPerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords);
                    break;
                }
                case '41056':
                case '29429': {
                    categories.push(...['YTD', '1 Month', '3 Months', '6 Months', '1 Year', '3 Years', '5 Years', '10 Years', 'Since Inception']);
                    performanceMetadata = this.getCumulativeTotalBSPPerfMetadata(currentShareClass);
                    break;
                }
                case '18120': {
                    categories.push(...['YTD', '1 Month', '3 Month', '6 Month', '1 Year', '3 Years', '5 Years', '10 Years', '15 Years', 'Since Inception']);
                    performanceMetadata = this.getCumulativeTotalK2PerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords, bm10kCumulativeChartMonthlyRecords, bm10kCumulativeChartQuarterlyRecords);
                    break;
                }
                case '18896': {
                    categories.push(...['YTD', '1 Month', '3 Month', '6 Month', '1 Year', '3 Years', '5 Years', '10 Years', '15 Years', 'Since Inception']);
                    performanceMetadata = this.getCumulativeTotalK2PerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords, bm10kCumulativeChartMonthlyRecords, bm10kCumulativeChartQuarterlyRecords);
                    break;
                }
                case '31293': {
                    categories.push(...['YTD', '1 Month', '3 Month', '6 Month', '1 Year', '3 Years', '5 Years', '10 Years', '15 Years', 'Since Inception']);
                    performanceMetadata = this.getCumulativeTotalK2PerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords, bm10kCumulativeChartMonthlyRecords, bm10kCumulativeChartQuarterlyRecords);
                    break;
                }
                case '31292': {
                    categories.push(...['YTD', '1 Month', '3 Month', '6 Month', '1 Year', '3 Years', '5 Years', '10 Years', '15 Years', 'Since Inception']);
                    performanceMetadata = this.getCumulativeTotalK2PerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords, bm10kCumulativeChartMonthlyRecords, bm10kCumulativeChartQuarterlyRecords);
                    break;
                }
                case '90022': {
                    categories.push(...['YTD', '1 Month', '3 Months', '6 Months', '1 Year', '3 Years', '5 Years', '10 Years', 'Since Inception']);
                    performanceMetadata = this.getCumulativeTotalBSPPerfMetadata(currentShareClass);
                    break;
                }
            }
            // Step 3: Finally, prepare the tab data required for cumulative total to load.
            this.perfTabData$.next({
                class: currentShareClass.shareClassName,
                title: ((_q = (_p = this.perfTabTitle) === null || _p === void 0 ? void 0 : _p[tabName]) === null || _q === void 0 ? void 0 : _q[fundId]) || 'Cumulative Total Returns',
                switchdata: SWITCH_DATA_TYPE_1,
                categories: categories,
                chartConfig: Object.assign({ colors: colors.length ? colors : undefined }, CHART_CONFIG_CUMULATIVE_TOTAL),
                performanceMetadata,
            });
        }
    }
    /**
     * Prepare performance metadata for cumulative total tab for CP fund.
     * @param currentShareClass currently loaded fund's share class
     * @param fund10kCumulativeChartMonthlyRecords cumulative performance historical monthly data from PDS
     * @param fund10kCumulativeChartQuarterlyRecords cumulative performance historical quarterly data from PDS
     */
    getCumulativeTotalCPPerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords) {
        return {
            monthEnd: {
                asOfDate: `As of ${fund10kCumulativeChartMonthlyRecords[fund10kCumulativeChartMonthlyRecords.length - 1].asOfDate}`,
                chartData: [
                    {
                        class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) ($)`,
                        data: fund10kCumulativeChartMonthlyRecords.map((cumulativeMonthlyRecord) => Number(cumulativeMonthlyRecord.cumulativeMonthlyReturnCalculatedStd)),
                    },
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${fund10kCumulativeChartQuarterlyRecords[fund10kCumulativeChartQuarterlyRecords.length - 1].asOfDate}`,
                chartData: [
                    {
                        class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) ($)`,
                        data: fund10kCumulativeChartQuarterlyRecords.map((cumulativeQuarterlyRecord) => Number(cumulativeQuarterlyRecord.cumulativeMonthlyReturnCalculatedStd)),
                    },
                ],
            },
        };
    }
    /**
     * Prepare performance metadata for cumulative total tab for BSP fund.
     * @param currentShareClass currently loaded fund's share class
     */
    getCumulativeTotalBSPPerfMetadata(currentShareClass) {
        var _a, _b;
        // Step 1.1: Filter perf data based upon default calc type - NET/NAV.
        const monthEndPerfData = currentShareClass.performance.monthEnd.filter((monthEndPerf) => monthEndPerf.calcNameStd === CalcTypeStd.NET || monthEndPerf.calcNameStd === CalcTypeStd.NAV);
        const quarterEndPerfData = currentShareClass.performance.quarterEnd.filter((quarterEndPerf) => quarterEndPerf.calcNameStd === CalcTypeStd.NET || quarterEndPerf.calcNameStd === CalcTypeStd.NAV);
        // Step 1.2: Sort bm perf data based upon their 'label' post filtering through default calc type.
        //           [Ref. Alts Prod Site] Here we need only 'NET'/'NAV' calc type for bm data.
        const bmMonthEndPerfData = currentShareClass.benchmarkPerformance.monthEnd
            .filter((bmMonthEndPerf) => bmMonthEndPerf.calcNameStd === CalcTypeStd.NET || bmMonthEndPerf.calcNameStd === CalcTypeStd.NAV)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        const bmQuarterEndPerfData = currentShareClass.benchmarkPerformance.quarterEnd
            .filter((bmQuarterEndPerf) => bmQuarterEndPerf.calcNameStd === CalcTypeStd.NET || bmQuarterEndPerf.calcNameStd === CalcTypeStd.NAV)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        // Step 2: Finally, prepare the perf meta data for month and quarter end accordingly.
        return {
            monthEnd: {
                asOfDate: `As of ${(_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                tableData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        return {
                            name: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                monthEndPerfDataObj.cumulativeYearToDateReturn,
                                monthEndPerfDataObj.cumulative1MonthReturn,
                                monthEndPerfDataObj.cumulative3MonthReturn,
                                monthEndPerfDataObj.cumulative6MonthReturn,
                                monthEndPerfDataObj.cumulative1YearReturn,
                                monthEndPerfDataObj.cumulative3YearReturn,
                                monthEndPerfDataObj.cumulative5YearReturn,
                                monthEndPerfDataObj.cumulative10YearReturn,
                                monthEndPerfDataObj.cumulativeSinceInceptionReturn,
                            ],
                        };
                    }),
                    ...bmMonthEndPerfData.map((bmMonthEndPerfDataObj) => {
                        var _a, _b, _c;
                        return {
                            name: `${bmMonthEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                bmMonthEndPerfDataObj.benchmarkCumulativeYearToDateReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative1MonthReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative3MonthReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative6MonthReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative1YearReturn,
                                // DCE-1550: Made 3/5/10 yr BM data visible only if corresponding fund data is also visible.
                                isValidValue((_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.cumulative3YearReturn)
                                    ? bmMonthEndPerfDataObj.benchmarkCumulative3YearReturn
                                    : undefined,
                                isValidValue((_b = monthEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.cumulative5YearReturn)
                                    ? bmMonthEndPerfDataObj.benchmarkCumulative5YearReturn
                                    : undefined,
                                isValidValue((_c = monthEndPerfData[0]) === null || _c === void 0 ? void 0 : _c.cumulative10YearReturn)
                                    ? bmMonthEndPerfDataObj.benchmarkCumulative10YearReturn
                                    : undefined,
                                bmMonthEndPerfDataObj.benchmarkCumulativeSinceInceptionReturn,
                            ],
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${(_b = quarterEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                tableData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        return {
                            name: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                quarterEndPerfDataObj.cumulativeYearToDateReturn,
                                quarterEndPerfDataObj.cumulative1MonthReturn,
                                quarterEndPerfDataObj.cumulative3MonthReturn,
                                quarterEndPerfDataObj.cumulative6MonthReturn,
                                quarterEndPerfDataObj.cumulative1YearReturn,
                                quarterEndPerfDataObj.cumulative3YearReturn,
                                quarterEndPerfDataObj.cumulative5YearReturn,
                                quarterEndPerfDataObj.cumulative10YearReturn,
                                quarterEndPerfDataObj.cumulativeSinceInceptionReturn,
                            ],
                        };
                    }),
                    ...bmQuarterEndPerfData.map((bmQuarterEndPerfDataObj) => {
                        var _a, _b, _c;
                        return {
                            name: `${bmQuarterEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                bmQuarterEndPerfDataObj.benchmarkCumulativeYearToDateReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative1MonthReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative3MonthReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative6MonthReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative1YearReturn,
                                // DCE-1550: Made 3/5/10 yr BM data visible only if corresponding fund data is also visible.
                                isValidValue((_a = quarterEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.cumulative3YearReturn)
                                    ? bmQuarterEndPerfDataObj.benchmarkCumulative3YearReturn
                                    : undefined,
                                isValidValue((_b = quarterEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.cumulative5YearReturn)
                                    ? bmQuarterEndPerfDataObj.benchmarkCumulative5YearReturn
                                    : undefined,
                                isValidValue((_c = quarterEndPerfData[0]) === null || _c === void 0 ? void 0 : _c.cumulative10YearReturn)
                                    ? bmQuarterEndPerfDataObj.benchmarkCumulative10YearReturn
                                    : undefined,
                                bmQuarterEndPerfDataObj.benchmarkCumulativeSinceInceptionReturn,
                            ],
                        };
                    }),
                ],
            },
        };
    }
    /**
     * Prepare performance metadata for cumulative total tab for K2 fund.
     * @param currentShareClass currently loaded fund's share class
     * @param fund10kCumulativeChartMonthlyRecords cumulative performance historical fund monthly data from PDS
     * @param fund10kCumulativeChartQuarterlyRecords cumulative performance historical fund quarterly data from PDS
     * @param bm10kCumulativeChartMonthlyRecords cumulative performance historical bm monthly data from PDS
     * @param bm10kCumulativeChartQuarterlyRecords cumulative performance historical bm quarterly data from PDS
     */
    getCumulativeTotalK2PerfMetadata(currentShareClass, fund10kCumulativeChartMonthlyRecords, fund10kCumulativeChartQuarterlyRecords, bm10kCumulativeChartMonthlyRecords, bm10kCumulativeChartQuarterlyRecords) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        // Step 1.1: Sort perf data based upon their available calc types.
        const monthEndPerfData = currentShareClass.performance.monthEnd.sort((curr, next) => next.calcNameStd.localeCompare(curr.calcNameStd));
        const quarterEndPerfData = currentShareClass.performance.quarterEnd.sort((curr, next) => next.calcNameStd.localeCompare(curr.calcNameStd));
        // Step 1.2: Sort bm perf data based upon their 'label' post filtering through default calc type.
        //           [Ref. Alts Prod Site] Here we need only 'NET'/'NAV' calc type for bm data.
        const bmMonthEndPerfData = currentShareClass.benchmarkPerformance.monthEnd
            .filter((bmMonthEndPerf) => bmMonthEndPerf.calcNameStd === CalcTypeStd.NET)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        const bmQuarterEndPerfData = currentShareClass.benchmarkPerformance.quarterEnd
            .filter((bmQuarterEndPerf) => bmQuarterEndPerf.calcNameStd === CalcTypeStd.NET)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        return {
            monthEnd: {
                asOfDate: `As of ${(_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    {
                        class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) ($)`,
                        data: fund10kCumulativeChartMonthlyRecords.map((cumulativeMonthlyRecord) => {
                            return {
                                date: dayjs(cumulativeMonthlyRecord.asOfDateStd).format('DD/MM/YYYY'),
                                value: cumulativeMonthlyRecord.cumulativeMonthlyReturnCalculatedStd,
                            };
                        }),
                    },
                    {
                        class: `${(_b = bmMonthEndPerfData[0]) === null || _b === void 0 ? void 0 : _b.benchmarkName} (%)`,
                        data: (_c = bm10kCumulativeChartMonthlyRecords.primary) === null || _c === void 0 ? void 0 : _c.map((bmCumulativeMonthlyRecord) => {
                            return {
                                date: dayjs(bmCumulativeMonthlyRecord.asOfDateStd).format('DD/MM/YYYY'),
                                value: bmCumulativeMonthlyRecord.cumulativeMonthlyReturnCalculatedStd,
                            };
                        }),
                    },
                    {
                        class: `${(_d = bmMonthEndPerfData[1]) === null || _d === void 0 ? void 0 : _d.benchmarkName} (%)`,
                        data: (_e = bm10kCumulativeChartMonthlyRecords.secondary) === null || _e === void 0 ? void 0 : _e.map((bmCumulativeMonthlyRecord) => {
                            return {
                                date: dayjs(bmCumulativeMonthlyRecord.asOfDateStd).format('DD/MM/YYYY'),
                                value: bmCumulativeMonthlyRecord.cumulativeMonthlyReturnCalculatedStd,
                            };
                        }),
                    },
                ],
                tableData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        return {
                            name: `${currentShareClass.shareClassName} - Without Sales Charge (${monthEndPerfDataObj.calcNameStd === CalcTypeStd.NET ? CalcTypeStd.NAV : CalcTypeStd.POP}) (%)`,
                            data: [
                                monthEndPerfDataObj.cumulativeYearToDateReturn,
                                monthEndPerfDataObj.cumulative1MonthReturn,
                                monthEndPerfDataObj.cumulative3MonthReturn,
                                monthEndPerfDataObj.cumulative6MonthReturn,
                                monthEndPerfDataObj.cumulative1YearReturn,
                                monthEndPerfDataObj.cumulative3YearReturn,
                                monthEndPerfDataObj.cumulative5YearReturn,
                                monthEndPerfDataObj.cumulative10YearReturn,
                                monthEndPerfDataObj.cumulative15YearReturn,
                                monthEndPerfDataObj.cumulativeSinceInceptionReturn,
                            ],
                            footnote: monthEndPerfDataObj.calcNameStd === CalcTypeStd.POP ? '5' : '6',
                        };
                    }),
                    ...bmMonthEndPerfData.map((bmMonthEndPerfDataObj) => {
                        return {
                            name: `${bmMonthEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                bmMonthEndPerfDataObj.benchmarkCumulativeYearToDateReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative1MonthReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative3MonthReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative6MonthReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative1YearReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative3YearReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative5YearReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative10YearReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulative15YearReturn,
                                bmMonthEndPerfDataObj.benchmarkCumulativeSinceInceptionReturn,
                            ],
                            footnote: bmMonthEndPerfDataObj.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${(_f = quarterEndPerfData[0]) === null || _f === void 0 ? void 0 : _f.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    {
                        class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV}) ($)`,
                        data: fund10kCumulativeChartQuarterlyRecords.map((cumulativeMonthlyRecord) => {
                            return {
                                date: dayjs(cumulativeMonthlyRecord.asOfDateStd).format('DD/MM/YYYY'),
                                value: cumulativeMonthlyRecord.cumulativeMonthlyReturnCalculatedStd,
                            };
                        }),
                    },
                    {
                        class: `${(_g = bmMonthEndPerfData[0]) === null || _g === void 0 ? void 0 : _g.benchmarkName} (%)`,
                        data: (_h = bm10kCumulativeChartQuarterlyRecords.primary) === null || _h === void 0 ? void 0 : _h.map((bmCumulativeMonthlyRecord) => {
                            return {
                                date: dayjs(bmCumulativeMonthlyRecord.asOfDateStd).format('DD/MM/YYYY'),
                                value: bmCumulativeMonthlyRecord.cumulativeMonthlyReturnCalculatedStd,
                            };
                        }),
                    },
                    {
                        class: `${(_j = bmMonthEndPerfData[1]) === null || _j === void 0 ? void 0 : _j.benchmarkName} (%)`,
                        data: (_k = bm10kCumulativeChartQuarterlyRecords.secondary) === null || _k === void 0 ? void 0 : _k.map((bmCumulativeMonthlyRecord) => {
                            return {
                                date: dayjs(bmCumulativeMonthlyRecord.asOfDateStd).format('DD/MM/YYYY'),
                                value: bmCumulativeMonthlyRecord.cumulativeMonthlyReturnCalculatedStd,
                            };
                        }),
                    },
                ],
                tableData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        return {
                            name: `${currentShareClass.shareClassName} - Without Sales Charge (${quarterEndPerfDataObj.calcNameStd === CalcTypeStd.NET ? CalcTypeStd.NAV : CalcTypeStd.POP}) (%)`,
                            data: [
                                quarterEndPerfDataObj.cumulativeYearToDateReturn,
                                quarterEndPerfDataObj.cumulative1MonthReturn,
                                quarterEndPerfDataObj.cumulative3MonthReturn,
                                quarterEndPerfDataObj.cumulative6MonthReturn,
                                quarterEndPerfDataObj.cumulative1YearReturn,
                                quarterEndPerfDataObj.cumulative3YearReturn,
                                quarterEndPerfDataObj.cumulative5YearReturn,
                                quarterEndPerfDataObj.cumulative10YearReturn,
                                quarterEndPerfDataObj.cumulative15YearReturn,
                                quarterEndPerfDataObj.cumulativeSinceInceptionReturn,
                            ],
                            footnote: quarterEndPerfDataObj.calcNameStd === CalcTypeStd.POP ? '5' : '6',
                        };
                    }),
                    ...bmQuarterEndPerfData.map((bmQuarterEndPerfDataObj) => {
                        return {
                            name: `${bmQuarterEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                bmQuarterEndPerfDataObj.benchmarkCumulativeYearToDateReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative1MonthReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative3MonthReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative6MonthReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative1YearReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative3YearReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative5YearReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative10YearReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulative15YearReturn,
                                bmQuarterEndPerfDataObj.benchmarkCumulativeSinceInceptionReturn,
                            ],
                            footnote: bmQuarterEndPerfDataObj.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
        };
    }
    /**
     * ****************************************************************************************************
     * ******************************** TAB-4 # DISTRIBUTIONS IMPLEMENTATION ******************************
     * ****************************************************************************************************
     */
    /**
     * Map the PDS product & distribution data into feasible tab data format for distributions.
     * @param fundId the current fundId
     * @param tabName the current tab name
     * @param product product data from PDS
     * @param distributionHistories distribution history data from PDS
     */
    prepareDistributionsTabData(fundId, tabName, product, distributionHistories) {
        var _a, _b, _c, _d, _e, _f;
        // Step 1: Declare categories (to be table columns) fundId wise - 92083 (CP) [if condition] & 29429 (BSP) [else condition]
        const categories = product.fundId === '92083'
            ? [
                'Record Date',
                'Ex-Dividend Date',
                'Reinvestment Date',
                'Payable Date',
                'Reinvestment Price',
                'Income',
                'Return to Capital',
                'Total Distribution Per Share',
            ]
            : [
                'Record Date',
                'Ex-Dividend Date',
                'Reinvestment Date',
                'Payable Date',
                'Reinvestment Price',
                'Long-Term Capital Gains',
                'Short-Term Capital Gains',
                'Income',
                'Total Distribution Per Share',
            ];
        // Step 2: Extract unique years from historical data and sort them in descending order.
        const availableYears = sortedUniq(distributionHistories.map((distributionHistory) => { var _a; return Number((_a = distributionHistory.asOfDateStd) === null || _a === void 0 ? void 0 : _a.split('-')[0]); }))
            .sort((curr, next) => next - curr)
            .map((year) => String(year));
        // Step 3: Fetch disclosures fundId wise.
        //         TODO: Fetch it from labels/caveats dynamically once configured in BR.
        const disclosure = product.fundId === '92083'
            ? 'Clarion Partners Real Estate Income Fund (the Fund) paid out quarterly dividends since inception, September 2019 until March 2020. From April 2020 onwards the Fund has paid a monthly dividend.'
            : '';
        // Step 4: Prepare distribution tab data and map fields accordingly.
        this.perfTabData$.next({
            title: ((_b = (_a = this.perfTabTitle) === null || _a === void 0 ? void 0 : _a[tabName]) === null || _b === void 0 ? void 0 : _b[fundId]) || 'Distributions Per Share',
            switchdata: SWITCH_DATA_TYPE_2,
            categories: categories,
            years: [...availableYears, 'Since Inception'],
            chartConfig: CHART_CONFIG_DISTRIBUTIONS,
            disclosure: disclosure,
            fundName: product.fundName,
            shareClassName: (_c = product === null || product === void 0 ? void 0 : product.shareClasses[0]) === null || _c === void 0 ? void 0 : _c.shareClassName,
            performanceInceptionDate: (_d = product === null || product === void 0 ? void 0 : product.shareClasses[0]) === null || _d === void 0 ? void 0 : _d.performanceInceptionDate,
            shareClassCurrency: (_e = product === null || product === void 0 ? void 0 : product.shareClasses[0]) === null || _e === void 0 ? void 0 : _e.shareClassCurrency,
            performanceMetadata: {
                monthEnd: {
                    asOfDate: `As of ${(_f = distributionHistories[0]) === null || _f === void 0 ? void 0 : _f.asOfDate}`,
                    // Step 4.1: Iterate throught the year list.
                    tableData: availableYears.map((year) => {
                        return {
                            year: year,
                            data: distributionHistories
                                // Step 4.2: Filter out the historical records as per current year in iteration.
                                .filter((distributionHistory) => { var _a; return ((_a = distributionHistory.asOfDateStd) === null || _a === void 0 ? void 0 : _a.split('-')[0]) === year; })
                                // Step 4.3: Map the required table columns fundId wise.
                                .map((distributionHistory) => {
                                const tableData = product.fundId === '92083'
                                    ? {
                                        recordDate: distributionHistory.incomeDistributionRecordDate,
                                        exDividendDate: distributionHistory.incomeDistributionExDividendDate,
                                        reinvestmentDate: distributionHistory.reinvestmentDate,
                                        payableDate: distributionHistory.incomeDistributionExPayableDate,
                                        reinvestmentPrice: distributionHistory.reinvestmentAmount,
                                        income: distributionHistory.incomeDistributionAmount,
                                        returnCapital: distributionHistory.returnOfCapitalAmount,
                                        totalDistribution: distributionHistory.totalDistributionAmountMonthly,
                                    }
                                    : {
                                        recordDate: distributionHistory.incomeDistributionRecordDate,
                                        exDividendDate: distributionHistory.incomeDistributionExDividendDate,
                                        reinvestmentDate: distributionHistory.reinvestmentDate,
                                        payableDate: distributionHistory.incomeDistributionExPayableDate,
                                        reinvestmentPrice: distributionHistory.reinvestmentAmount,
                                        // For BSP, display long/short cap gains & remove return capital column.
                                        longTermCapitalGains: distributionHistory.longTermCapitalGainAmount,
                                        shortTermCapitalGains: distributionHistory.shortTermCapitalGainAmount,
                                        income: distributionHistory.incomeDistributionAmount,
                                        totalDistribution: distributionHistory.totalDistributionAmountMonthly,
                                    };
                                return tableData;
                            }),
                        };
                    }),
                },
            },
        });
    }
    /**
     * ****************************************************************************************************
     * ******************************** TAB-5 # RISK MEASURES IMPLEMENTATION ******************************
     * ****************************************************************************************************
     */
    /**
     * Map the PDS risk stats summary data into feasible tab data format for risk measures.
     * @param fundId the current fundId
     * @param tabName the current tab name
     * @param shareClassName share class name of current fund
     * @param riskStatsSummaries risk stats summary data from PDS
     */
    prepareRiskMeasuresTabData(fundId, tabName, shareClassName, riskStatsSummaries) {
        var _a, _b, _c;
        // Intentionally made a "deep copy" of original collection.
        // Since, here we'll have to extract and pop out the filtered object from its list.
        const availableRiskStatsSummaries = cloneDeep(riskStatsSummaries);
        this.perfTabData$.next({
            title: ((_b = (_a = this.perfTabTitle) === null || _a === void 0 ? void 0 : _a[tabName]) === null || _b === void 0 ? void 0 : _b[fundId]) || 'Risk Measures',
            riskMeasuresMetadata: {
                asOfDate: (_c = riskStatsSummaries === null || riskStatsSummaries === void 0 ? void 0 : riskStatsSummaries[0]) === null || _c === void 0 ? void 0 : _c.asOfDate,
                subtitle: 'Measured against: S&P 500 Index',
                disclosure: '',
                standardDeviation: this.getStdDevRMMapping(shareClassName, availableRiskStatsSummaries),
                sharpeRatio: this.getSharpeRatioRMMapping(shareClassName, availableRiskStatsSummaries),
                statistics: this.getStatisticsRMMapping(availableRiskStatsSummaries),
            },
        });
    }
    /**
     * Return the table data mapping for risk measures "standard deviation" table.
     * @param shareClassName share class name of current fund
     * @param availableRiskStatsSummaries currently available risk stats summaries as a list
     */
    getStdDevRMMapping(shareClassName, availableRiskStatsSummaries) {
        const rowData = [];
        // Step 1.1: Extract std dev fund stat.
        const stdDevFundStatIndex = availableRiskStatsSummaries.findIndex((riskStat) => riskStat.elementNameStd === 'STANDARD_DEVIATION_FUND');
        // Step 1.2: Check if it exist and extract the available data.
        if (stdDevFundStatIndex !== -1) {
            const stat = availableRiskStatsSummaries[stdDevFundStatIndex];
            rowData.push({
                rowName: `${shareClassName} - Without Sales Charge (NAV)`,
                columnValues: [stat.element3YearValue, stat.element5YearValue, stat.element10YearValue],
            });
            // Step 1.3: Delete the above filtered stat from available list.
            availableRiskStatsSummaries.splice(stdDevFundStatIndex, 1);
        }
        // Step 2.1: Extract std dev BM stat.
        const stdDevBMStatIndex = availableRiskStatsSummaries.findIndex((riskStat) => riskStat.elementNameStd === 'STANDARD_DEVIATION_BM');
        // Step 2.2: Check if it exist and extract the available data.
        if (stdDevBMStatIndex !== -1) {
            const stat = availableRiskStatsSummaries[stdDevBMStatIndex];
            rowData.push({
                rowName: stat.benchmarkName,
                columnValues: [stat.element3YearValue, stat.element5YearValue, stat.element10YearValue],
                rowNamefootnote: '8',
            });
            // Step 1.3: Delete the above filtered stat from available list.
            availableRiskStatsSummaries.splice(stdDevBMStatIndex, 1);
        }
        // Step 3: Map the required std dev table fields and return it.
        return {
            tableName: 'Standard Deviation (%)',
            tableNameTooltip: `A measure of the degree to which an investment product's return varies from the average of its previous returns. The larger the standard deviation, the greater the likelihood (and risk) that a product's performance will fluctuate from the average return.`,
            categories: ['3 Years', '5 Years', '10 Years'],
            body: rowData,
        };
    }
    /**
     * Return the table data mapping for risk measures "sharpe ratio" table.
     * @param shareClassName share class name of current fund
     * @param availableRiskStatsSummaries currently available risk stats summaries as a list
     */
    getSharpeRatioRMMapping(shareClassName, availableRiskStatsSummaries) {
        const rowData = [];
        // Step 1.1: Extract sharpe ratio fund stat.
        const sharpeRatioFundStatIndex = availableRiskStatsSummaries.findIndex((riskStat) => riskStat.elementNameStd === 'SHARPE_RATIO_FUND');
        // Step 1.2: Check if it exist and extract the available data.
        if (sharpeRatioFundStatIndex !== -1) {
            const stat = availableRiskStatsSummaries[sharpeRatioFundStatIndex];
            rowData.push({
                rowName: `${shareClassName} - Without Sales Charge (NAV)`,
                columnValues: [stat.element3YearValue, stat.element5YearValue, stat.element10YearValue],
            });
            // Step 1.3: Delete the above filtered stat from available list.
            availableRiskStatsSummaries.splice(sharpeRatioFundStatIndex, 1);
        }
        // Step 3: Map the required sharpe ratio table fields and return it.
        return {
            tableName: 'Sharpe Ratio (%)',
            tableNameTooltip: `A measure of risk-adjusted return. To calculate a Sharpe ratio, an investment product's excess returns (its return in excess of the return generated by risk-free assets such as Treasury bills) are divided by the its standard deviation.`,
            categories: ['3 Years', '5 Years', '10 Years'],
            body: rowData,
        };
    }
    /**
     * Return the table data mapping for risk measures "statistics" table.
     * @param availableRiskStatsSummaries currently available risk stats summaries as a list
     */
    getStatisticsRMMapping(availableRiskStatsSummaries) {
        // TODO: Remove below tooltips once configured & fetched from BR (most probably as a label).
        const tooltips = {
            ALPHA: `The annualized percentage difference between a portfolio's actual returns and its expected performance given its level of market risk, as measured by beta.`,
            BETA: `A measure of an investment product's volatility relative to the market, as represented by the stated market index. A beta greater than 1.0 indicates volatility greater than the market.`,
            BETA_BEAR: `A measure that explains the extent to which the portfolio’s excess returns (portfolio return – risk free rate return) moves relative to the benchmark’s excess return (benchmark return – risk Free rate return) in down markets (when the benchmark returns are negative).`,
            BB_CAP_RATIO: `The ratio of bull (or \"up\") market participation to bear (or \"down\") market participation. A ratio of greater than one means that the portfolio had relatively better participation in up markets than in down markets.`,
            BETA_BULL: `A measure that explains the extent to which the portfolio’s excess returns (portfolio return – risk free ratereturn) moves relative to the benchmark’s excess return (benchmark return – risk free rate return) in up markets (when the benchmark returns are positive).`,
            'R-SQUARED': `A measure of how much of a portfolio's performance can be explained by the returns from the overall market (or a benchmark index). If a portfolio's total return precisely matched that of the overall market or benchmark, its R-squared would be 1.0. If a portfolio's return bore no relationship to the market's returns, its R-squared would be 0.`,
        };
        return {
            tableName: 'Statistics',
            categories: ['3 Years', '5 Years', '10 Years'],
            body: availableRiskStatsSummaries
                // Sort the remaining stats as per their display order.
                .sort((curr, next) => Number(curr.displayOrder) - Number(next.displayOrder))
                // Iterate, map & return the required fields.
                .map((stat) => {
                return {
                    rowName: stat.elementName,
                    rowNameTooltip: tooltips[stat.elementNameStd],
                    columnValues: [stat.element3YearValue, stat.element5YearValue, stat.element10YearValue],
                };
            }),
        };
    }
    /**
     * ****************************************************************************************************
     * ******************************* TAB-6 # TOTAL RETURNS IMPLEMENTATION *******************************
     * ****************************************************************************************************
     */
    /**
     * Map the PDS product data into feasible tab data format for total returns.
     * @param fundId the current fundId
     * @param tabName the current tab name
     * @param product product data from PDS
     */
    prepareTotalReturnsTabData(fundId, tabName, product) {
        var _a, _b, _c;
        const currentShareClass = (_a = product.shareClasses) === null || _a === void 0 ? void 0 : _a[0];
        // Step 1: Proceed further when have valid share class object.
        if (currentShareClass) {
            // Step 2.1: Filter out perf data based upon default calc types defined above.
            const monthEndPerfData = currentShareClass.performance.monthEnd.filter((monthEndPerf) => DEFAULT_CALC_TYPES.includes(monthEndPerf.calcNameStd));
            const quarterEndPerfData = currentShareClass.performance.quarterEnd.filter((quarterEndPerf) => DEFAULT_CALC_TYPES.includes(quarterEndPerf.calcNameStd));
            // Step 2.2: Sort bm perf data based upon their 'label' post filtering through default calc types.
            const bmMonthEndPerfData = currentShareClass.benchmarkPerformance.monthEnd
                .filter((bmMonthEndPerf) => DEFAULT_CALC_TYPES.includes(bmMonthEndPerf.calcNameStd))
                .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
            const bmQuarterEndPerfData = currentShareClass.benchmarkPerformance.quarterEnd
                .filter((bmQuarterEndPerf) => DEFAULT_CALC_TYPES.includes(bmQuarterEndPerf.calcNameStd))
                .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
            const categories = [];
            const colors = [];
            let performanceMetadata;
            // Step 3: Based upon fund loaded, prepare perf meta data along with categories & colors (if any).
            //         Categories are x-axis values for charts and/or column headers values for tables.
            //         Colors are defined specifically for any particular fund, to be used in plots & legends.
            switch (product.fundId) {
                case '41056':
                case '29429': {
                    categories.push(...['YTD*', '3 Months*', '6 Months*', '1 Year', 'Since Inception']);
                    // For now, total returns tab exists for only BSP tab & implementation is same as of avg annual.
                    performanceMetadata = this.getTotalReturnsBSPPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData);
                    break;
                }
            }
            // Step 4: Finally, prepare the tab data required for avg annual to load.
            this.perfTabData$.next({
                fundName: product.fundName,
                class: currentShareClass.shareClassName,
                title: ((_c = (_b = this.perfTabTitle) === null || _b === void 0 ? void 0 : _b[tabName]) === null || _c === void 0 ? void 0 : _c[fundId]) || 'Total Returns',
                switchdata: SWITCH_DATA_TYPE_1,
                categories: categories,
                chartConfig: Object.assign({ colors: colors.length ? colors : undefined }, CHART_CONFIG_AVERAGE_ANNUAL),
                performanceMetadata,
            });
        }
    }
    /**
     * Prepare performance metadata for total returns tab for BSP fund.
     * @param currentShareClass currently loaded fund's share class
     * @param monthEndPerfData month end performance data against default calc type
     * @param quarterEndPerfData quarter end performance data against default calc type
     * @param bmMonthEndPerfData month end benchmark performance data against default calc type and sort order
     * @param bmQuarterEndPerfData quarter end benchmark performance data against default calc type and sort order
     */
    getTotalReturnsBSPPerfMetadata(currentShareClass, monthEndPerfData, quarterEndPerfData, bmMonthEndPerfData, bmQuarterEndPerfData) {
        return {
            monthEnd: {
                asOfDate: `As of ${monthEndPerfData[0].performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(monthEndPerfDataObj.cumulativeYearToDateReturn),
                                Number(monthEndPerfDataObj.cumulative3MonthReturn),
                                Number(monthEndPerfDataObj.cumulative6MonthReturn),
                                Number(monthEndPerfDataObj.averageAnnual1YearReturn),
                                Number(monthEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                    ...bmMonthEndPerfData.map((bmMonthEndPerfDataObj) => {
                        return {
                            class: `${bmMonthEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                Number(bmMonthEndPerfDataObj.benchmarkCumulativeYearToDateReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCumulative3MonthReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkCumulative6MonthReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnual1YearReturn),
                                Number(bmMonthEndPerfDataObj.benchmarkAverageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${quarterEndPerfData[0].performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                chartData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        return {
                            class: `${currentShareClass.shareClassName} - Without Sales Charge (NAV) (%)`,
                            data: [
                                Number(quarterEndPerfDataObj.cumulativeYearToDateReturn),
                                Number(quarterEndPerfDataObj.cumulative3MonthReturn),
                                Number(quarterEndPerfDataObj.cumulative6MonthReturn),
                                Number(quarterEndPerfDataObj.averageAnnual1YearReturn),
                                Number(quarterEndPerfDataObj.averageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                    ...bmQuarterEndPerfData.map((bmQuarterEndPerfDataObj) => {
                        return {
                            class: `${bmQuarterEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                Number(bmQuarterEndPerfDataObj.benchmarkCumulativeYearToDateReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCumulative3MonthReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkCumulative6MonthReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkAverageAnnual1YearReturn),
                                Number(bmQuarterEndPerfDataObj.benchmarkAverageAnnualSinceInceptionReturn),
                            ],
                        };
                    }),
                ],
            },
        };
    }
    /**
     * Map the PDS product & charts data into feasible tab data format for monthly calendar.
     * @param product product data from PDS
     * @param charts timeline charts data from PDS
     */
    prepareDiscreteAnnualPerformanceTabData(product, charts) {
        var _a, _b, _c, _d;
        const currentShareClass = (_a = product.shareClasses) === null || _a === void 0 ? void 0 : _a[0];
        const fund10kCumulativeChartMonthlyRecords = (_d = (_c = (_b = charts === null || charts === void 0 ? void 0 : charts.cumulativePerformanceHistory) === null || _b === void 0 ? void 0 : _b._10k) === null || _c === void 0 ? void 0 : _c.sinceInception) === null || _d === void 0 ? void 0 : _d.fund;
        // Step 1: Proceed further when have valid share class object & cumulative historical records.
        if (currentShareClass && (fund10kCumulativeChartMonthlyRecords === null || fund10kCumulativeChartMonthlyRecords === void 0 ? void 0 : fund10kCumulativeChartMonthlyRecords.length)) {
            const categories = [];
            const colors = [];
            let performanceMetadata;
            // Step 2: Based upon fund loaded, prepare perf meta data along with categories & colors (if any).
            //         Categories are x-axis values for charts and/or column headers values for tables.
            //         Colors are defined specifically for any particular fund, to be used in plots & legends.
            switch (product.fundId) {
                case '18896': {
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getDiscreteAnnualPerfMetadata(currentShareClass, categories);
                    break;
                }
                case '31293': {
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getDiscreteAnnualPerfMetadata(currentShareClass, categories);
                    break;
                }
                case '31292': {
                    colors.push(...['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']);
                    performanceMetadata = this.getDiscreteAnnualPerfMetadata(currentShareClass, categories);
                    break;
                }
            }
            // Step 3: Finally, prepare the tab data required for discrete annual to load.
            this.perfTabData$.next({
                class: currentShareClass.shareClassName,
                switchdata: SWITCH_DATA_TYPE_1,
                categories: categories,
                chartConfig: Object.assign({ colors: colors.length ? colors : undefined }, CHART_CONFIG_DISCRETE_ANNUAL),
                performanceMetadata,
            });
        }
    }
    /**
     * Prepare performance metadata for monthly calendar tab for K2 fund.
     * @param currentShareClass currently loaded fund's share class
     * @param categories x-axis data for chart or column header data for table
     */
    getDiscreteAnnualPerfMetadata(currentShareClass, categories) {
        var _a, _b, _c, _d;
        // Step 1.1: Sort perf data based upon their available calc types.
        const monthEndPerfData = currentShareClass.performance.monthEnd.sort((curr, next) => next.calcNameStd.localeCompare(curr.calcNameStd));
        const quarterEndPerfData = currentShareClass.performance.quarterEnd.sort((curr, next) => next.calcNameStd.localeCompare(curr.calcNameStd));
        // Step 1.2: Sort bm perf data based upon their 'label' post filtering through default calc type.
        //           [Ref. Alts Prod Site] Here we need only 'NET'/'NAV' calc type for bm data.
        const bmMonthEndPerfData = currentShareClass.benchmarkPerformance.monthEnd
            .filter((bmMonthEndPerf) => bmMonthEndPerf.calcNameStd === CalcTypeStd.NET)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        const bmQuarterEndPerfData = currentShareClass.benchmarkPerformance.quarterEnd
            .filter((bmQuarterEndPerf) => bmQuarterEndPerf.calcNameStd === CalcTypeStd.NET)
            .sort((curr, next) => curr.benchmarkLabel.localeCompare(next.benchmarkLabel)); // Sort alphabetically based upon INST1/2
        // Step 2.1: Retrieve the current year value as per the data present in PDS feed.
        const currentYear = Number((_b = (_a = monthEndPerfData[0]) === null || _a === void 0 ? void 0 : _a.performanceAsOfDateStd) === null || _b === void 0 ? void 0 : _b.split('-')[0]);
        // Step 2.2: Prepare category data for charts x-axis & table column header.
        //           Referring US .com site, ytd + 10 calendar data for 2024.
        //           While, alts current (old 2023) data ytd + have 9 calendar data.
        //           Hence, going for full set of data as per .com.
        new Array(11).fill(0).forEach((val, index) => {
            if (index === 0) {
                categories.push('Currency'); // First plot will be YTD, having cumulative ytd data for current year.
            }
            else {
                categories.push(String(currentYear - index - 1) + '/' + String(currentYear - index)); // Rest plots will be respective calendar years.
            }
        });
        // Step 3: Finally, prepare the perf meta data for month and quarter end accordingly.
        return {
            monthEnd: {
                asOfDate: `As of ${(_c = monthEndPerfData[0]) === null || _c === void 0 ? void 0 : _c.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                tableData: [
                    ...monthEndPerfData.map((monthEndPerfDataObj) => {
                        const rowHeader = monthEndPerfDataObj.calcNameStd === CalcTypeStd.POP
                            ? `${currentShareClass.shareClassName} (%)`
                            : `${currentShareClass.shareClassName} (%)`;
                        return {
                            name: rowHeader,
                            data: [
                                currentShareClass.shareClassCurrency,
                                Number(monthEndPerfDataObj.discrannualrollyear1),
                                Number(monthEndPerfDataObj.discrannualrollyear2),
                                Number(monthEndPerfDataObj.discrannualrollyear3),
                                Number(monthEndPerfDataObj.discrannualrollyear4),
                                Number(monthEndPerfDataObj.discrannualrollyear5),
                                Number(monthEndPerfDataObj.discrannualrollyear6),
                                Number(monthEndPerfDataObj.discrannualrollyear7),
                                Number(monthEndPerfDataObj.discrannualrollyear8),
                                Number(monthEndPerfDataObj.discrannualrollyear9),
                                Number(monthEndPerfDataObj.discrannualrollyear10),
                            ],
                            inceptionDate: currentShareClass.performanceInceptionDate,
                            footnote: monthEndPerfDataObj.calcNameStd === CalcTypeStd.POP ? '5' : '6',
                        };
                    }),
                    ...bmMonthEndPerfData.map((bmMonthEndPerfDataObj) => {
                        return {
                            name: `${bmMonthEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                currentShareClass.shareClassCurrency,
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr1),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr2),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr3),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr4),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr5),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr6),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr7),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr8),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr9),
                                Number(bmMonthEndPerfDataObj.bmdiscrannualrollyr10),
                            ],
                            footnote: bmMonthEndPerfDataObj.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
            quarterEnd: {
                asOfDate: `As of ${(_d = quarterEndPerfData[0]) === null || _d === void 0 ? void 0 : _d.performanceAsOfDate}`,
                sinceInceptionDate: currentShareClass.performanceInceptionDate,
                tableData: [
                    ...quarterEndPerfData.map((quarterEndPerfDataObj) => {
                        const rowHeader = quarterEndPerfDataObj.calcNameStd === CalcTypeStd.POP
                            ? `${currentShareClass.shareClassName} (%)`
                            : `${currentShareClass.shareClassName} (%)`;
                        return {
                            name: rowHeader,
                            data: [
                                currentShareClass.shareClassCurrency,
                                Number(quarterEndPerfDataObj.discrannualrollyear1),
                                Number(quarterEndPerfDataObj.discrannualrollyear2),
                                Number(quarterEndPerfDataObj.discrannualrollyear3),
                                Number(quarterEndPerfDataObj.discrannualrollyear4),
                                Number(quarterEndPerfDataObj.discrannualrollyear5),
                                Number(quarterEndPerfDataObj.discrannualrollyear6),
                                Number(quarterEndPerfDataObj.discrannualrollyear7),
                                Number(quarterEndPerfDataObj.discrannualrollyear8),
                                Number(quarterEndPerfDataObj.discrannualrollyear9),
                                Number(quarterEndPerfDataObj.discrannualrollyear10),
                            ],
                            inceptionDate: currentShareClass.performanceInceptionDate,
                            footnote: quarterEndPerfDataObj.calcNameStd === CalcTypeStd.POP ? '5' : '6',
                        };
                    }),
                    ...bmQuarterEndPerfData.map((bmQuarterEndPerfDataObj) => {
                        return {
                            name: `${bmQuarterEndPerfDataObj.benchmarkName} (%)`,
                            data: [
                                currentShareClass.shareClassCurrency,
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr1),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr2),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr3),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr4),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr5),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr6),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr7),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr8),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr9),
                                Number(bmQuarterEndPerfDataObj.bmdiscrannualrollyr10),
                            ],
                            footnote: bmQuarterEndPerfDataObj.benchmarkLabel === 'INST2' ? '7' : undefined,
                        };
                    }),
                ],
            },
        };
    }
    ngOnDestroy() {
        this.unsubscribe$.complete();
    }
}
PerfTabMapperService.ɵfac = function PerfTabMapperService_Factory(t) { return new (t || PerfTabMapperService)(i0.ɵɵinject(i1$1.ProductSnapshotService), i0.ɵɵinject(i1.StorageService)); };
PerfTabMapperService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PerfTabMapperService, factory: PerfTabMapperService.ɵfac, providedIn: 'any' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabMapperService, [{
        type: Injectable,
        args: [{
                providedIn: 'any',
            }]
    }], function () { return [{ type: i1$1.ProductSnapshotService }, { type: i1.StorageService }]; }, null); })();

const logger = Logger.getLogger('PerfTabBaseComponent');
class PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr) {
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
        this.tabTitleFootnotes = [];
        this.chartConfig = {};
        this.tableConfig = {};
        this.subscriptions = [];
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g;
        // Read any JSON like BR config, if present.
        this.brConfig = this.extractBRConfig();
        this.isHandheld$ = this.responsiveService.isHandheld$();
        this.subscriptions.push(this.perfTabMapperService.getPerfTabData$().subscribe((tabData) => {
            // Intentionally added and done 'showChart' as 'false' & 'true' here as a hacky fix.
            // Chart DOM doesn't gets updated for new set of chart configs & data when product type is changed from banner.
            // Change detection within chart component didn't work, so, made whole component re-generated from parent.
            this.showChart = false;
            this.cdr.detectChanges();
            this.showChart = true;
            this.mapContent(tabData);
        }));
        // Read fundId and shareClass from parameters
        const pageModelConfig = (_c = (_b = (_a = this.page) === null || _a === void 0 ? void 0 : _a.getComponent()) === null || _b === void 0 ? void 0 : _b.getModels()) === null || _c === void 0 ? void 0 : _c.config;
        const productConfig = this.productConfigService.getProductConfig(this.page);
        this.fundId = (_d = pageModelConfig === null || pageModelConfig === void 0 ? void 0 : pageModelConfig.fundId) !== null && _d !== void 0 ? _d : productConfig === null || productConfig === void 0 ? void 0 : productConfig.fundId;
        this.shareClassCode = (_e = pageModelConfig === null || pageModelConfig === void 0 ? void 0 : pageModelConfig.shareClassCode) !== null && _e !== void 0 ? _e : (_g = (_f = productConfig === null || productConfig === void 0 ? void 0 : productConfig.shareClasses) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.value;
    }
    /**
     * Return the BR config for the tab as a JSON, if present. Else, return undefined.
     */
    extractBRConfig() {
        var _a;
        const document = getModelFromRef(this.page, this.component, 'document');
        let brConfig;
        if (document) {
            const stringifiedJSON = (_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json;
            try {
                brConfig = JSON.parse(stringifiedJSON);
            }
            catch (error) {
                // Since, JSON file from BR is 'optional', better to log this as a 'debug'.
                logger.debug('Unable to parse BR config json: ', error);
            }
        }
        return brConfig;
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for average annual
     */
    mapContent(tabData) {
        this.bgColor = tabData.bgColor;
        this.tabTitle = tabData.title;
        this.switchdata = tabData.switchdata;
        this.fundName = tabData.fundName;
        this.shareClass = tabData.class;
        this.categories = tabData.categories;
        this.performanceMetadata = tabData.performanceMetadata;
    }
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
PerfTabBaseComponent.ɵfac = function PerfTabBaseComponent_Factory(t) { return new (t || PerfTabBaseComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PerfTabBaseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabBaseComponent, selectors: [["ng-component"]], inputs: { component: "component", page: "page" }, decls: 0, vars: 0, template: function PerfTabBaseComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabBaseComponent, [{
        type: Component,
        args: [{
                template: '',
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

const FUND_IDS = [
    '92083',
    '29429',
    '18120',
    'COFDASCORE',
    'COFDASCORECAP',
    'COFDASDYNAMIC',
    '90022',
    '18896',
    '41056',
    '31292',
    '31293',
];
const SHARE_CLASS_CODES = [
    'I',
    'D',
    'S',
    'T',
    'Z',
    'A',
    'C',
    'R',
    'R6',
    'NA',
    'AA2',
    'RD',
    'IS',
    'Z1',
    'BC',
    'M',
    'RK1',
    'RK',
    'OA',
    'AK',
    'OA1',
    'PX7',
    'Z7',
];
const TAB_CONFIG_92083 = {
    tabs: ['averageAnnual', 'monthlyCalendar', 'cumulative', 'distributions'],
    tabData: {
        averageAnnual: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
        monthlyCalendar: {
            isChartEnabled: false,
            isTableEnabled: true,
        },
        cumulative: {
            isChartEnabled: true,
            isTableEnabled: false,
        },
    },
};
const TAB_CONFIG_29429_41056 = {
    tabs: ['totalReturns', 'cumulative', 'distributions'],
    tabData: {
        averageAnnual: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
        monthlyCalendar: {
            isChartEnabled: false,
            isTableEnabled: true,
        },
    },
};
const TAB_CONFIG_18120 = {
    tabs: ['averageAnnual', 'monthlyCalendar', 'cumulative', 'riskMeasures'],
    tabData: {
        averageAnnual: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
        monthlyCalendar: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
        cumulative: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
    },
};
const TAB_CONFIG_18896_31292_31293 = {
    tabs: ['discreteAnnualPerformance', 'averageAnnual', 'monthlyCalendar', 'cumulative', 'riskMeasures'],
    tabData: {
        averageAnnual: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
        monthlyCalendar: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
        cumulative: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
    },
};
const TAB_CONFIG_COFDASCORE_COFDASCORECAP = {
    tabs: ['averageAnnual'],
    tabData: {
        averageAnnual: {
            isChartEnabled: false,
            isTableEnabled: true,
        },
    },
};
const TAB_CONFIG_90022 = {
    tabs: ['averageAnnual', 'cumulative', 'distributions'],
    tabData: {
        averageAnnual: {
            isChartEnabled: true,
            isTableEnabled: true,
        },
        monthlyCalendar: {
            isChartEnabled: false,
            isTableEnabled: true,
        },
    },
};
const TAB_CONFIGS = {
    '92083': {
        I: TAB_CONFIG_92083,
        D: TAB_CONFIG_92083,
        S: TAB_CONFIG_92083,
        T: TAB_CONFIG_92083,
    },
    '29429': {
        Z: TAB_CONFIG_29429_41056,
        A: TAB_CONFIG_29429_41056,
    },
    '18120': {
        Z: TAB_CONFIG_18120,
        A: TAB_CONFIG_18120,
        C: TAB_CONFIG_18120,
        R: TAB_CONFIG_18120,
        R6: TAB_CONFIG_18120,
    },
    COFDASCORE: {
        NA: TAB_CONFIG_COFDASCORE_COFDASCORECAP,
    },
    COFDASCORECAP: {
        NA: TAB_CONFIG_COFDASCORE_COFDASCORECAP,
    },
    COFDASDYNAMIC: {
        NA: TAB_CONFIG_COFDASCORE_COFDASCORECAP,
    },
    '90022': {
        AA2: TAB_CONFIG_90022,
        C: TAB_CONFIG_90022,
        RD: TAB_CONFIG_90022,
        IS: TAB_CONFIG_90022,
        I: TAB_CONFIG_90022,
    },
    '18896': {
        Z: TAB_CONFIG_18896_31292_31293,
        Z1: TAB_CONFIG_18896_31292_31293,
        Z7: TAB_CONFIG_18896_31292_31293,
        BC: TAB_CONFIG_18896_31292_31293,
    },
    '31292': {
        PX7: TAB_CONFIG_18896_31292_31293,
        RK1: TAB_CONFIG_18896_31292_31293,
        RK: TAB_CONFIG_18896_31292_31293,
        OA1: TAB_CONFIG_18896_31292_31293,
        OA: TAB_CONFIG_18896_31292_31293,
        BC: TAB_CONFIG_18896_31292_31293,
    },
    '31293': {
        Z: TAB_CONFIG_18896_31292_31293,
        RK1: TAB_CONFIG_18896_31292_31293,
        RK: TAB_CONFIG_18896_31292_31293,
        OA1: TAB_CONFIG_18896_31292_31293,
        OA: TAB_CONFIG_18896_31292_31293,
        AK: TAB_CONFIG_18896_31292_31293,
    },
    '41056': {
        D: TAB_CONFIG_29429_41056,
        I: TAB_CONFIG_29429_41056,
        M: TAB_CONFIG_29429_41056,
        S: TAB_CONFIG_29429_41056,
    },
};
/**
 * Returns the performance tab configuration based upon fund ID and share class code.
 * @param fundId fund id of the selected fund
 * @param shareClassCode share class code of the selected fund
 */
const getPerfTabConfig = (fundId, shareClassCode) => {
    fundId = fundId === null || fundId === void 0 ? void 0 : fundId.toUpperCase();
    shareClassCode = shareClassCode === null || shareClassCode === void 0 ? void 0 : shareClassCode.toUpperCase();
    const searchedFundId = Object.keys(TAB_CONFIGS).find((iteratedFundId) => iteratedFundId.toUpperCase() === fundId);
    if (shareClassCode && searchedFundId) {
        const searchedShareClassCode = Object.keys(TAB_CONFIGS[searchedFundId]).find((iteratedShareClassCode) => iteratedShareClassCode.toUpperCase() === shareClassCode);
        return TAB_CONFIGS[searchedFundId][searchedShareClassCode];
    }
    return TAB_CONFIGS[searchedFundId];
};
// NOTE: Below mapping should be strictly in accordance with the mapping done in "performance module" in "ft-alts-app".
const TAB_NAME_INDEX_MAPPING = {
    averageAnnual: 1,
    monthlyCalendar: 2,
    cumulative: 3,
    distributions: 4,
    riskMeasures: 5,
    totalReturns: 6,
    discreteAnnualPerformance: 7,
};
const PERF_CONFIG = {
    FUND_IDS,
    SHARE_CLASS_CODES,
    getPerfTabConfig,
    TAB_NAME_INDEX_MAPPING,
};

function PerfChartComponent_highcharts_chart_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "highcharts-chart", 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("Highcharts", ctx_r0.highcharts)("options", ctx_r0.highchartsOptions);
} }
const _c0$a = function (a0) { return { "perf-chart__bg-color--default": a0 }; };
Accessibility(Highcharts);
// Respective colors of the series plotted.
const COLORS = ['#00BFB3', '#3769FF', '#C042EA', '#D5E4FD'];
// Fixed width of each column plotted in pixels.
const COLUMN_WIDTH = 50;
class PerfChartComponent {
    constructor(responsiveService, cdr) {
        this.responsiveService = responsiveService;
        this.cdr = cdr;
        /**
         * Optional prop to set background color of the chart.
         */
        this.bgColor = 'default';
        this.highchartsOptions = {};
    }
    ngOnInit() {
        this.subscription = this.responsiveService.isHandheld$().subscribe((isHandheld) => {
            this.isHandheld = isHandheld;
            this.highchartsOptions = this.getHighchartsOptions(); // Recalculate options with updated column width.
            this.cdr.detectChanges();
        });
        import(/* webpackChunkName: "highcharts-async" */ 'highcharts').then((highchartsModule) => {
            this.highcharts = highchartsModule;
            this.cdr.detectChanges();
        });
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.chartData.currentValue) {
            this.updatedChartData = simpleChanges.chartData.currentValue;
            this.highchartsOptions = this.getHighchartsOptions();
            this.cdr.detectChanges();
        }
    }
    /**
     * Return comprehensive set of highcharts options required for plotting.
     */
    getHighchartsOptions() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const chartOptions = {
            chart: {
                type: (_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.chartType,
                backgroundColor: null,
                height: ((_b = this.chartConfig) === null || _b === void 0 ? void 0 : _b.chartHeight) ? this.chartConfig.chartHeight : undefined,
            },
            accessibility: {
                enabled: true,
                keyboardNavigation: {
                    enabled: true,
                },
            },
            title: {
                text: null,
            },
            xAxis: (_c = this.chartConfig) === null || _c === void 0 ? void 0 : _c.xAxis,
            yAxis: (_d = this.chartConfig) === null || _d === void 0 ? void 0 : _d.yAxis,
            tooltip: (_e = this.chartConfig) === null || _e === void 0 ? void 0 : _e.tooltipOptions,
            plotOptions: {
                column: ((_f = this.chartConfig) === null || _f === void 0 ? void 0 : _f.chartType) === 'column'
                    ? {
                        borderWidth: 0,
                        pointWidth: this.isHandheld ? null : ((_g = this.chartConfig) === null || _g === void 0 ? void 0 : _g.columnWidth) ? this.chartConfig.columnWidth : COLUMN_WIDTH,
                        pointPadding: 0.2,
                        groupPadding: (_h = this.chartConfig) === null || _h === void 0 ? void 0 : _h.plotOptionsGroupPadding,
                    }
                    : {},
                line: ((_j = this.chartConfig) === null || _j === void 0 ? void 0 : _j.chartType) === 'line'
                    ? {
                        borderWidth: 0,
                        color: '#00BFB3',
                        marker: {
                            enabled: false,
                        },
                    }
                    : {},
                series: {
                    events: {
                        legendItemClick: function () {
                            return false;
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
            legend: {
                align: 'left',
                symbolWidth: 15,
                symbolHeight: 15,
                symbolRadius: 0,
                itemStyle: {
                    fontFamily: 'TTCommonsProRegular',
                    fontSize: '13',
                    color: '#FFFFFF',
                    fontWeight: '400',
                },
                itemHoverStyle: {
                    color: '#FFFFFF',
                    cursor: 'default',
                },
                itemMarginTop: ((_k = this.chartConfig) === null || _k === void 0 ? void 0 : _k.legendItemMarginTop) ? this.chartConfig.legendItemMarginTop : undefined,
            },
            series: this.getSeriesData(),
        };
        // Add x-axis categories as per the data available.
        if (chartOptions.xAxis) {
            chartOptions.xAxis.categories = (_l = this.updatedChartData) === null || _l === void 0 ? void 0 : _l.xAxis;
        }
        return chartOptions;
    }
    /**
     * Prepare and return complete series data.
     * Supports multiple plots with color (upto 'N' count available in 'COLORS' declared) and hover details.
     */
    getSeriesData() {
        var _a;
        return (_a = this.updatedChartData) === null || _a === void 0 ? void 0 : _a.yAxis.map((yAxisObj, index) => {
            var _a, _b;
            return Object.assign({ name: (_a = this.updatedChartData) === null || _a === void 0 ? void 0 : _a.name[index], data: yAxisObj.plots, color: ((_b = this.chartConfig) === null || _b === void 0 ? void 0 : _b.colors) ? this.chartConfig.colors[index] : COLORS[index] }, yAxisObj.props);
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
PerfChartComponent.ɵfac = function PerfChartComponent_Factory(t) { return new (t || PerfChartComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PerfChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfChartComponent, selectors: [["ft-alts-perf-chart"]], inputs: { bgColor: "bgColor", chartConfig: "chartConfig", chartData: "chartData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 4, consts: [[3, "ngClass"], ["class", "perf-chart__responsive", 3, "Highcharts", "options", 4, "ngIf"], [1, "perf-chart__responsive", 3, "Highcharts", "options"]], template: function PerfChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PerfChartComponent_highcharts_chart_1_Template, 1, 2, "highcharts-chart", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$a, ctx.bgColor === "default"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.chartData && ctx.highcharts);
    } }, directives: [i3.NgClass, i3.NgIf, i3$1.HighchartsChartComponent], styles: [".perf-chart__bg-color--default[_ngcontent-%COMP%]{background-color:var(--ft-charts-alts-dark-blue)}.perf-chart__responsive[_ngcontent-%COMP%]{width:100%;display:block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfChartComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-chart',
                templateUrl: './perf-chart.component.html',
                styleUrls: ['./perf-chart.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: i0.ChangeDetectorRef }]; }, { bgColor: [{
            type: Input
        }], chartConfig: [{
            type: Input
        }], chartData: [{
            type: Input
        }] }); })();

const _c0$9 = function (a0) { return { "perf-table__hide-element": a0 }; };
function PerfTableComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function PerfTableComponent_div_0_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.onSvgButtonClick(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 6);
    i0.ɵɵelementStart(2, "g", 7);
    i0.ɵɵelement(3, "circle", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "path", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$9, ctx_r1.isSvgButtonClicked));
} }
function PerfTableComponent_div_0_th_9_sup_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const headData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(headData_r6.footnote);
} }
function PerfTableComponent_div_0_th_9_ft_alts_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-icon", 14);
} if (rf & 2) {
    const headData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("tooltipType", "medium")("tooltipContent", headData_r6.tooltip)("defaultTooltipPosition", "top")("tooltipBehavior", "fixed");
} }
function PerfTableComponent_div_0_th_9_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const headData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(headData_r6.subLabel);
} }
function PerfTableComponent_div_0_th_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PerfTableComponent_div_0_th_9_sup_2_Template, 3, 1, "sup", 10);
    i0.ɵɵtemplate(3, PerfTableComponent_div_0_th_9_ft_alts_icon_3_Template, 1, 4, "ft-alts-icon", 11);
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, PerfTableComponent_div_0_th_9_span_5_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const headData_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", headData_r6.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", headData_r6.footnote);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", headData_r6.tooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", headData_r6.subLabel);
} }
function PerfTableComponent_div_0_tr_11_td_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} if (rf & 2) {
    const rowIndex_r14 = i0.ɵɵnextContext(2).index;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("background-color", ctx_r18.tableConfig.legendColors[rowIndex_r14]);
} }
function PerfTableComponent_div_0_tr_11_td_1_sup_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    const firstColumn_r17 = ctx_r22.first;
    const row_r16 = ctx_r22.$implicit;
    const rowIndex_r14 = i0.ɵɵnextContext().index;
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(firstColumn_r17 && (ctx_r19.tableConfig == null ? null : ctx_r19.tableConfig.legendColors == null ? null : ctx_r19.tableConfig.legendColors[rowIndex_r14]) ? "inline-footnote" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(row_r16.footnote);
} }
function PerfTableComponent_div_0_tr_11_td_1_ft_alts_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-icon", 21);
} if (rf & 2) {
    const row_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("tooltipType", "medium")("tooltipContent", row_r16.tooltip)("defaultTooltipPosition", "top")("tooltipBehavior", "fixed");
} }
const _c1$4 = function (a0) { return { "align-center": a0 }; };
function PerfTableComponent_div_0_tr_11_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 17);
    i0.ɵɵtemplate(1, PerfTableComponent_div_0_tr_11_td_1_span_1_Template, 1, 2, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ftAltsDashIfEmpty");
    i0.ɵɵtemplate(4, PerfTableComponent_div_0_tr_11_td_1_sup_4_Template, 3, 3, "sup", 19);
    i0.ɵɵtemplate(5, PerfTableComponent_div_0_tr_11_td_1_ft_alts_icon_5_Template, 1, 4, "ft-alts-icon", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r16 = ctx.$implicit;
    const firstColumn_r17 = ctx.first;
    const rowIndex_r14 = i0.ɵɵnextContext().index;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$4, firstColumn_r17 && (ctx_r15.tableConfig == null ? null : ctx_r15.tableConfig.legendColors == null ? null : ctx_r15.tableConfig.legendColors[rowIndex_r14])));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", firstColumn_r17 && (ctx_r15.tableConfig == null ? null : ctx_r15.tableConfig.legendColors == null ? null : ctx_r15.tableConfig.legendColors[rowIndex_r14]));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, row_r16.value), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", row_r16.footnote);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r16.tooltip);
} }
function PerfTableComponent_div_0_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, PerfTableComponent_div_0_tr_11_td_1_Template, 6, 9, "td", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const bodyData_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", bodyData_r13);
} }
const _c2$1 = function (a0, a1) { return { "perf-table__overflow--hidden": a0, "perf-table__overflow--scroll": a1 }; };
const _c3 = function (a0) { return { "perf-table__scroll-button-bg-gradient": a0 }; };
function PerfTableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, PerfTableComponent_div_0_div_3_Template, 5, 3, "div", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementStart(5, "table", 3);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "thead");
    i0.ɵɵelementStart(8, "tr");
    i0.ɵɵtemplate(9, PerfTableComponent_div_0_th_9_Template, 6, 4, "th", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "tbody");
    i0.ɵɵtemplate(11, PerfTableComponent_div_0_tr_11_Template, 2, 1, "tr", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c2$1, i0.ɵɵpipeBind1(1, 5, ctx_r0.isHandheld$) && !ctx_r0.isSvgButtonClicked, i0.ɵɵpipeBind1(2, 7, ctx_r0.isHandheld$) && ctx_r0.isSvgButtonClicked));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 9, ctx_r0.isHandheld$) && !ctx_r0.isSvgButtonClicked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c3, i0.ɵɵpipeBind1(6, 11, ctx_r0.isHandheld$) && !ctx_r0.isSvgButtonClicked));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.updatedTableData.head);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.updatedTableData.body);
} }
class PerfTableComponent {
    constructor(responsiveService, cdr, router) {
        this.responsiveService = responsiveService;
        this.cdr = cdr;
        this.router = router;
        this.isSvgButtonClicked = false;
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.tableData.currentValue) {
            this.updatedTableData = simpleChanges.tableData.currentValue;
            this.cdr.detectChanges();
        }
    }
    /**
     * Make flag 'isSvgButtonClicked' truthy when its clicked.
     */
    onSvgButtonClick() {
        this.isSvgButtonClicked = true;
    }
}
PerfTableComponent.ɵfac = function PerfTableComponent_Factory(t) { return new (t || PerfTableComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Router)); };
PerfTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTableComponent, selectors: [["ft-alts-perf-table"]], inputs: { tableData: "tableData", tableConfig: "tableConfig" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "perf-table", 3, "ngClass", 4, "ngIf"], [1, "perf-table", 3, "ngClass"], ["class", "perf-table__scroll-button-svg", 3, "ngClass", "click", 4, "ngIf"], [1, "font-small--b", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "perf-table__scroll-button-svg", 3, "ngClass", "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "76", "height", "76", "viewBox", "0 0 76 76", "fill", "none"], ["filter", "url(#filter0_d_4267_79595)"], ["cx", "38", "cy", "33", "r", "28", "fill", "white"], ["d", "M38.0002 44.6666L36.4689 43.0989L45.4741 34.0937H26.3335V31.9062H45.4741L36.4689 22.901L38.0002 21.3333L49.6668 32.9999L38.0002 44.6666Z", "fill", "#3769FF"], [4, "ngIf"], ["type", "info-white", "size", "normal", "theme", "white", "ftAltsTooltip", "", 3, "tooltipType", "tooltipContent", "defaultTooltipPosition", "tooltipBehavior", 4, "ngIf"], ["className", "font-small", 4, "ngIf"], [1, "color--ft-white"], ["type", "info-white", "size", "normal", "theme", "white", "ftAltsTooltip", "", 3, "tooltipType", "tooltipContent", "defaultTooltipPosition", "tooltipBehavior"], ["className", "font-small"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], [3, "background-color", 4, "ngIf"], [3, "class", 4, "ngIf"], ["type", "info-blue", "size", "normal", "theme", "white", "ftAltsTooltip", "", 3, "tooltipType", "tooltipContent", "defaultTooltipPosition", "tooltipBehavior", 4, "ngIf"], ["type", "info-blue", "size", "normal", "theme", "white", "ftAltsTooltip", "", 3, "tooltipType", "tooltipContent", "defaultTooltipPosition", "tooltipBehavior"]], template: function PerfTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTableComponent_div_0_Template, 12, 18, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.updatedTableData);
    } }, directives: [i3.NgIf, i3.NgClass, i3.NgForOf, i1.IconComponent, i1.TooltipDirective], pipes: [i3.AsyncPipe, i1.DashIfEmptyPipe], styles: [".perf-table[_ngcontent-%COMP%]{width:100%;position:relative;overflow-x:auto}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{background-color:var(--ft-complementary-sky-blue-4);color:var(--ft-white)}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]{background-color:var(--ft-light-grey)}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:16px;white-space:nowrap;font-weight:600}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type{text-align:left}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:not(:first-of-type):not(:last-of-type), .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:not(:first-of-type):not(:last-of-type){text-align:center}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{text-align:right}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:10px}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:12px}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:16px;height:16px;margin-right:8px}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   sup.inline-footnote[_ngcontent-%COMP%]{display:flex;margin-left:4px;margin-top:-8px;z-index:1}.perf-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .align-center[_ngcontent-%COMP%]{display:flex;align-items:center}.perf-table__scroll-button-bg-gradient[_ngcontent-%COMP%]{position:relative}.perf-table__scroll-button-bg-gradient[_ngcontent-%COMP%]:before{content:\"\";position:absolute;width:100vw;height:100%;margin-top:-9%;background:linear-gradient(272.68deg,#263154 -28.11%,rgba(132,140,165,.271219) 58.95%,rgba(169,178,204,0) 91.34%)}.perf-table__scroll-button-svg[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;top:calc(50% - 38px);left:50vw;z-index:3;opacity:1}.perf-table[_ngcontent-%COMP%]::-webkit-scrollbar{height:6px}.perf-table[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:var(--ft-complementary-sky-blue-1);border-radius:3px}.perf-table[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:var(--ft-alts-dark-blue)}.perf-table__hide-element[_ngcontent-%COMP%]{display:none}.perf-table__overflow--hidden[_ngcontent-%COMP%]{overflow:hidden}.perf-table__overflow--scroll[_ngcontent-%COMP%]{overflow-x:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTableComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-table',
                templateUrl: './perf-table.component.html',
                styleUrls: ['./perf-table.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: i0.ChangeDetectorRef }, { type: i2.Router }]; }, { tableData: [{
            type: Input
        }], tableConfig: [{
            type: Input
        }] }); })();

function PerfTabAverageAnnualComponent_div_0_sup_7_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", footnote_r7, ",");
} }
function PerfTabAverageAnnualComponent_div_0_sup_7_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(footnote_r7);
} }
function PerfTabAverageAnnualComponent_div_0_sup_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, PerfTabAverageAnnualComponent_div_0_sup_7_span_1_span_1_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(2, PerfTabAverageAnnualComponent_div_0_sup_7_span_1_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isLastIteration_r8 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !isLastIteration_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isLastIteration_r8);
} }
function PerfTabAverageAnnualComponent_div_0_sup_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtemplate(1, PerfTabAverageAnnualComponent_div_0_sup_7_span_1_Template, 3, 2, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.tabTitleFootnotes);
} }
function PerfTabAverageAnnualComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "ft-alts-switch", 14);
    i0.ɵɵlistener("switchState", function PerfTabAverageAnnualComponent_div_0_div_8_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r2.switchdata.offLabel)("onLabel", ctx_r2.switchdata.onLabel)("state", ctx_r2.switchdata.state);
} }
function PerfTabAverageAnnualComponent_div_0_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectedPerformanceData.asOfDate, " ");
} }
function PerfTabAverageAnnualComponent_div_0_ft_alts_perf_chart_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-chart", 16);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("bgColor", ctx_r4.bgColor)("chartConfig", ctx_r4.chartConfig)("chartData", ctx_r4.chartData);
} }
function PerfTabAverageAnnualComponent_div_0_ft_alts_perf_table_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-table", 17);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tableData", ctx_r5.tableData)("tableConfig", ctx_r5.tableConfig);
} }
const _c0$8 = function (a0) { return { "pt-avg-annual__chart-header": a0 }; };
function PerfTabAverageAnnualComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "h2", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PerfTabAverageAnnualComponent_div_0_sup_7_Template, 2, 1, "sup", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PerfTabAverageAnnualComponent_div_0_div_8_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PerfTabAverageAnnualComponent_div_0_p_9_Template, 2, 1, "p", 8);
    i0.ɵɵtemplate(10, PerfTabAverageAnnualComponent_div_0_ft_alts_perf_chart_10_Template, 1, 3, "ft-alts-perf-chart", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PerfTabAverageAnnualComponent_div_0_ft_alts_perf_table_11_Template, 1, 2, "ft-alts-perf-table", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$8, !i0.ɵɵpipeBind1(3, 7, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tabTitleFootnotes == null ? null : ctx_r0.tabTitleFootnotes.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && ctx_r0.showSwitchButton && ctx_r0.switchdata);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showTitleAsOfDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && (ctx_r0.chartConfig == null ? null : ctx_r0.chartConfig.showChart) && ctx_r0.chartData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tableConfig == null ? null : ctx_r0.tableConfig.showTable);
} }
class PerfTabAverageAnnualComponent extends PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr, dashIfEmptyPipe, decimalPipe) {
        super(responsiveService, perfTabMapperService, productConfigService, cdr);
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
        this.dashIfEmptyPipe = dashIfEmptyPipe;
        this.decimalPipe = decimalPipe;
        this.showSwitchButton = false;
        this.showTitleAsOfDate = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.perfTabMapperService.populate('averageAnnual', this.fundId, this.shareClassCode, this.brConfig);
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for average annual
     */
    mapContent(tabData) {
        super.mapContent(tabData);
        // Assign chart config only when its available, else let it be 'empty' as initialized, for tooltip options below.
        if (tabData.chartConfig) {
            this.chartConfig = tabData.chartConfig;
        }
        // Assign necessary chart & table configurations based upon fund loaded.
        this.mapConfigs();
        if (this.performanceMetadata) {
            this.onSwitchPressed(this.switchdata.state);
        }
    }
    /**
     * Map the necessary fund based config here.
     */
    mapConfigs() {
        // Fetch all the available fund id list.
        const availableFundIds = PERF_CONFIG.FUND_IDS;
        switch (this.fundId) {
            case '92083': {
                this.chartConfig['showChart'] = true;
                this.tableConfig['showTable'] = true;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
            case '18120': {
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['columnWidth'] = 32;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
            case '18896': {
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['columnWidth'] = 32;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
            case '31293': {
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['columnWidth'] = 32;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
            case '31292': {
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['columnWidth'] = 32;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
            case 'COFDASCORE': {
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                break;
            }
            case 'COFDASCORECAP': {
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                break;
            }
            case 'COFDASDYNAMIC': {
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                break;
            }
            case '90022': {
                this.chartConfig['showChart'] = true;
                this.tableConfig['showTable'] = true;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
            case '41056': {
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
        }
    }
    /**
     * Trigger action items on toggle of switch state.
     * Use correct performance data and prepare chart & table data accordingly.
     * @param currentState currently seleted switch state
     */
    onSwitchPressed(currentState) {
        // Step 1: Save correct performance data as per switch state selected.
        if (currentState === 'off') {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.offValue]);
        }
        else {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.onValue]);
        }
        // Step 2: Get chart data processed accordingly.
        this.chartData = this.prepareChartData(this.selectedPerformanceData.chartData);
        // Step 3: Get table data by processing updated chart data and other details from selected performance data.
        this.tableData = this.prepareTableData(this.chartData, this.selectedPerformanceData.asOfDate, this.selectedPerformanceData.sinceInceptionDate, currentState);
        // Step 4: Finally, update the child components - chart & table to use the updated values.
        this.cdr.detectChanges();
    }
    /**
     * Transform chart raw data into a feasible data structure as required by chart component.
     * @param chartRawMetaData
     * @returns complete chart data containing name & axes data.
     */
    prepareChartData(chartRawMetaData) {
        let chartData = {
            name: [],
            xAxis: [],
            yAxis: [],
        };
        chartRawMetaData === null || chartRawMetaData === void 0 ? void 0 : chartRawMetaData.forEach((chartRawData) => {
            chartData.name.push(chartRawData.class);
            chartData.yAxis.push({
                plots: chartRawData.data,
                props: {
                    dataLabels: {
                        enabled: this.chartConfig.chartType === 'column' ? true : false,
                    },
                    type: this.chartConfig.chartType,
                    point: {
                        events: {
                            mouseOver: function () {
                                var _a;
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 0.7,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                                (_a = this.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                    opacity: 1,
                                    transition: 'opacity 0.3s ease-in-out',
                                });
                            },
                            mouseOut: function () {
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 1,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                            },
                        },
                    },
                },
            });
        });
        chartData.xAxis = this.categories;
        return chartData;
    }
    /**
     * Prepare complete table metadata as required.
     * Uses chart data for binding x-axes (categories) to table header, and, y-axes (plots) to table body.
     * @param chartData updated chart data
     * @param asOfDate as of date as per selected performance data
     * @param sinceInceptionDate since inception data as per selected performance data
     * @param currentState currently seleted switch state
     * @returns complete table metadata containing head & body values
     */
    prepareTableData(chartData, asOfDate, sinceInceptionDate, currentState) {
        var _a;
        const headData = [];
        const bodyData = [];
        // Step 1: Add row headers for table header & table body initially.
        headData.push({
            // Show "fund name" as label if core/capped sma, else "period end" toggle type.
            label: ['cofdascore', 'cofdascorecap', 'cofdasdynamic'].includes((_a = this.fundId) === null || _a === void 0 ? void 0 : _a.toLowerCase())
                ? this.fundName
                : currentState === 'on'
                    ? this.switchdata.onLabel
                    : this.switchdata.offLabel,
            subLabel: asOfDate,
        });
        chartData.yAxis.forEach((plots, index) => {
            // Take care of multiple rows in a body through "array of objects" push, if present.
            bodyData.push([
                this.selectedPerformanceData.chartData[index].footnote
                    ? {
                        value: chartData.name[index],
                        footnote: this.selectedPerformanceData.chartData[index].footnote,
                    }
                    : {
                        value: chartData.name[index],
                    },
            ]);
        });
        // Step 2: Add remaining column data for table header & table body.
        headData.push(...chartData.xAxis.map((category, index) => {
            if (index === chartData.xAxis.length - 1) {
                return {
                    label: category,
                    subLabel: sinceInceptionDate,
                };
            }
            return {
                label: category,
            };
        }));
        chartData.yAxis.forEach((yAxisObj, index) => {
            // Take care of multiple rows in a body through 'index', if present.
            bodyData[index].push(...yAxisObj.plots.map((plot) => {
                return {
                    value: this.dashIfEmptyPipe.transform(plot) === EMDASH
                        ? plot
                        : // Replace '%' from data set, if present.
                            // Calculate the expected result from decimal pipe and again append '%'.
                            String(plot).includes('%')
                                ? `${this.decimalPipe.transform(String(plot).replace('%', ''), '1.2-2')}%`
                                : this.decimalPipe.transform(plot, '1.2-2'),
                };
            }));
        });
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabAverageAnnualComponent.ɵfac = function PerfTabAverageAnnualComponent_Factory(t) { return new (t || PerfTabAverageAnnualComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DashIfEmptyPipe), i0.ɵɵdirectiveInject(i3.DecimalPipe)); };
PerfTabAverageAnnualComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabAverageAnnualComponent, selectors: [["ft-alts-perf-tab-average-annual"]], features: [i0.ɵɵProvidersFeature([PerfTabMapperService, DashIfEmptyPipe, DecimalPipe]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "pt-avg-annual", 4, "ngIf"], [1, "pt-avg-annual"], [1, "color--ft-white", "spacing--md"], [3, "ngClass"], [1, "flex-wrap"], [1, "title--h4", "color--ft-white", "spacing--xs"], [4, "ngIf"], ["class", "spacing--lg", 4, "ngIf"], ["class", "color--ft-white font-p spacing--md", 4, "ngIf"], [3, "bgColor", "chartConfig", "chartData", 4, "ngIf"], [3, "tableData", "tableConfig", 4, "ngIf"], ["class", "color--ft-white", 4, "ngFor", "ngForOf"], [1, "color--ft-white"], [1, "spacing--lg"], [3, "offLabel", "onLabel", "state", "switchState"], [1, "color--ft-white", "font-p", "spacing--md"], [3, "bgColor", "chartConfig", "chartData"], [3, "tableData", "tableConfig"]], template: function PerfTabAverageAnnualComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabAverageAnnualComponent_div_0_Template, 12, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i3.NgIf, i3.NgClass, i3.NgForOf, i1.SwitchComponent, PerfChartComponent, PerfTableComponent], pipes: [i3.AsyncPipe], styles: [".pt-avg-annual__chart-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabAverageAnnualComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-average-annual',
                templateUrl: './perf-tab-average-annual.component.html',
                styleUrls: ['./perf-tab-average-annual.component.scss'],
                providers: [PerfTabMapperService, DashIfEmptyPipe, DecimalPipe],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }, { type: i1.DashIfEmptyPipe }, { type: i3.DecimalPipe }]; }, null); })();

class PerfChartModule {
}
PerfChartModule.ɵfac = function PerfChartModule_Factory(t) { return new (t || PerfChartModule)(); };
PerfChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfChartModule });
PerfChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, HighchartsChartModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfChartModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfChartComponent],
                imports: [CommonModule, HighchartsChartModule],
                exports: [PerfChartComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfChartModule, { declarations: [PerfChartComponent], imports: [CommonModule, HighchartsChartModule], exports: [PerfChartComponent] }); })();

class PerfTableModule {
}
PerfTableModule.ɵfac = function PerfTableModule_Factory(t) { return new (t || PerfTableModule)(); };
PerfTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTableModule });
PerfTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, PipesModule, TooltipModule, IconModule, DirectivesModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTableModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTableComponent],
                imports: [CommonModule, PipesModule, TooltipModule, IconModule, DirectivesModule],
                exports: [PerfTableComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTableModule, { declarations: [PerfTableComponent], imports: [CommonModule, PipesModule, TooltipModule, IconModule, DirectivesModule], exports: [PerfTableComponent] }); })();

class PerfTabAverageAnnualModule {
}
PerfTabAverageAnnualModule.ɵfac = function PerfTabAverageAnnualModule_Factory(t) { return new (t || PerfTabAverageAnnualModule)(); };
PerfTabAverageAnnualModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabAverageAnnualModule });
PerfTabAverageAnnualModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabAverageAnnualModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabAverageAnnualComponent],
                imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule],
                exports: [PerfTabAverageAnnualComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabAverageAnnualModule, { declarations: [PerfTabAverageAnnualComponent], imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule], exports: [PerfTabAverageAnnualComponent] }); })();

function PerfTabCumulativeTotalComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "ft-alts-switch", 10);
    i0.ɵɵlistener("switchState", function PerfTabCumulativeTotalComponent_div_0_div_6_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r1.switchdata.offLabel)("onLabel", ctx_r1.switchdata.onLabel)("state", ctx_r1.switchdata.state);
} }
function PerfTabCumulativeTotalComponent_div_0_ng_container_9_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.chartConfig.caveat, " ");
} }
function PerfTabCumulativeTotalComponent_div_0_ng_container_9_ft_alts_perf_chart_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-chart", 14);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("bgColor", ctx_r7.bgColor)("chartConfig", ctx_r7.chartConfig)("chartData", ctx_r7.chartData);
} }
function PerfTabCumulativeTotalComponent_div_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PerfTabCumulativeTotalComponent_div_0_ng_container_9_p_1_Template, 2, 1, "p", 11);
    i0.ɵɵtemplate(2, PerfTabCumulativeTotalComponent_div_0_ng_container_9_ft_alts_perf_chart_2_Template, 1, 3, "ft-alts-perf-chart", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.chartConfig.caveat);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showChart && ctx_r2.chartData);
} }
function PerfTabCumulativeTotalComponent_div_0_ft_alts_perf_table_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-table", 15);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tableData", ctx_r3.tableData)("tableConfig", ctx_r3.tableConfig);
} }
const _c0$7 = function (a0) { return { "pt-cumulative-total__chart-header": a0 }; };
function PerfTabCumulativeTotalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "h2", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PerfTabCumulativeTotalComponent_div_0_div_6_Template, 2, 3, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p", 6);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PerfTabCumulativeTotalComponent_div_0_ng_container_9_Template, 3, 2, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, PerfTabCumulativeTotalComponent_div_0_ft_alts_perf_table_10_Template, 1, 2, "ft-alts-perf-table", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$7, !i0.ɵɵpipeBind1(3, 6, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && ctx_r0.switchdata);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedPerformanceData.asOfDate, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.chartConfig == null ? null : ctx_r0.chartConfig.showChart);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tableConfig == null ? null : ctx_r0.tableConfig.showTable);
} }
class PerfTabCumulativeTotalComponent extends PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr, dashIfEmptyPipe, decimalPipe) {
        super(responsiveService, perfTabMapperService, productConfigService, cdr);
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
        this.dashIfEmptyPipe = dashIfEmptyPipe;
        this.decimalPipe = decimalPipe;
        // Bind extra custom imports with main dayjs import.
        dayjs.extend(utc);
        dayjs.extend(customParseFormat);
    }
    ngOnInit() {
        super.ngOnInit();
        this.perfTabMapperService.populate('cumulative', this.fundId, this.shareClassCode, this.brConfig);
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for cumulative total
     */
    mapContent(tabData) {
        super.mapContent(tabData);
        // Assign chart config only when its available, else let it be 'empty' as initialized, for tooltip options below.
        if (tabData.chartConfig) {
            this.chartConfig = tabData.chartConfig;
        }
        // Assign necessary chart & table configurations based upon fund loaded.
        this.mapConfigs();
        if (this.performanceMetadata) {
            this.onSwitchPressed(this.switchdata.state);
        }
    }
    /**
     * Map the necessary fund based config here.
     */
    mapConfigs() {
        // Fetch all the available fund id list.
        const availableFundIds = PERF_CONFIG.FUND_IDS;
        switch (this.fundId) {
            case '92083': {
                this.chartConfig['showChart'] = true;
                this.chartConfig['chartHeight'] = '430px';
                this.chartConfig['canSetXAxisCategories'] = true;
                this.chartConfig['xAxis']['type'] = 'category';
                this.tableConfig['showTable'] = false;
                break;
            }
            case '41056':
            case '29429': {
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                this.tableConfig['useChartData'] = false; // TODO: CHECK IF THIS FLAG IS STILL NEEDED.
                break;
            }
            case '18120': {
                this.chartConfig['showChart'] = true;
                this.chartConfig['chartHeight'] = '300px';
                this.chartConfig['canSetXAxisCategories'] = false;
                this.chartConfig['xAxis']['type'] = 'datetime';
                this.chartConfig['colors'] = ['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']; // Since we're not getting the same from BR json.
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                break;
            }
            case '18896': {
                this.chartConfig['showChart'] = true;
                this.chartConfig['chartHeight'] = '300px';
                this.chartConfig['canSetXAxisCategories'] = false;
                this.chartConfig['xAxis']['type'] = 'datetime';
                this.chartConfig['colors'] = ['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']; // Since we're not getting the same from BR json.
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                break;
            }
            case '31293': {
                this.chartConfig['showChart'] = true;
                this.chartConfig['chartHeight'] = '300px';
                this.chartConfig['canSetXAxisCategories'] = false;
                this.chartConfig['xAxis']['type'] = 'datetime';
                this.chartConfig['colors'] = ['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']; // Since we're not getting the same from BR json.
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                break;
            }
            case '31292': {
                this.chartConfig['showChart'] = true;
                this.chartConfig['chartHeight'] = '300px';
                this.chartConfig['canSetXAxisCategories'] = false;
                this.chartConfig['xAxis']['type'] = 'datetime';
                this.chartConfig['colors'] = ['#3769FF', '#00BFB3', '#91B9FF', '#E6E6E6']; // Since we're not getting the same from BR json.
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                break;
            }
            case '90022': {
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                this.tableConfig['useChartData'] = false; // TODO: CHECK IF THIS FLAG IS STILL NEEDED.
                break;
            }
        }
    }
    /**
     * Trigger action items on toggle of switch state.
     * Use correct performance data and prepare chart data accordingly.
     * @param currentState currently seleted switch state
     */
    onSwitchPressed(currentState) {
        var _a, _b;
        // Step 1: Save correct performance data as per switch state selected.
        if (currentState === 'off') {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.offValue]);
        }
        else {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.onValue]);
        }
        // Step 2: Get chart data, processing selected performance data.
        if ((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.showChart) {
            this.chartData = this.prepareChartData(this.selectedPerformanceData.chartData);
        }
        // Step 3: Get table data, processing selected performance data and current state.
        if ((_b = this.tableConfig) === null || _b === void 0 ? void 0 : _b.showTable) {
            this.tableData = this.prepareTableData(this.selectedPerformanceData, currentState);
        }
        // Step 4: Finally, update the child component - chart & table to use the updated values.
        this.cdr.detectChanges();
    }
    /**
     * Transform chart raw data into a feasible data structure as required by chart component.
     * @param chartRawMetaData
     * @returns complete chart data containing name & axes data.
     */
    prepareChartData(chartRawMetaData) {
        var _a, _b;
        let chartData = {
            name: [],
            xAxis: [],
            yAxis: [],
        };
        chartRawMetaData === null || chartRawMetaData === void 0 ? void 0 : chartRawMetaData.forEach((chartRawData) => {
            var _a;
            chartData.name.push(chartRawData.class);
            // When data array is "number[]".
            if ((_a = chartRawData.data) === null || _a === void 0 ? void 0 : _a.some((chartRawDataItem) => typeof chartRawDataItem === 'number')) {
                chartData.yAxis.push({
                    plots: chartRawData.data,
                    props: {
                        dataLabels: {
                            enabled: this.chartConfig.chartType === 'column' ? true : false,
                        },
                        type: this.chartConfig.chartType,
                    },
                });
            }
            // When data array is "object[]".
            else {
                chartData.yAxis.push({
                    plots: chartRawData.data.map((dataItem) => [
                        dayjs.utc(dataItem.date, 'DD/MM/YYYY').valueOf(),
                        Number(parseFloat(dataItem.value.replace(',', ''))),
                    ]),
                    props: {
                        dataLabels: {
                            enabled: this.chartConfig.chartType === 'column' ? true : false,
                        },
                        type: this.chartConfig.chartType,
                    },
                });
            }
        });
        // Set x-axis categories only when required, else make it undefined.
        if (((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.canSetXAxisCategories) && ((_b = this.categories) === null || _b === void 0 ? void 0 : _b.length)) {
            chartData.xAxis = this.categories;
        }
        else {
            chartData.xAxis = undefined;
        }
        return chartData;
    }
    /**
     * Prepare complete table metadata as required.
     * Uses 'categories' for binding table header, and, 'tableData' to table body.
     * @param selectedPerformanceData currently selected performance data as per current switch state
     * @param currentState currently selected switch state
     */
    prepareTableData(selectedPerformanceData, currentState) {
        var _a;
        const headData = [];
        const bodyData = [];
        // Step 1: Add row header at first, followed by column headers to header data.
        headData.push({
            label: currentState === 'on' ? this.switchdata.onLabel : this.switchdata.offLabel,
            subLabel: selectedPerformanceData.asOfDate,
        }, ...this.categories.map((category, index) => {
            const columnHeader = {
                label: category,
            };
            if (index === this.categories.length - 1 && category.toLowerCase().includes('inception')) {
                columnHeader['subLabel'] = selectedPerformanceData.sinceInceptionDate;
            }
            return columnHeader;
        }));
        // Step 2: Add row header for every row, followed by column values to each row.
        bodyData.push(...(_a = selectedPerformanceData[this.tableConfig.useChartData ? 'chartData' : 'tableData']) === null || _a === void 0 ? void 0 : _a.map((tableDataObj) => {
            const rowHeaderBodyData = {
                value: this.tableConfig.useChartData ? tableDataObj.class : tableDataObj.name,
            };
            if (tableDataObj.footnote) {
                rowHeaderBodyData['footnote'] = tableDataObj.footnote;
            }
            return [
                rowHeaderBodyData,
                ...tableDataObj.data.map((plot) => {
                    return {
                        value: this.dashIfEmptyPipe.transform(plot) === EMDASH ? plot : this.decimalPipe.transform(plot, '1.2-2'),
                    };
                }),
            ];
        }));
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabCumulativeTotalComponent.ɵfac = function PerfTabCumulativeTotalComponent_Factory(t) { return new (t || PerfTabCumulativeTotalComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DashIfEmptyPipe), i0.ɵɵdirectiveInject(i3.DecimalPipe)); };
PerfTabCumulativeTotalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabCumulativeTotalComponent, selectors: [["ft-alts-perf-tab-cumulative-total"]], features: [i0.ɵɵProvidersFeature([PerfTabMapperService, DashIfEmptyPipe, DecimalPipe]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "pt-cumulative-total", 4, "ngIf"], [1, "pt-cumulative-total"], [1, "color--ft-white", "spacing--md"], [3, "ngClass"], [1, "title--h4", "color--ft-white", "spacing--xs"], ["class", "spacing--lg", 4, "ngIf"], [1, "color--ft-white", "font-p", "spacing--md"], [4, "ngIf"], [3, "tableData", "tableConfig", 4, "ngIf"], [1, "spacing--lg"], [3, "offLabel", "onLabel", "state", "switchState"], ["class", "font-p--b spacing--md", 4, "ngIf"], [3, "bgColor", "chartConfig", "chartData", 4, "ngIf"], [1, "font-p--b", "spacing--md"], [3, "bgColor", "chartConfig", "chartData"], [3, "tableData", "tableConfig"]], template: function PerfTabCumulativeTotalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabCumulativeTotalComponent_div_0_Template, 11, 10, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i3.NgIf, i3.NgClass, i1.SwitchComponent, PerfChartComponent, PerfTableComponent], pipes: [i3.AsyncPipe], styles: [".pt-cumulative-total__chart-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabCumulativeTotalComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-cumulative-total',
                templateUrl: './perf-tab-cumulative-total.component.html',
                styleUrls: ['./perf-tab-cumulative-total.component.scss'],
                providers: [PerfTabMapperService, DashIfEmptyPipe, DecimalPipe],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }, { type: i1.DashIfEmptyPipe }, { type: i3.DecimalPipe }]; }, null); })();

class PerfTabCumulativeTotalModule {
}
PerfTabCumulativeTotalModule.ɵfac = function PerfTabCumulativeTotalModule_Factory(t) { return new (t || PerfTabCumulativeTotalModule)(); };
PerfTabCumulativeTotalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabCumulativeTotalModule });
PerfTabCumulativeTotalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, SwitchModule, PerfChartModule, PerfTableModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabCumulativeTotalModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabCumulativeTotalComponent],
                imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule],
                exports: [PerfTabCumulativeTotalComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabCumulativeTotalModule, { declarations: [PerfTabCumulativeTotalComponent], imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule], exports: [PerfTabCumulativeTotalComponent] }); })();

function PerfDropdownComponent_ng_container_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function PerfDropdownComponent_ng_container_11_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const item_r1 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onDropdownItemClicked(item_r1); });
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r1);
} }
function PerfDropdownComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PerfDropdownComponent_ng_container_11_div_1_Template, 3, 1, "div", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r1 !== ctx_r0.selectedItem);
} }
const _c0$6 = function (a0) { return { "perf-dropdown__container__icon--open": a0 }; };
const _c1$3 = function (a0) { return { "perf-dropdown__list--open": a0 }; };
class PerfDropdownComponent {
    constructor(analytics, windowRef) {
        this.analytics = analytics;
        this.windowRef = windowRef;
        /**
         * Optional prop to set dropdown label.
         * If not supplied, by default, 'Select' will be the label displayed.
         */
        this.label = 'Select';
        /**
         * Mandatory prop having dropdown items.
         */
        this.items = [];
        /**
         * The change event emitter against the new dropdown item.
         */
        this.onChange = new EventEmitter();
        this.isDropdownOpened = false;
    }
    ngOnInit() {
        var _a;
        if (!this.selectedItem) {
            this.selectedItem = (_a = this.items) === null || _a === void 0 ? void 0 : _a[0];
        }
    }
    /**
     * Toggle the dropdown state to be either 'opened' or 'closed'.
     */
    onDropdownClicked() {
        this.isDropdownOpened = !this.isDropdownOpened;
    }
    /**
     * Save the newly clicked dropdown item as the selected one.
     * Trigger an output event for the same as well.
     * @param selectedItem currently selected item
     */
    onDropdownItemClicked(selectedItem) {
        // Save the selection.
        this.selectedItem = selectedItem;
        // Close the dropdown list.
        this.isDropdownOpened = false;
        // Emit an output event as the new selected one.
        this.onChange.emit(selectedItem);
        // Track Analytics Event
        this.analytics.trackEvent({
            event: 'dropdown_select',
            name: selectedItem,
            label: selectedItem,
        });
    }
}
PerfDropdownComponent.ɵfac = function PerfDropdownComponent_Factory(t) { return new (t || PerfDropdownComponent)(i0.ɵɵdirectiveInject(i1.AnalyticsService), i0.ɵɵdirectiveInject(WINDOW)); };
PerfDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfDropdownComponent, selectors: [["ft-alts-perf-dropdown"]], inputs: { label: "label", items: "items", selectedItem: "selectedItem" }, outputs: { onChange: "onChange" }, decls: 12, vars: 9, consts: [[1, "perf-dropdown"], [1, "perf-dropdown__container", 3, "click"], [1, "perf-dropdown__container__inner"], [1, "spacing--none"], [1, "perf-dropdown__container__icon", 3, "ngClass"], ["width", "14", "height", "8", "viewBox", "0 0 14 8", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0.550781 0.799805L6.95078 7.2998L13.4508 0.799805", "stroke", "#ffffff", "strokeMiterlimit", "10", "strokeLinecap", "round", "strokeLinejoin", "round"], [1, "perf-dropdown__list", 3, "ngClass"], [4, "ngFor", "ngForOf"], ["class", "perf-dropdown__list__item", 3, "click", 4, "ngIf"], [1, "perf-dropdown__list__item", 3, "click"]], template: function PerfDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("click", function PerfDropdownComponent_Template_div_click_1_listener() { return ctx.onDropdownClicked(); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(8, "svg", 5);
        i0.ɵɵelement(9, "path", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵtemplate(11, PerfDropdownComponent_ng_container_11_Template, 2, 1, "ng-container", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.label);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$6, ctx.isDropdownOpened));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$3, ctx.isDropdownOpened));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [i3.NgClass, i3.NgForOf, i3.NgIf], styles: [".perf-dropdown[_ngcontent-%COMP%]{width:100%;max-width:310px;display:flex;flex-direction:column;position:relative;z-index:5}.perf-dropdown__container[_ngcontent-%COMP%]{border:1px solid var(--ft-grey-3);border-radius:8px;padding:var(--space-xxs) var(--space-xs);display:flex;align-items:center;background-color:transparent;border-color:var(--ft-white);color:var(--ft-white);cursor:pointer}.perf-dropdown__container__inner[_ngcontent-%COMP%]{margin-right:auto;display:flex;flex-direction:column;grid-gap:var(--space-xxs);gap:var(--space-xxs)}.perf-dropdown__container__inner[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:first-child{font-family:var(--fonts-input-caption-font-family);font-size:var(--fonts-input-caption-font-size-small-desktop);font-weight:var(--fonts-input-caption-font-weight);line-height:var(--fonts-input-caption-line-height)}.perf-dropdown__container__inner[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:last-child{font-family:var(--fonts-input-font-family);font-size:var(--fonts-input-font-size-small-desktop);font-weight:var(--fonts-input-font-weight);line-height:var(--fonts-input-line-height)}.perf-dropdown__container__icon[_ngcontent-%COMP%]{display:flex;transition:transform .3s ease-in-out;color:var(--ft-white)}.perf-dropdown__container__icon--open[_ngcontent-%COMP%]{transform:rotate(180deg)}.perf-dropdown__list[_ngcontent-%COMP%]{position:absolute;top:100%;width:100%;max-height:0;border-radius:8px;display:flex;flex-direction:column;overflow:hidden;transition:max-height .3s ease-in-out;background-color:var(--ft-white);color:var(--ft-black)}.perf-dropdown__list--open[_ngcontent-%COMP%]{max-height:400px}.perf-dropdown__list__item[_ngcontent-%COMP%]{padding:var(--space-xs);font-family:var(--fonts-input-font-family);font-size:var(--fonts-input-font-size-small-desktop);font-weight:var(--fonts-input-font-weight);line-height:var(--fonts-input-line-height);cursor:pointer}.perf-dropdown__list__item[_ngcontent-%COMP%]:hover{background-color:var(--ft-complementary-sky-blue-1)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-dropdown',
                templateUrl: './perf-dropdown.component.html',
                styleUrls: ['./perf-dropdown.component.scss'],
            }]
    }], function () { return [{ type: i1.AnalyticsService }, { type: Window, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, { label: [{
            type: Input
        }], items: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], onChange: [{
            type: Output
        }] }); })();

function PerfTabDistributionsComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "ft-alts-switch", 16);
    i0.ɵɵlistener("switchState", function PerfTabDistributionsComponent_div_0_div_6_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r1.switchdata.offLabel)("onLabel", ctx_r1.switchdata.onLabel)("state", ctx_r1.switchdata.state);
} }
function PerfTabDistributionsComponent_div_0_ft_alts_perf_chart_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-chart", 17);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("bgColor", ctx_r2.bgColor)("chartConfig", ctx_r2.chartConfig)("chartData", ctx_r2.chartData);
} }
function PerfTabDistributionsComponent_div_0_ng_container_16_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ft-alts-pagination", 20);
    i0.ɵɵlistener("onChange", function PerfTabDistributionsComponent_div_0_ng_container_16_ng_container_3_Template_ft_alts_pagination_onChange_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(3); return ctx_r8.onPageChanged($event); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("totalPages", i0.ɵɵpipeBind1(2, 2, ctx_r7.totalPages$))("currentPage", i0.ɵɵpipeBind1(3, 4, ctx_r7.currentPageNumber$));
} }
function PerfTabDistributionsComponent_div_0_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelement(2, "ft-alts-perf-table", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PerfTabDistributionsComponent_div_0_ng_container_16_ng_container_3_Template, 4, 6, "ng-container", 11);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tableData", ctx_r3.tableData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 2, ctx_r3.totalPages$) > 1);
} }
function PerfTabDistributionsComponent_div_0_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.disclosure, " ");
} }
const _c0$5 = function (a0) { return { "spacing--md": a0 }; };
const _c1$2 = function (a0) { return { "pt-distributions__chart-header": a0 }; };
const _c2 = function (a0, a1) { return { "pt-distributions__width--full": a0, "pt-distributions__width--half": a1 }; };
function PerfTabDistributionsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "h2", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PerfTabDistributionsComponent_div_0_div_6_Template, 2, 3, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementStart(12, "ft-alts-perf-dropdown", 8);
    i0.ɵɵlistener("onChange", function PerfTabDistributionsComponent_div_0_Template_ft_alts_perf_dropdown_onChange_12_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.onDropdownChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p", 9);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, PerfTabDistributionsComponent_div_0_ft_alts_perf_chart_15_Template, 1, 3, "ft-alts-perf-chart", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, PerfTabDistributionsComponent_div_0_ng_container_16_Template, 5, 4, "ng-container", 11);
    i0.ɵɵelementStart(17, "div", 12);
    i0.ɵɵelementStart(18, "div", 13);
    i0.ɵɵelementStart(19, "div", 14);
    i0.ɵɵelementStart(20, "a", 15);
    i0.ɵɵlistener("click", function PerfTabDistributionsComponent_div_0_Template_a_click_20_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.triggerHistoricalDistributionDownload(); });
    i0.ɵɵtext(21, " Download Historical Distribution (XLS) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, PerfTabDistributionsComponent_div_0_ng_container_22_Template, 3, 1, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c0$5, !ctx_r0.showTable));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c1$2, !i0.ɵɵpipeBind1(3, 13, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && ctx_r0.switchdata);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c1$2, !i0.ɵɵpipeBind1(8, 15, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(27, _c2, i0.ɵɵpipeBind1(10, 17, ctx_r0.isHandheld$), !i0.ɵɵpipeBind1(11, 19, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", "Year")("items", ctx_r0.years)("selectedItem", ctx_r0.selectedYear);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedPerformanceData == null ? null : ctx_r0.selectedPerformanceData.asOfDate, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && !ctx_r0.showTable && ctx_r0.chartData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showTable);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.disclosure);
} }
// Declare the default selected year for the dropdown year list.
// Note that the string value should be "exact same" as to be listed in the list.
const DEFAULT_SELECTED_YEAR = 'Since Inception';
// Pagination page size.
const PAGE_SIZE = 10;
// File download declarations.
const DISTRIBUTION_DOWNLOAD_LINK = '/binaries/content/assets/global/ft-alts/${fundId}/distributionhistoryreportclass${shareClass}.xlsx';
const DISTRIBUTION_DOWNLOAD_NAME = 'DistributionHistoryReportClass${shareClass}.xlsx';
class PerfTabDistributionsComponent extends PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr) {
        super(responsiveService, perfTabMapperService, productConfigService, cdr);
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
    }
    ngOnInit() {
        super.ngOnInit();
        this.pagedRecords = new PagedRecords(PAGE_SIZE);
        this.totalPages$ = this.pagedRecords.numberOfPages$;
        this.currentPageNumber$ = this.pagedRecords.pageNumber$;
        this.downloadLink = this.generateDownloadLink(this.fundId, this.shareClassCode);
        this.downloadFileName = DISTRIBUTION_DOWNLOAD_NAME.replace('${shareClass}', this.shareClassCode);
        this.perfTabMapperService.populate('distributions', this.fundId, this.shareClassCode, this.brConfig);
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for distributions
     */
    mapContent(tabData) {
        super.mapContent(tabData);
        this.shareClassName = tabData.shareClassName;
        this.performanceInceptionDate = tabData.performanceInceptionDate;
        this.shareClassCurrency = tabData.shareClassCurrency;
        // Assign 'years' & 'disclosure' data, applicable for distributions only.
        this.years = tabData.years;
        this.disclosure = tabData.disclosure;
        // Assign chart config only when its available, else let it be 'empty' as initialized, for tooltip options below.
        if (tabData.chartConfig) {
            this.chartConfig = tabData.chartConfig;
        }
        // DCE-1095: Set step to include every plot points in x-axis in non-handheld view.
        this.subscriptions.push(this.responsiveService.isHandheld$().subscribe((isHandheld) => {
            if (isHandheld) {
                this.chartConfig.xAxis.labels.step = 0; // '0' marks default as auto steps.
            }
            else {
                this.chartConfig.xAxis.labels.step = 1;
            }
        }));
        if (this.performanceMetadata) {
            // Fetch the performance data for distributions. Here the data comes only in month end.
            this.selectedPerformanceData = this.performanceMetadata.monthEnd;
            // Merge performance data for all years and push it to table data list.
            // So that, a full list can be used when dropdown selected is "since inception".
            this.selectedPerformanceData.tableData.push(this.createPerfDataForSinceInception(this.selectedPerformanceData.tableData));
        }
        // Load the chart/table data as per the default selected year.
        this.onDropdownChange(DEFAULT_SELECTED_YEAR);
        // Show the chart/table display as per configuration on load.
        this.onSwitchPressed(this.switchdata.state);
    }
    /**
     * Merge all performance table data into one set.
     * Return the set as and for "since inception".
     * @param allPerformanceRawData complete performance data for all years as from data source
     */
    createPerfDataForSinceInception(allPerformanceRawData) {
        const allYearTableData = [];
        // Iterate through all the performance table rows and merge the data into one list.
        allPerformanceRawData.forEach((tableDataObj) => allYearTableData.push(...tableDataObj.data));
        // Finally return the list with label as since inception.
        return {
            year: 'Since Inception',
            data: allYearTableData,
        };
    }
    /**
     * Transform distributions raw data into a feasible data structure as required by chart component.
     * @param distributionsData target year distributions data
     */
    prepareChartData(distributionsData) {
        // Create date compare function against the required date format.
        const dataCompareFn = createDateComparator('MM/DD/YYYY');
        // Create the needful chart component variables and assign them values accordingly.
        const xAxis = [];
        const navSeries = [];
        const totalDistributionSeries = [];
        // Iterate through the distribution table data for the selected year.
        distributionsData === null || distributionsData === void 0 ? void 0 : distributionsData.sort((current, next) => dataCompareFn(current.recordDate, next.recordDate, false)).forEach((distributionsObj) => {
            const date = new Date(distributionsObj.recordDate);
            const formattedDate = date.toLocaleString('en-us', { month: 'short', year: '2-digit' }).replace(' ', " '");
            const tooltipDate = date.toLocaleString('en-us', {
                month: 'long',
                year: 'numeric',
            });
            xAxis.push(formattedDate);
            navSeries.push({
                y: parseFloat(distributionsObj.reinvestmentPrice.replace('$', '')),
                name: tooltipDate,
            });
            // DCE-1550: Made total distributions series fetch the values from 'income' field rather than its obvious field for BSP.
            totalDistributionSeries.push(parseFloat(distributionsObj[this.fundId === '29429' ? 'income' : 'totalDistribution'].replace('$', '')));
        });
        return {
            name: ['NAV', 'Total Distribution Per Share'],
            xAxis: xAxis,
            yAxis: [
                {
                    plots: navSeries,
                    props: {
                        color: '#C042EA',
                        yAxis: 0,
                        zIndex: 2,
                        dataLabels: {
                            enabled: this.chartConfig.chartType === 'column' ? true : false,
                        },
                    }, // Intentionally typecasted again to suppress mandatory prop 'type'.
                },
                {
                    plots: totalDistributionSeries,
                    props: {
                        type: 'column',
                        color: '#00BFB3',
                        borderWidth: 0,
                        pointPadding: 0.1,
                        pointPlacement: 0,
                        yAxis: 1,
                        zIndex: 1,
                        dataLabels: {
                            enabled: this.chartConfig.chartType === 'column' ? true : false,
                        },
                    },
                },
            ],
        };
    }
    /**
     * Transform distributions raw data into a feasible data structure as required by table component.
     * @param distributionsData target year distributions data
     */
    prepareTableData(distributionsData) {
        const headData = [];
        const bodyData = [];
        // Step 1: Firstly, list all required column headers along with their labels.
        const columnHeaderLabelMapping = {
            recordDate: 'Record Date',
            exDividendDate: 'Ex-Dividend Date',
            reinvestmentDate: 'Reinvestment Date',
            payableDate: 'Payable Date',
            reinvestmentPrice: 'Reinvestment Price',
            longTermCapitalGains: 'Long-Term Capital Gains',
            shortTermCapitalGains: 'Short-Term Capital Gains',
            income: 'Income',
            returnCapital: 'Return to Capital',
            totalDistribution: 'Total Distribution Per Share',
        };
        let columnHeadersToBeDisplayed = [];
        // Step 2.1: Fetch all the available fund id list.
        const availableFundIds = PERF_CONFIG.FUND_IDS;
        // Step 2.2: Assign the relevant column to be displayed as per fund id.
        switch (this.fundId) {
            case '92083': {
                columnHeadersToBeDisplayed = [
                    'recordDate',
                    'exDividendDate',
                    'reinvestmentDate',
                    'payableDate',
                    'reinvestmentPrice',
                    'income',
                    'returnCapital',
                    'totalDistribution',
                ];
                break;
            }
            case '41056':
            case '29429': {
                columnHeadersToBeDisplayed = [
                    'recordDate',
                    'exDividendDate',
                    'reinvestmentDate',
                    'payableDate',
                    'reinvestmentPrice',
                    'longTermCapitalGains',
                    'shortTermCapitalGains',
                    'income',
                    'totalDistribution',
                ];
                break;
            }
            case '90022': {
                columnHeadersToBeDisplayed = [
                    'recordDate',
                    'exDividendDate',
                    'reinvestmentDate',
                    'payableDate',
                    'reinvestmentPrice',
                    'longTermCapitalGains',
                    'shortTermCapitalGains',
                    'income',
                    'totalDistribution',
                ];
                break;
            }
        }
        // Step 3: Add column headers, needed to be displayed.
        columnHeadersToBeDisplayed.forEach((columnHeader) => {
            headData.push({
                label: columnHeaderLabelMapping[columnHeader],
            });
        });
        // Step 4: Add table rows.
        // Step 4.1: For this, create date compare function against the required date format.
        const dataCompareFn = createDateComparator('MM/DD/YYYY');
        // Step 4.2: Then sort it descending and iterate each of them to map body data.
        distributionsData
            .sort((current, next) => dataCompareFn(next.recordDate, current.recordDate, false))
            .forEach((distributionData) => {
            bodyData.push(columnHeadersToBeDisplayed.map((columnHeader) => {
                return {
                    value: distributionData[columnHeader],
                };
            }));
        });
        this.distributionHistoryExcelData = this.prepareHistoricalDistributionExcel(columnHeaderLabelMapping, distributionsData);
        // Step 4.3: Further, configure pagination to display correct page as per page size.
        this.pagedRecords.records = cloneDeep(bodyData);
        // Step 5: Finally return the current page as body data along with head data.
        return {
            head: headData,
            body: this.pagedRecords.currentPage,
        };
    }
    /**
     * Prepares historical distribution in excel format
     */
    prepareHistoricalDistributionExcel(columnHeaderLabelMapping, distributionsData) {
        const mappedFullRecords = [
            Object.keys(distributionsData[0]).map((data) => getCellObject(columnHeaderLabelMapping[data])),
        ];
        distributionsData.forEach((data) => {
            mappedFullRecords.push(Object.values(data));
        });
        const fundName = [];
        const shareClassSection = [];
        const endDateStartDateSection = [];
        fundName.push([this.fundName]);
        shareClassSection.push([`Share Class`, this.shareClassName]);
        shareClassSection.push([`Performance Inception Date`, this.performanceInceptionDate]);
        shareClassSection.push([`Currency`, this.shareClassCurrency]);
        endDateStartDateSection.push([
            `Download dividends : From ${mappedFullRecords[mappedFullRecords.length - 1][0]} To ${mappedFullRecords[1][0]}`,
        ]);
        return {
            excelData: mappedFullRecords,
            fundName,
            shareClassSection,
            endDateStartDateSection,
        };
    }
    /*
     Triggers download of historical distribution data as per year selected from dropdown
    */
    triggerHistoricalDistributionDownload() {
        const { excelData, fundName, shareClassSection, endDateStartDateSection } = this.distributionHistoryExcelData;
        this.exportToExcel(excelData, fundName, shareClassSection, endDateStartDateSection);
    }
    /**
     * Save the newly clicked dropdown item as the selected one.
     * @param selectedItem currently selected item
     */
    onDropdownChange(selectedItem) {
        var _a, _b;
        // Save the selected year as the value received.
        this.selectedYear = selectedItem;
        // Extract the selected year distributions table data.
        const selectedYearDistributionsTableData = (_b = (_a = this.selectedPerformanceData) === null || _a === void 0 ? void 0 : _a.tableData) === null || _b === void 0 ? void 0 : _b.find((tableDataObj) => tableDataObj.year === selectedItem).data;
        // Prepare chart data against selected dropdown item.
        this.chartData = this.prepareChartData(selectedYearDistributionsTableData);
        // Prepare table data against selected dropdown item.
        this.tableData = this.prepareTableData(selectedYearDistributionsTableData);
        this.cdr.detectChanges();
    }
    /**
     * Export the table data to excel and auto download.
     * @param data full record for excel
     */
    exportToExcel(data, fundName, shareClassSection, endDateStartDateSection) {
        import('xlsx').then((xlsx) => {
            const workSheet = xlsx.utils.aoa_to_sheet(fundName);
            const workBook = xlsx.utils.book_new();
            workSheet['!cols'] = getColWidths(data);
            xlsx.utils.sheet_add_aoa(workSheet, shareClassSection, {
                origin: 'A' + (fundName.length + 2),
            });
            xlsx.utils.sheet_add_aoa(workSheet, endDateStartDateSection, {
                origin: 'A' + (fundName.length + shareClassSection.length + 3),
            });
            xlsx.utils.sheet_add_aoa(workSheet, data, {
                origin: 'A' + (fundName.length + shareClassSection.length + endDateStartDateSection.length + 5),
            });
            xlsx.utils.book_append_sheet(workBook, workSheet, 'DistributionHistoryDetails');
            xlsx.writeFile(workBook, 'DistributionHistoryReport.xlsx');
        });
    }
    /**
     * Toggle display between chart and table.
     * @param currentState currently seleted switch state
     */
    onSwitchPressed(currentState) {
        this.showTable = currentState === 'on';
        this.cdr.detectChanges();
    }
    /**
     * Trigger page change with the page number selected.
     * @param pageNumber page number clicked
     */
    onPageChanged(pageNumber) {
        // Set the page number in paging utils.
        this.pagedRecords.pageNumber = pageNumber;
        // Get the new current page based upon page number set previously.
        this.tableData.body = this.pagedRecords.currentPage;
        // Trigger the change detection for latest changes.
        this.cdr.detectChanges();
    }
    /**
     * Generate download link for static distributions file for currently loaded fund.
     * @param fundId fund id of currently loaded fund
     * @param shareClassCode share class code of currently loaded fund
     */
    generateDownloadLink(fundId, shareClassCode) {
        if (fundId && shareClassCode) {
            return DISTRIBUTION_DOWNLOAD_LINK.replace('${fundId}', fundId).replace('${shareClass}', shareClassCode === null || shareClassCode === void 0 ? void 0 : shareClassCode.replace(/\s+/g, '-').toLowerCase());
        }
        return null;
    }
}
PerfTabDistributionsComponent.ɵfac = function PerfTabDistributionsComponent_Factory(t) { return new (t || PerfTabDistributionsComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PerfTabDistributionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabDistributionsComponent, selectors: [["ft-alts-perf-tab-distributions"]], features: [i0.ɵɵProvidersFeature([PerfTabMapperService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "pt-distributions", 4, "ngIf"], [1, "pt-distributions"], [1, "color--ft-white", 3, "ngClass"], [1, "spacing--xs", 3, "ngClass"], [1, "title--h4", "color--ft-white", "spacing--xs"], ["class", "spacing--lg", 4, "ngIf"], [1, "spacing--xl", 3, "ngClass"], [1, "spacing--md", 3, "ngClass"], [3, "label", "items", "selectedItem", "onChange"], [1, "color--ft-white", "font-p", "spacing--md"], [3, "bgColor", "chartConfig", "chartData", 4, "ngIf"], [4, "ngIf"], [1, "spacing--lg"], [1, "alts-navigation__primary-button"], [1, "alts-block-button", "alts-button-v1"], ["target", "_blank", 1, "alts-block-button__link", 3, "click"], [3, "offLabel", "onLabel", "state", "switchState"], [3, "bgColor", "chartConfig", "chartData"], [1, "spacing--xl"], [3, "tableData"], [3, "totalPages", "currentPage", "onChange"], [1, "font-p--b", "color--ft-white", "padding-top--md"]], template: function PerfTabDistributionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabDistributionsComponent_div_0_Template, 23, 30, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i3.NgIf, i3.NgClass, PerfDropdownComponent, i1.SwitchComponent, PerfChartComponent, PerfTableComponent, i1.PaginationComponent], pipes: [i3.AsyncPipe], styles: [".pt-distributions__chart-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.pt-distributions__chart-header[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{word-break:normal}.pt-distributions__width--full[_ngcontent-%COMP%]{width:100%}.pt-distributions__width--half[_ngcontent-%COMP%]{flex-basis:50%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabDistributionsComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-distributions',
                templateUrl: './perf-tab-distributions.component.html',
                styleUrls: ['./perf-tab-distributions.component.scss'],
                providers: [PerfTabMapperService],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }]; }, null); })();

class PerfDropdownModule {
}
PerfDropdownModule.ɵfac = function PerfDropdownModule_Factory(t) { return new (t || PerfDropdownModule)(); };
PerfDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfDropdownModule });
PerfDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfDropdownComponent],
                imports: [CommonModule],
                exports: [PerfDropdownComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfDropdownModule, { declarations: [PerfDropdownComponent], imports: [CommonModule], exports: [PerfDropdownComponent] }); })();

class PerfTabDistributionsModule {
}
PerfTabDistributionsModule.ɵfac = function PerfTabDistributionsModule_Factory(t) { return new (t || PerfTabDistributionsModule)(); };
PerfTabDistributionsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabDistributionsModule });
PerfTabDistributionsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PerfDropdownModule,
            PerfChartModule,
            PerfTableModule,
            SwitchModule,
            PaginationModule,
            ButtonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabDistributionsModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabDistributionsComponent],
                imports: [
                    CommonModule,
                    PerfDropdownModule,
                    PerfChartModule,
                    PerfTableModule,
                    SwitchModule,
                    PaginationModule,
                    ButtonModule,
                ],
                exports: [PerfTabDistributionsComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabDistributionsModule, { declarations: [PerfTabDistributionsComponent], imports: [CommonModule,
        PerfDropdownModule,
        PerfChartModule,
        PerfTableModule,
        SwitchModule,
        PaginationModule,
        ButtonModule], exports: [PerfTabDistributionsComponent] }); })();

function PerfTabMonthlyCalendarComponent_div_0_sup_7_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", footnote_r6, ",");
} }
function PerfTabMonthlyCalendarComponent_div_0_sup_7_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(footnote_r6);
} }
function PerfTabMonthlyCalendarComponent_div_0_sup_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, PerfTabMonthlyCalendarComponent_div_0_sup_7_span_1_span_1_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(2, PerfTabMonthlyCalendarComponent_div_0_sup_7_span_1_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isLastIteration_r7 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !isLastIteration_r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isLastIteration_r7);
} }
function PerfTabMonthlyCalendarComponent_div_0_sup_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtemplate(1, PerfTabMonthlyCalendarComponent_div_0_sup_7_span_1_Template, 3, 2, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.tabTitleFootnotes);
} }
function PerfTabMonthlyCalendarComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "ft-alts-switch", 14);
    i0.ɵɵlistener("switchState", function PerfTabMonthlyCalendarComponent_div_0_div_8_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r2.switchdata.offLabel)("onLabel", ctx_r2.switchdata.onLabel)("state", ctx_r2.switchdata.state);
} }
function PerfTabMonthlyCalendarComponent_div_0_ft_alts_perf_chart_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-chart", 15);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("bgColor", ctx_r3.bgColor)("chartConfig", ctx_r3.chartConfig)("chartData", ctx_r3.chartData);
} }
function PerfTabMonthlyCalendarComponent_div_0_ft_alts_perf_table_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-table", 16);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tableData", ctx_r4.tableData)("tableConfig", ctx_r4.tableConfig);
} }
const _c0$4 = function (a0) { return { "pt-monthly-calendar__table-header": a0 }; };
function PerfTabMonthlyCalendarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "h2", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PerfTabMonthlyCalendarComponent_div_0_sup_7_Template, 2, 1, "sup", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PerfTabMonthlyCalendarComponent_div_0_div_8_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 8);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PerfTabMonthlyCalendarComponent_div_0_ft_alts_perf_chart_11_Template, 1, 3, "ft-alts-perf-chart", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, PerfTabMonthlyCalendarComponent_div_0_ft_alts_perf_table_12_Template, 1, 2, "ft-alts-perf-table", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$4, !i0.ɵɵpipeBind1(3, 7, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tabTitleFootnotes == null ? null : ctx_r0.tabTitleFootnotes.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && ctx_r0.switchdata);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedPerformanceData.asOfDate, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && (ctx_r0.chartConfig == null ? null : ctx_r0.chartConfig.showChart) && ctx_r0.chartData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tableConfig == null ? null : ctx_r0.tableConfig.showTable);
} }
class PerfTabMonthlyCalendarComponent extends PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr, dashIfEmptyPipe, decimalPipe) {
        super(responsiveService, perfTabMapperService, productConfigService, cdr);
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
        this.dashIfEmptyPipe = dashIfEmptyPipe;
        this.decimalPipe = decimalPipe;
    }
    ngOnInit() {
        super.ngOnInit();
        this.perfTabMapperService.populate('monthlyCalendar', this.fundId, this.shareClassCode, this.brConfig);
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for monthly calendar
     */
    mapContent(tabData) {
        super.mapContent(tabData);
        // Assign chart config only when its available, else let it be 'empty' as initialized.
        if (tabData.chartConfig) {
            this.chartConfig = tabData.chartConfig;
        }
        // Assign necessary chart & table configurations based upon fund loaded.
        this.mapConfigs();
        if (this.performanceMetadata) {
            this.onSwitchPressed(this.switchdata.state);
        }
    }
    /**
     * Map the necessary fund based config here.
     */
    mapConfigs() {
        var _a, _b, _c;
        // Fetch all the available fund id list.
        const availableFundIds = PERF_CONFIG.FUND_IDS;
        const tabTitle = (_c = (_b = (_a = this.brConfig) === null || _a === void 0 ? void 0 : _a.tabTitle) === null || _b === void 0 ? void 0 : _b.monthlyCalendar) === null || _c === void 0 ? void 0 : _c[this.fundId];
        switch (this.fundId) {
            case '92083': {
                this.tabTitle = tabTitle || 'Monthly & Calendar Year Return';
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showShareClassLabelInHeader'] = true;
                break;
            }
            case '18120': {
                this.tabTitle = tabTitle || 'Calendar Year Returns';
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['hideYTDPlots'] = true;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.tableConfig['showPeriodEndLabelInHeader'] = true;
                this.tableConfig['showPerformanceInceptionLabelInHeader'] = true;
                break;
            }
            case '18896': {
                this.tabTitle = tabTitle || 'Calendar Year Returns';
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['hideYTDPlots'] = true;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.tableConfig['showPeriodEndLabelInHeader'] = true;
                this.tableConfig['showPerformanceInceptionLabelInHeader'] = true;
                break;
            }
            case '31293': {
                this.tabTitle = 'Calendar Year Returns';
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['hideYTDPlots'] = true;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.tableConfig['showPeriodEndLabelInHeader'] = true;
                this.tableConfig['showPerformanceInceptionLabelInHeader'] = true;
                break;
            }
            case '31292': {
                this.tabTitle = 'Calendar Year Returns';
                this.tabTitleFootnotes = ['4']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
                this.chartConfig['showChart'] = true;
                this.chartConfig['hideYTDPlots'] = true;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showLegends'] = true;
                this.tableConfig['legendColors'] = this.chartConfig.colors;
                this.tableConfig['showPeriodEndLabelInHeader'] = true;
                this.tableConfig['showPerformanceInceptionLabelInHeader'] = true;
                break;
            }
            case '41056': {
                this.tabTitle = tabTitle || 'Monthly & Calendar Year Return';
                this.chartConfig['showChart'] = false;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showShareClassLabelInHeader'] = true;
            }
        }
    }
    /**
     * Trigger action items on toggle of switch state.
     * Use correct performance data and prepare table data accordingly.
     * @param currentState currently selected switch state
     */
    onSwitchPressed(currentState) {
        var _a, _b;
        // Step 1: Save correct performance data as per switch state selected.
        if (currentState === 'off') {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.offValue]);
        }
        else {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.onValue]);
        }
        // Step 2: Get chart data processed accordingly from raw table data from BR.
        if ((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.showChart) {
            this.chartData = this.prepareChartData(this.selectedPerformanceData.tableData);
        }
        // Step 3: Get table data by processing selected performance data and current state.
        if ((_b = this.tableConfig) === null || _b === void 0 ? void 0 : _b.showTable) {
            this.tableData = this.prepareTableData(this.selectedPerformanceData, currentState);
        }
        // Step 4: Finally, update the child component - table to use the updated values.
        this.cdr.detectChanges();
    }
    /**
     * Transform table raw data into a feasible data structure as required by chart component.
     * @param tableRawMetaData table raw data from BR
     * @returns complete chart data containing name & axes data
     */
    prepareChartData(tableRawMetaData) {
        let chartData = {
            name: [],
            xAxis: [],
            yAxis: [],
        };
        tableRawMetaData === null || tableRawMetaData === void 0 ? void 0 : tableRawMetaData.forEach((tableRawData, index) => {
            var _a;
            chartData.name.push(tableRawData.name);
            chartData.yAxis.push({
                // When current plot is 'YTD' against tableRawData's iteration,
                // And config matches as 'hideYTDPlots' to be truthy; 'skip' the iteration.
                // As we want to avoid the data set for YTD to be pushed into y-axis plots.
                plots: (_a = tableRawData.data) === null || _a === void 0 ? void 0 : _a.filter((_, index) => { var _a, _b, _c; return !(((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.hideYTDPlots) && ((_c = (_b = this.categories) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'YTD'); }),
                props: {
                    type: this.chartConfig.chartType,
                    point: {
                        events: {
                            mouseOver: function () {
                                var _a;
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 0.7,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                                (_a = this.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                    opacity: 1,
                                    transition: 'opacity 0.3s ease-in-out',
                                });
                            },
                            mouseOut: function () {
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 1,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                            },
                        },
                    },
                },
            });
        });
        // Remove x-axis plot for 'ytd', if 'hideYTDPlots' to be truthy.
        chartData.xAxis = this.categories.filter((_, index) => { var _a, _b, _c; return !(((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.hideYTDPlots) && ((_c = (_b = this.categories) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'YTD'); });
        return chartData;
    }
    /**
     * Prepare complete table metadata as required.
     * Uses 'categories' for binding x-axes to table header, and, 'tableData' for y-axes (plots) to table body.
     * @param selectedPerformanceData currently selected performance data as per current switch state
     * @param currentState currently selected switch state
     */
    prepareTableData(selectedPerformanceData, currentState) {
        var _a, _b, _c;
        const headData = [];
        const bodyData = [];
        // Step 1: Add row header at first, followed by column headers to header data.
        // Step 1.1 Derive header first column label as per 'flag'.
        let firstColumnHeader;
        if ((_a = this.tableConfig) === null || _a === void 0 ? void 0 : _a.showShareClassLabelInHeader) {
            firstColumnHeader = {
                label: this.shareClass,
            };
        }
        else if ((_b = this.tableConfig) === null || _b === void 0 ? void 0 : _b.showPeriodEndLabelInHeader) {
            firstColumnHeader = {
                label: currentState === 'on' ? this.switchdata.onLabel : this.switchdata.offLabel,
                subLabel: selectedPerformanceData.asOfDate,
            };
        }
        // Step 1.2 Derive header last column label as per 'flag'.
        let lastColumnHeader;
        if ((_c = this.tableConfig) === null || _c === void 0 ? void 0 : _c.showPerformanceInceptionLabelInHeader) {
            lastColumnHeader = {
                label: 'Performance Inception Date',
            };
        }
        // Step 1.3 Finally, push all the labels in an order.
        headData.push(firstColumnHeader, ...this.categories.map((category) => {
            return {
                label: category,
            };
        }));
        if (lastColumnHeader) {
            headData.push(lastColumnHeader);
        }
        // Step 2: Add row header for every row, followed by column values to each row.
        bodyData.push(...selectedPerformanceData.tableData.map((tableDataObj) => {
            var _a;
            const rowHeaderBodyData = {
                value: tableDataObj.year || tableDataObj.name,
            };
            if (tableDataObj.footnote) {
                rowHeaderBodyData['footnote'] = tableDataObj.footnote;
            }
            const mappedPerformanceTableBodyData = [
                rowHeaderBodyData,
                ...tableDataObj.data.map((plot) => {
                    const transformedPlot = this.dashIfEmptyPipe.transform(plot) === EMDASH ? EMDASH : this.decimalPipe.transform(plot, '1.2-2');
                    return {
                        value: 
                        // Ref. Alts Prod: CP has values in % while K2 doesn't.
                        this.fundId === '92083'
                            ? transformedPlot === EMDASH
                                ? transformedPlot
                                : `${transformedPlot}%`
                            : transformedPlot,
                    };
                }),
            ];
            if ((_a = this.tableConfig) === null || _a === void 0 ? void 0 : _a.showPerformanceInceptionLabelInHeader) {
                mappedPerformanceTableBodyData.push({
                    value: tableDataObj.inceptionDate,
                });
            }
            return mappedPerformanceTableBodyData;
        }));
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabMonthlyCalendarComponent.ɵfac = function PerfTabMonthlyCalendarComponent_Factory(t) { return new (t || PerfTabMonthlyCalendarComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DashIfEmptyPipe), i0.ɵɵdirectiveInject(i3.DecimalPipe)); };
PerfTabMonthlyCalendarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabMonthlyCalendarComponent, selectors: [["ft-alts-perf-tab-monthly-calendar"]], features: [i0.ɵɵProvidersFeature([PerfTabMapperService, DashIfEmptyPipe, DecimalPipe]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "pt-monthly-calendar", 4, "ngIf"], [1, "pt-monthly-calendar"], [1, "color--ft-white", "spacing--md"], [3, "ngClass"], [1, "flex-wrap"], [1, "title--h4", "color--ft-white", "spacing--xs"], [4, "ngIf"], ["class", "spacing--lg", 4, "ngIf"], [1, "color--ft-white", "font-p", "spacing--md"], [3, "bgColor", "chartConfig", "chartData", 4, "ngIf"], [3, "tableData", "tableConfig", 4, "ngIf"], ["class", "color--ft-white", 4, "ngFor", "ngForOf"], [1, "color--ft-white"], [1, "spacing--lg"], [3, "offLabel", "onLabel", "state", "switchState"], [3, "bgColor", "chartConfig", "chartData"], [3, "tableData", "tableConfig"]], template: function PerfTabMonthlyCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabMonthlyCalendarComponent_div_0_Template, 13, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i3.NgIf, i3.NgClass, i3.NgForOf, i1.SwitchComponent, PerfChartComponent, PerfTableComponent], pipes: [i3.AsyncPipe], styles: [".pt-monthly-calendar__table-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabMonthlyCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-monthly-calendar',
                templateUrl: './perf-tab-monthly-calendar.component.html',
                styleUrls: ['./perf-tab-monthly-calendar.component.scss'],
                providers: [PerfTabMapperService, DashIfEmptyPipe, DecimalPipe],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }, { type: i1.DashIfEmptyPipe }, { type: i3.DecimalPipe }]; }, null); })();

class PerfTabMonthlyCalendarModule {
}
PerfTabMonthlyCalendarModule.ɵfac = function PerfTabMonthlyCalendarModule_Factory(t) { return new (t || PerfTabMonthlyCalendarModule)(); };
PerfTabMonthlyCalendarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabMonthlyCalendarModule });
PerfTabMonthlyCalendarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabMonthlyCalendarModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabMonthlyCalendarComponent],
                imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule],
                exports: [PerfTabMonthlyCalendarComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabMonthlyCalendarModule, { declarations: [PerfTabMonthlyCalendarComponent], imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule], exports: [PerfTabMonthlyCalendarComponent] }); })();

function PerfTabRiskMeasuresComponent_sup_5_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", footnote_r4, ",");
} }
function PerfTabRiskMeasuresComponent_sup_5_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(footnote_r4);
} }
function PerfTabRiskMeasuresComponent_sup_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, PerfTabRiskMeasuresComponent_sup_5_span_1_span_1_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(2, PerfTabRiskMeasuresComponent_sup_5_span_1_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isLastIteration_r5 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !isLastIteration_r5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isLastIteration_r5);
} }
function PerfTabRiskMeasuresComponent_sup_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtemplate(1, PerfTabRiskMeasuresComponent_sup_5_span_1_Template, 3, 2, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.tabTitleFootnotes);
} }
function PerfTabRiskMeasuresComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.asOfDate, " ");
} }
function PerfTabRiskMeasuresComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.subtitle, " ");
} }
const _c0$3 = function (a0) { return { "flex-direction--handheld": a0 }; };
const _c1$1 = function (a0) { return { "padding--none": a0 }; };
class PerfTabRiskMeasuresComponent extends PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr, dashIfEmptyPipe, decimalPipe) {
        super(responsiveService, perfTabMapperService, productConfigService, cdr);
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
        this.dashIfEmptyPipe = dashIfEmptyPipe;
        this.decimalPipe = decimalPipe;
    }
    ngOnInit() {
        super.ngOnInit();
        this.perfTabMapperService.populate('riskMeasures', this.fundId, this.shareClassCode, this.brConfig);
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for monthly calendar
     */
    mapContent(tabData) {
        super.mapContent(tabData);
        this.asOfDate = tabData.riskMeasuresMetadata.asOfDate;
        this.subtitle = tabData.riskMeasuresMetadata.subtitle;
        this.tabTitleFootnotes = ['4', '8']; // Intentionally hardcoded (ref. by prod). To be made dynamic later.
        this.statisticsTableData = this.prepareTableData(tabData.riskMeasuresMetadata.statistics);
        this.standardDeviationTableData = this.prepareTableData(tabData.riskMeasuresMetadata.standardDeviation);
        this.sharpeRatioTableData = this.prepareTableData(tabData.riskMeasuresMetadata.sharpeRatio);
        this.cdr.detectChanges();
    }
    /**
     * Prepare complete table metadata as required and return it.
     * It is compatible with all table types - statistics / standardDeviation / sharpeRatio.
     * @param tableMappings table mappings for each table types from data source
     */
    prepareTableData(tableMappings) {
        const headData = [];
        const bodyData = [];
        // Step 1: Add row header at first, followed by column headers to header data.
        const firstColumnHeader = {
            label: tableMappings.tableName,
        };
        if (tableMappings.tableNameTooltip) {
            firstColumnHeader['tooltip'] = tableMappings.tableNameTooltip;
        }
        headData.push(firstColumnHeader, ...tableMappings.categories.map((category) => {
            return {
                label: category,
            };
        }));
        // Step 2: Add row header for every row, followed by column values to each row.
        tableMappings.body.forEach((rowData) => {
            const rowHeader = {
                value: rowData.rowName,
            };
            if (rowData.rowNamefootnote) {
                rowHeader['footnote'] = rowData.rowNamefootnote;
            }
            if (rowData.rowNameTooltip) {
                rowHeader['tooltip'] = rowData.rowNameTooltip;
            }
            bodyData.push([
                rowHeader,
                ...rowData.columnValues.map((columnValue) => {
                    return {
                        value: String(this.dashIfEmptyPipe.transform(columnValue) === EMDASH
                            ? columnValue
                            : this.decimalPipe.transform(columnValue, '1.2-2')),
                    };
                }),
            ]);
        });
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabRiskMeasuresComponent.ɵfac = function PerfTabRiskMeasuresComponent_Factory(t) { return new (t || PerfTabRiskMeasuresComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DashIfEmptyPipe), i0.ɵɵdirectiveInject(i3.DecimalPipe)); };
PerfTabRiskMeasuresComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabRiskMeasuresComponent, selectors: [["ft-alts-perf-tab-risk-measures"]], features: [i0.ɵɵProvidersFeature([PerfTabMapperService, DashIfEmptyPipe, DecimalPipe]), i0.ɵɵInheritDefinitionFeature], decls: 18, vars: 22, consts: [[1, "pt-risk-measures"], ["id", "tab-header", 1, "color--ft-white", "spacing--md"], [1, "flex-wrap"], [1, "title--h4", "color--ft-white", "spacing--xxs"], [4, "ngIf"], ["class", "color--ft-white font-p spacing--s", 4, "ngIf"], [1, "pt-risk-measures__tables", "spacing--lg", 3, "ngClass"], [1, "spacing--xs", 3, "ngClass"], [3, "tableData"], [3, "ngClass"], [1, "spacing--xs"], ["class", "color--ft-white", 4, "ngFor", "ngForOf"], [1, "color--ft-white"], [1, "color--ft-white", "font-p", "spacing--s"]], template: function PerfTabRiskMeasuresComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h2", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, PerfTabRiskMeasuresComponent_sup_5_Template, 2, 1, "sup", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, PerfTabRiskMeasuresComponent_p_6_Template, 2, 1, "p", 5);
        i0.ɵɵtemplate(7, PerfTabRiskMeasuresComponent_p_7_Template, 2, 1, "p", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵpipe(9, "async");
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵpipe(11, "async");
        i0.ɵɵelement(12, "ft-alts-perf-table", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵpipe(14, "async");
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵelement(16, "ft-alts-perf-table", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "ft-alts-perf-table", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.tabTitle, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.tabTitleFootnotes == null ? null : ctx.tabTitleFootnotes.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.asOfDate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subtitle);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c0$3, i0.ɵɵpipeBind1(9, 10, ctx.isHandheld$)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c1$1, i0.ɵɵpipeBind1(11, 12, ctx.isHandheld$)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tableData", ctx.statisticsTableData);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c1$1, i0.ɵɵpipeBind1(14, 14, ctx.isHandheld$)));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("tableData", ctx.standardDeviationTableData);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("tableData", ctx.sharpeRatioTableData);
    } }, directives: [i3.NgIf, i3.NgClass, PerfTableComponent, i3.NgForOf], pipes: [i3.AsyncPipe], styles: [".pt-risk-measures__tables[_ngcontent-%COMP%]{display:flex;justify-content:space-between;flex-direction:row}.pt-risk-measures__tables[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.pt-risk-measures__tables[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:first-child{padding-right:.75rem}.pt-risk-measures__tables[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:last-child{padding-left:.75rem}.pt-risk-measures__tables[_ngcontent-%COMP%] > div.padding--none[_ngcontent-%COMP%]{padding:0!important}.pt-risk-measures__tables.flex-direction--handheld[_ngcontent-%COMP%]{flex-direction:column}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabRiskMeasuresComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-risk-measures',
                templateUrl: './perf-tab-risk-measures.component.html',
                styleUrls: ['./perf-tab-risk-measures.component.scss'],
                providers: [PerfTabMapperService, DashIfEmptyPipe, DecimalPipe],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }, { type: i1.DashIfEmptyPipe }, { type: i3.DecimalPipe }]; }, null); })();

class PerfTabRiskMeasuresModule {
}
PerfTabRiskMeasuresModule.ɵfac = function PerfTabRiskMeasuresModule_Factory(t) { return new (t || PerfTabRiskMeasuresModule)(); };
PerfTabRiskMeasuresModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabRiskMeasuresModule });
PerfTabRiskMeasuresModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, PerfTableModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabRiskMeasuresModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabRiskMeasuresComponent],
                imports: [CommonModule, PerfTableModule],
                exports: [PerfTabRiskMeasuresComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabRiskMeasuresModule, { declarations: [PerfTabRiskMeasuresComponent], imports: [CommonModule, PerfTableModule], exports: [PerfTabRiskMeasuresComponent] }); })();

function PerfTabTotalReturnsComponent_div_0_sup_7_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", footnote_r7, ",");
} }
function PerfTabTotalReturnsComponent_div_0_sup_7_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(footnote_r7);
} }
function PerfTabTotalReturnsComponent_div_0_sup_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, PerfTabTotalReturnsComponent_div_0_sup_7_span_1_span_1_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(2, PerfTabTotalReturnsComponent_div_0_sup_7_span_1_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isLastIteration_r8 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !isLastIteration_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isLastIteration_r8);
} }
function PerfTabTotalReturnsComponent_div_0_sup_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtemplate(1, PerfTabTotalReturnsComponent_div_0_sup_7_span_1_Template, 3, 2, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.tabTitleFootnotes);
} }
function PerfTabTotalReturnsComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "ft-alts-switch", 14);
    i0.ɵɵlistener("switchState", function PerfTabTotalReturnsComponent_div_0_div_8_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r2.switchdata.offLabel)("onLabel", ctx_r2.switchdata.onLabel)("state", ctx_r2.switchdata.state);
} }
function PerfTabTotalReturnsComponent_div_0_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectedPerformanceData.asOfDate, " ");
} }
function PerfTabTotalReturnsComponent_div_0_ft_alts_perf_chart_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-chart", 16);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("bgColor", ctx_r4.bgColor)("chartConfig", ctx_r4.chartConfig)("chartData", ctx_r4.chartData);
} }
function PerfTabTotalReturnsComponent_div_0_ft_alts_perf_table_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-table", 17);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tableData", ctx_r5.tableData)("tableConfig", ctx_r5.tableConfig);
} }
const _c0$2 = function (a0) { return { "pt-total-returns__chart-header": a0 }; };
function PerfTabTotalReturnsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "h2", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PerfTabTotalReturnsComponent_div_0_sup_7_Template, 2, 1, "sup", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PerfTabTotalReturnsComponent_div_0_div_8_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PerfTabTotalReturnsComponent_div_0_p_9_Template, 2, 1, "p", 8);
    i0.ɵɵtemplate(10, PerfTabTotalReturnsComponent_div_0_ft_alts_perf_chart_10_Template, 1, 3, "ft-alts-perf-chart", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PerfTabTotalReturnsComponent_div_0_ft_alts_perf_table_11_Template, 1, 2, "ft-alts-perf-table", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$2, !i0.ɵɵpipeBind1(3, 7, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tabTitleFootnotes == null ? null : ctx_r0.tabTitleFootnotes.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && ctx_r0.showSwitchButton && ctx_r0.switchdata);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showTitleAsOfDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && (ctx_r0.chartConfig == null ? null : ctx_r0.chartConfig.showChart) && ctx_r0.chartData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tableConfig == null ? null : ctx_r0.tableConfig.showTable);
} }
class PerfTabTotalReturnsComponent extends PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr, dashIfEmptyPipe, decimalPipe) {
        super(responsiveService, perfTabMapperService, productConfigService, cdr);
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
        this.dashIfEmptyPipe = dashIfEmptyPipe;
        this.decimalPipe = decimalPipe;
        this.showSwitchButton = false;
        this.showTitleAsOfDate = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.perfTabMapperService.populate('totalReturns', this.fundId, this.shareClassCode, this.brConfig);
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for average annual
     */
    mapContent(tabData) {
        super.mapContent(tabData);
        // Assign chart config only when its available, else let it be 'empty' as initialized, for tooltip options below.
        if (tabData.chartConfig) {
            this.chartConfig = tabData.chartConfig;
        }
        // Assign necessary chart & table configurations based upon fund loaded.
        this.mapConfigs();
        if (this.performanceMetadata) {
            this.onSwitchPressed(this.switchdata.state);
        }
    }
    /**
     * Map the necessary fund based config here.
     */
    mapConfigs() {
        // Fetch all the available fund id list.
        const availableFundIds = PERF_CONFIG.FUND_IDS;
        switch (this.fundId) {
            case '41056':
            case '29429': {
                this.chartConfig['showChart'] = true;
                this.tableConfig['showTable'] = true;
                this.chartConfig['columnWidth'] = 32;
                this.showSwitchButton = true;
                this.showTitleAsOfDate = true;
                break;
            }
        }
    }
    /**
     * Trigger action items on toggle of switch state.
     * Use correct performance data and prepare chart & table data accordingly.
     * @param currentState currently seleted switch state
     */
    onSwitchPressed(currentState) {
        // Step 1: Save correct performance data as per switch state selected.
        if (currentState === 'off') {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.offValue]);
        }
        else {
            this.selectedPerformanceData = cloneDeep(this.performanceMetadata[this.switchdata.onValue]);
        }
        // Step 2: Get chart data processed accordingly.
        this.chartData = this.prepareChartData(this.selectedPerformanceData.chartData);
        // Step 3: Get table data by processing updated chart data and other details from selected performance data.
        this.tableData = this.prepareTableData(this.chartData, this.selectedPerformanceData.asOfDate, this.selectedPerformanceData.sinceInceptionDate, currentState);
        // Step 4: Finally, update the child components - chart & table to use the updated values.
        this.cdr.detectChanges();
    }
    /**
     * Transform chart raw data into a feasible data structure as required by chart component.
     * @param chartRawMetaData
     * @returns complete chart data containing name & axes data.
     */
    prepareChartData(chartRawMetaData) {
        let chartData = {
            name: [],
            xAxis: [],
            yAxis: [],
        };
        chartRawMetaData === null || chartRawMetaData === void 0 ? void 0 : chartRawMetaData.forEach((chartRawData) => {
            chartData.name.push(chartRawData.class);
            chartData.yAxis.push({
                plots: chartRawData.data,
                props: {
                    dataLabels: {
                        enabled: this.chartConfig.chartType === 'column' ? true : false,
                    },
                    type: this.chartConfig.chartType,
                    point: {
                        events: {
                            mouseOver: function () {
                                var _a;
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 0.7,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                                (_a = this.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                    opacity: 1,
                                    transition: 'opacity 0.3s ease-in-out',
                                });
                            },
                            mouseOut: function () {
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 1,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                            },
                        },
                    },
                },
            });
        });
        chartData.xAxis = this.categories;
        return chartData;
    }
    /**
     * Prepare complete table metadata as required.
     * Uses chart data for binding x-axes (categories) to table header, and, y-axes (plots) to table body.
     * @param chartData updated chart data
     * @param asOfDate as of date as per selected performance data
     * @param sinceInceptionDate since inception data as per selected performance data
     * @param currentState currently seleted switch state
     * @returns complete table metadata containing head & body values
     */
    prepareTableData(chartData, asOfDate, sinceInceptionDate, currentState) {
        var _a;
        const headData = [];
        const bodyData = [];
        // Step 1: Add row headers for table header & table body initially.
        headData.push({
            // Show "fund name" as label if core/capped sma, else "period end" toggle type.
            label: ['cofdascore', 'cofdascorecap', 'cofdasdynamic'].includes((_a = this.fundId) === null || _a === void 0 ? void 0 : _a.toLowerCase())
                ? this.fundName
                : currentState === 'on'
                    ? this.switchdata.onLabel
                    : this.switchdata.offLabel,
            subLabel: asOfDate,
        });
        chartData.yAxis.forEach((plots, index) => {
            // Take care of multiple rows in a body through "array of objects" push, if present.
            bodyData.push([
                this.selectedPerformanceData.chartData[index].footnote
                    ? {
                        value: chartData.name[index],
                        footnote: this.selectedPerformanceData.chartData[index].footnote,
                    }
                    : {
                        value: chartData.name[index],
                    },
            ]);
        });
        // Step 2: Add remaining column data for table header & table body.
        headData.push(...chartData.xAxis.map((category, index) => {
            if (index === chartData.xAxis.length - 1) {
                return {
                    label: category,
                    subLabel: sinceInceptionDate,
                };
            }
            return {
                label: category,
            };
        }));
        chartData.yAxis.forEach((yAxisObj, index) => {
            // Take care of multiple rows in a body through 'index', if present.
            bodyData[index].push(...yAxisObj.plots.map((plot) => {
                return {
                    value: this.dashIfEmptyPipe.transform(plot) === EMDASH
                        ? plot
                        : // Replace '%' from data set, if present.
                            // Calculate the expected result from decimal pipe and again append '%'.
                            String(plot).includes('%')
                                ? `${this.decimalPipe.transform(String(plot).replace('%', ''), '1.2-2')}%`
                                : this.decimalPipe.transform(plot, '1.2-2'),
                };
            }));
        });
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabTotalReturnsComponent.ɵfac = function PerfTabTotalReturnsComponent_Factory(t) { return new (t || PerfTabTotalReturnsComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DashIfEmptyPipe), i0.ɵɵdirectiveInject(i3.DecimalPipe)); };
PerfTabTotalReturnsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabTotalReturnsComponent, selectors: [["ft-alts-perf-tab-total-returns"]], features: [i0.ɵɵProvidersFeature([PerfTabMapperService, DashIfEmptyPipe, DecimalPipe]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "pt-total-returns", 4, "ngIf"], [1, "pt-total-returns"], [1, "color--ft-white", "spacing--md"], [3, "ngClass"], [1, "flex-wrap"], [1, "title--h4", "color--ft-white", "spacing--xs"], [4, "ngIf"], ["class", "spacing--lg", 4, "ngIf"], ["class", "color--ft-white font-p spacing--md", 4, "ngIf"], [3, "bgColor", "chartConfig", "chartData", 4, "ngIf"], [3, "tableData", "tableConfig", 4, "ngIf"], ["class", "color--ft-white", 4, "ngFor", "ngForOf"], [1, "color--ft-white"], [1, "spacing--lg"], [3, "offLabel", "onLabel", "state", "switchState"], [1, "color--ft-white", "font-p", "spacing--md"], [3, "bgColor", "chartConfig", "chartData"], [3, "tableData", "tableConfig"]], template: function PerfTabTotalReturnsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabTotalReturnsComponent_div_0_Template, 12, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i3.NgIf, i3.NgClass, i3.NgForOf, i1.SwitchComponent, PerfChartComponent, PerfTableComponent], pipes: [i3.AsyncPipe], styles: [".pt-total-returns__chart-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabTotalReturnsComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-total-returns',
                templateUrl: './perf-tab-total-returns.component.html',
                styleUrls: ['./perf-tab-total-returns.component.scss'],
                providers: [PerfTabMapperService, DashIfEmptyPipe, DecimalPipe],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }, { type: i1.DashIfEmptyPipe }, { type: i3.DecimalPipe }]; }, null); })();

class PerfTabTotalReturnsModule {
}
PerfTabTotalReturnsModule.ɵfac = function PerfTabTotalReturnsModule_Factory(t) { return new (t || PerfTabTotalReturnsModule)(); };
PerfTabTotalReturnsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabTotalReturnsModule });
PerfTabTotalReturnsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, SwitchModule, PerfChartModule, PerfTableModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabTotalReturnsModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabTotalReturnsComponent],
                imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule],
                exports: [PerfTabTotalReturnsComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabTotalReturnsModule, { declarations: [PerfTabTotalReturnsComponent], imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule], exports: [PerfTabTotalReturnsComponent] }); })();

function PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", footnote_r6, ",");
} }
function PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(footnote_r6);
} }
function PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_span_1_span_1_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(2, PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_span_1_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isLastIteration_r7 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !isLastIteration_r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isLastIteration_r7);
} }
function PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtemplate(1, PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_span_1_Template, 3, 2, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.tabTitleFootnotes);
} }
function PerfTabDiscreteAverageAnnualComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "ft-alts-switch", 14);
    i0.ɵɵlistener("switchState", function PerfTabDiscreteAverageAnnualComponent_div_0_div_8_Template_ft_alts_switch_switchState_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.onSwitchPressed($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("offLabel", ctx_r2.switchdata.offLabel)("onLabel", ctx_r2.switchdata.onLabel)("state", ctx_r2.switchdata.state);
} }
function PerfTabDiscreteAverageAnnualComponent_div_0_ft_alts_perf_chart_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-chart", 15);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("bgColor", ctx_r3.bgColor)("chartConfig", ctx_r3.chartConfig)("chartData", ctx_r3.chartData);
} }
function PerfTabDiscreteAverageAnnualComponent_div_0_ft_alts_perf_table_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-perf-table", 16);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tableData", ctx_r4.tableData)("tableConfig", ctx_r4.tableConfig);
} }
const _c0$1 = function (a0) { return { "pt-monthly-calendar__table-header": a0 }; };
function PerfTabDiscreteAverageAnnualComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "h2", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PerfTabDiscreteAverageAnnualComponent_div_0_sup_7_Template, 2, 1, "sup", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PerfTabDiscreteAverageAnnualComponent_div_0_div_8_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 8);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PerfTabDiscreteAverageAnnualComponent_div_0_ft_alts_perf_chart_11_Template, 1, 3, "ft-alts-perf-chart", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, PerfTabDiscreteAverageAnnualComponent_div_0_ft_alts_perf_table_12_Template, 1, 2, "ft-alts-perf-table", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$1, !i0.ɵɵpipeBind1(3, 7, ctx_r0.isHandheld$)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.tabTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tabTitleFootnotes == null ? null : ctx_r0.tabTitleFootnotes.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && ctx_r0.switchdata);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedPerformanceData.asOfDate, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showChart && (ctx_r0.chartConfig == null ? null : ctx_r0.chartConfig.showChart) && ctx_r0.chartData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tableConfig == null ? null : ctx_r0.tableConfig.showTable);
} }
class PerfTabDiscreteAverageAnnualComponent extends PerfTabBaseComponent {
    constructor(responsiveService, perfTabMapperService, productConfigService, cdr, dashIfEmptyPipe, decimalPipe) {
        super(responsiveService, perfTabMapperService, productConfigService, cdr);
        this.responsiveService = responsiveService;
        this.perfTabMapperService = perfTabMapperService;
        this.productConfigService = productConfigService;
        this.cdr = cdr;
        this.dashIfEmptyPipe = dashIfEmptyPipe;
        this.decimalPipe = decimalPipe;
    }
    ngOnInit() {
        super.ngOnInit();
        this.perfTabMapperService.populate('discreteAnnualPerformance', this.fundId, this.shareClassCode, this.brConfig);
    }
    /**
     * Map BR product raw response to component variables.
     * @param tabData performance tab content for monthly calendar
     */
    mapContent(tabData) {
        super.mapContent(tabData);
        // Assign chart config only when its available, else let it be 'empty' as initialized.
        if (tabData.chartConfig) {
            this.chartConfig = tabData.chartConfig;
        }
        // Assign necessary chart & table configurations based upon fund loaded.
        this.mapConfigs();
        if (this.performanceMetadata) {
            this.onSwitchPressed(this.switchdata.state);
        }
    }
    /**
     * Map the necessary fund based config here.
     */
    mapConfigs() {
        var _a, _b, _c;
        // Fetch all the available fund id list.
        const availableFundIds = PERF_CONFIG.FUND_IDS;
        const tabTitle = (_c = (_b = (_a = this.brConfig) === null || _a === void 0 ? void 0 : _a.tabTitle) === null || _b === void 0 ? void 0 : _b.monthlyCalendar) === null || _c === void 0 ? void 0 : _c[this.fundId];
        switch (this.fundId) {
            case '18896': {
                this.tabTitle = tabTitle || 'Discrete Annual Performance';
                this.chartConfig['showChart'] = true;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showShareClassLabelInHeader'] = true;
                break;
            }
            case '31292': {
                this.tabTitle = tabTitle || 'Discrete Annual Performance';
                this.chartConfig['showChart'] = true;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showShareClassLabelInHeader'] = true;
                break;
            }
            case '31293': {
                this.tabTitle = tabTitle || 'Discrete Annual Performance';
                this.chartConfig['showChart'] = true;
                this.tableConfig['showTable'] = true;
                this.tableConfig['showShareClassLabelInHeader'] = true;
                break;
            }
        }
    }
    /**
     * Trigger action items on toggle of switch state.
     * Use correct performance data and prepare table data accordingly.
     * @param currentState currently selected switch state
     */
    onSwitchPressed(currentState) {
        var _a, _b;
        // Step 1: Save correct performance data as per switch state selected.
        if (currentState === 'off') {
            this.selectedPerformanceData = cloneDeep$1(this.performanceMetadata[this.switchdata.offValue]);
        }
        else {
            this.selectedPerformanceData = cloneDeep$1(this.performanceMetadata[this.switchdata.onValue]);
        }
        // Step 2: Get chart data processed accordingly from raw table data from BR.
        if ((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.showChart) {
            this.chartData = this.prepareChartData(this.selectedPerformanceData.tableData);
        }
        // Step 3: Get table data by processing selected performance data and current state.
        if ((_b = this.tableConfig) === null || _b === void 0 ? void 0 : _b.showTable) {
            this.tableData = this.prepareTableData(this.selectedPerformanceData, currentState);
        }
        // Step 4: Finally, update the child component - table to use the updated values.
        this.cdr.detectChanges();
    }
    /**
     * Transform table raw data into a feasible data structure as required by chart component.
     * @param tableRawMetaData table raw data from BR
     * @returns complete chart data containing name & axes data
     */
    prepareChartData(tableRawMetaData) {
        let chartData = {
            name: [],
            xAxis: [],
            yAxis: [],
        };
        tableRawMetaData === null || tableRawMetaData === void 0 ? void 0 : tableRawMetaData.forEach((tableRawData, index) => {
            var _a;
            chartData.name.push(tableRawData.name);
            chartData.yAxis.push({
                // When current plot is 'YTD' against tableRawData's iteration,
                // And config matches as 'hideYTDPlots' to be truthy; 'skip' the iteration.
                // As we want to avoid the data set for YTD to be pushed into y-axis plots.
                plots: (_a = tableRawData.data) === null || _a === void 0 ? void 0 : _a.filter((_, index) => { var _a, _b; return !(((_b = (_a = this.categories) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'CURRENCY'); }),
                props: {
                    type: this.chartConfig.chartType,
                    point: {
                        events: {
                            mouseOver: function () {
                                var _a;
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 0.7,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                                (_a = this.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                    opacity: 1,
                                    transition: 'opacity 0.3s ease-in-out',
                                });
                            },
                            mouseOut: function () {
                                const series = this.series;
                                series.points.forEach((point) => {
                                    var _a;
                                    (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.css({
                                        opacity: 1,
                                        transition: 'opacity 0.3s ease-in-out',
                                    });
                                });
                            },
                        },
                    },
                },
            });
        });
        // Remove x-axis plot for 'ytd', if 'hideYTDPlots' to be truthy.
        chartData.xAxis = this.categories.filter((_, index) => { var _a, _b; return !(((_b = (_a = this.categories) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'CURRENCY'); });
        return chartData;
    }
    /**
     * Prepare complete table metadata as required.
     * Uses 'categories' for binding x-axes to table header, and, 'tableData' for y-axes (plots) to table body.
     * @param selectedPerformanceData currently selected performance data as per current switch state
     * @param currentState currently selected switch state
     */
    prepareTableData(selectedPerformanceData, currentState) {
        var _a, _b, _c;
        const headData = [];
        const bodyData = [];
        // Step 1: Add row header at first, followed by column headers to header data.
        // Step 1.1 Derive header first column label as per 'flag'.
        let firstColumnHeader;
        if ((_a = this.tableConfig) === null || _a === void 0 ? void 0 : _a.showShareClassLabelInHeader) {
            firstColumnHeader = {
                label: this.shareClass,
            };
        }
        else if ((_b = this.tableConfig) === null || _b === void 0 ? void 0 : _b.showPeriodEndLabelInHeader) {
            firstColumnHeader = {
                label: currentState === 'on' ? this.switchdata.onLabel : this.switchdata.offLabel,
                subLabel: selectedPerformanceData.asOfDate,
            };
        }
        // Step 1.2 Derive header last column label as per 'flag'.
        let lastColumnHeader;
        if ((_c = this.tableConfig) === null || _c === void 0 ? void 0 : _c.showPerformanceInceptionLabelInHeader) {
            lastColumnHeader = {
                label: 'Performance Inception Date',
            };
        }
        // Step 1.3 Finally, push all the labels in an order.
        headData.push(firstColumnHeader, ...this.categories.map((category) => {
            return {
                label: category,
            };
        }));
        if (lastColumnHeader) {
            headData.push(lastColumnHeader);
        }
        // Step 2: Add row header for every row, followed by column values to each row.
        bodyData.push(...selectedPerformanceData.tableData.map((tableDataObj) => {
            var _a;
            const rowHeaderBodyData = {
                value: tableDataObj.year || tableDataObj.name,
            };
            if (tableDataObj.footnote) {
                rowHeaderBodyData['footnote'] = tableDataObj.footnote;
            }
            const mappedPerformanceTableBodyData = [
                rowHeaderBodyData,
                ...tableDataObj.data.map((plot) => {
                    let transformedPlot;
                    if (typeof plot === "string") {
                        transformedPlot = plot;
                    }
                    else {
                        transformedPlot = this.dashIfEmptyPipe.transform(plot) === EMDASH ? EMDASH : this.decimalPipe.transform(plot, '1.2-2');
                    }
                    return {
                        value: transformedPlot,
                    };
                }),
            ];
            if ((_a = this.tableConfig) === null || _a === void 0 ? void 0 : _a.showPerformanceInceptionLabelInHeader) {
                mappedPerformanceTableBodyData.push({
                    value: tableDataObj.inceptionDate,
                });
            }
            return mappedPerformanceTableBodyData;
        }));
        // Step 3: Finally, return both head and body data.
        return {
            head: headData,
            body: bodyData,
        };
    }
}
PerfTabDiscreteAverageAnnualComponent.ɵfac = function PerfTabDiscreteAverageAnnualComponent_Factory(t) { return new (t || PerfTabDiscreteAverageAnnualComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(PerfTabMapperService), i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DashIfEmptyPipe), i0.ɵɵdirectiveInject(i3.DecimalPipe)); };
PerfTabDiscreteAverageAnnualComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfTabDiscreteAverageAnnualComponent, selectors: [["ft-alts-perf-tab-discrete-average-annual"]], features: [i0.ɵɵProvidersFeature([PerfTabMapperService, DashIfEmptyPipe, DecimalPipe]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "pt-monthly-calendar", 4, "ngIf"], [1, "pt-monthly-calendar"], [1, "color--ft-white", "spacing--md"], [3, "ngClass"], [1, "flex-wrap"], [1, "title--h4", "color--ft-white", "spacing--xs"], [4, "ngIf"], ["class", "spacing--lg", 4, "ngIf"], [1, "color--ft-white", "font-p", "spacing--md"], [3, "bgColor", "chartConfig", "chartData", 4, "ngIf"], [3, "tableData", "tableConfig", 4, "ngIf"], ["class", "color--ft-white", 4, "ngFor", "ngForOf"], [1, "color--ft-white"], [1, "spacing--lg"], [3, "offLabel", "onLabel", "state", "switchState"], [3, "bgColor", "chartConfig", "chartData"], [3, "tableData", "tableConfig"]], template: function PerfTabDiscreteAverageAnnualComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerfTabDiscreteAverageAnnualComponent_div_0_Template, 13, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedPerformanceData);
    } }, directives: [i3.NgIf, i3.NgClass, i3.NgForOf, i1.SwitchComponent, PerfChartComponent, PerfTableComponent], pipes: [i3.AsyncPipe], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabDiscreteAverageAnnualComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-tab-discrete-average-annual',
                templateUrl: './perf-tab-discrete-average-annual.component.html',
                styleUrls: ['./perf-tab-discrete-average-annual.component.scss'],
                providers: [PerfTabMapperService, DashIfEmptyPipe, DecimalPipe],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: PerfTabMapperService }, { type: i1.ProductsConfigService }, { type: i0.ChangeDetectorRef }, { type: i1.DashIfEmptyPipe }, { type: i3.DecimalPipe }]; }, null); })();

class PerfTabDiscreteAverageAnnualModule {
}
PerfTabDiscreteAverageAnnualModule.ɵfac = function PerfTabDiscreteAverageAnnualModule_Factory(t) { return new (t || PerfTabDiscreteAverageAnnualModule)(); };
PerfTabDiscreteAverageAnnualModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfTabDiscreteAverageAnnualModule });
PerfTabDiscreteAverageAnnualModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule, PipesModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfTabDiscreteAverageAnnualModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfTabDiscreteAverageAnnualComponent],
                imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule, PipesModule],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfTabDiscreteAverageAnnualModule, { declarations: [PerfTabDiscreteAverageAnnualComponent], imports: [CommonModule, SwitchModule, PerfChartModule, PerfTableModule, DirectivesModule, PipesModule] }); })();

function PerfFooterComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const caveat_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", caveat_r3, " ");
} }
function PerfFooterComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "a", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r1.disclaimer.href, i0.ɵɵsanitizeUrl)("target", ctx_r1.disclaimer.target);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.disclaimer.text, " ");
} }
const _c0 = function (a0) { return { "perf-footer__section__cta-bg--mobile": a0 }; };
const _c1 = function (a0) { return { "width--max": a0 }; };
function PerfFooterComponent_section_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 8);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵelement(5, "img", 12);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 13);
    i0.ɵɵelementStart(8, "div", 14);
    i0.ɵɵelementStart(9, "h2", 15);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p", 16);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "ft-alts-button", 17);
    i0.ɵɵlistener("buttonClicked", function PerfFooterComponent_section_4_Template_ft_alts_button_buttonClicked_13_listener() { return null; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, i0.ɵɵpipeBind1(2, 8, ctx_r2.isHandheld$)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("src", ctx_r2.ctaBannerImage == null ? null : ctx_r2.ctaBannerImage.path, i0.ɵɵsanitizeUrl)("alt", ctx_r2.ctaBannerImage == null ? null : ctx_r2.ctaBannerImage.altText)("ngClass", i0.ɵɵpureFunction1(14, _c1, i0.ɵɵpipeBind1(6, 10, ctx_r2.isHandheld$)));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r2.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.subTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("link", ctx_r2.actionButton)("variant", "v2");
} }
/**
 * ********************************************** SIMPLE CONFIGURATION **********************************************
 * The 'fields' listed against the "fund ids" as per their 'order' will decide the rows visibility in the table body.
 * ******************************************************************************************************************
 */
const FUND_ID_CHARGES_MAPPING = {
    // CP
    '92083': ['performanceFee'],
    // BSP
    '29429': [
        'expenseRatioGross',
        'expenseRatioNet',
        'maximumInitialCharge',
        'cdsc',
        'managementFee',
    ],
    // K2
    '18120': [
        'expenseRatioGross',
        'expenseRatioNet',
        'maximumInitialCharge',
        'cdsc',
        'managementFee',
    ],
};
class PerfFooterComponent {
    constructor(responsiveService, productSnapshotService) {
        this.responsiveService = responsiveService;
        this.productSnapshotService = productSnapshotService;
        this.unsubscribe$ = new Subject();
    }
    ngOnInit() {
        this.isHandheld$ = this.responsiveService.isHandheld$();
        const document = getModelFromRef(this.page, this.component, 'document');
        if (document) {
            this.mapContent(document);
        }
    }
    /**
     * Map BR content to component variables.
     * @param document the valid BR document having footer content
     */
    mapContent(document) {
        var _a;
        const { caveats, tableData, disclaimer, ctaBannerImage, title, subTitle, actionButton, } = JSON.parse((_a = document.getData()) === null || _a === void 0 ? void 0 : _a.json);
        this.caveats = caveats;
        this.disclaimer = disclaimer;
        this.ctaBannerImage = ctaBannerImage;
        this.title = title;
        this.subTitle = subTitle;
        this.actionButton = actionButton;
        // DCE-1526 Made table data fetched from BR.
        this.tableData = tableData; // TODO: REMOVE IT ONCE PDS FIELDS AND BR LABELS ARE READY.
        // Prepare the table data from PDS product data as available and pass it accordingly.
        // this.populateTableData(); // TODO: UNCOMMENT THIS ONCE ABOVE ASSIGNMENT IS REMOVED.
    }
    /**
     * Fetch the PDS charges data for all share classes and map it to the table object accordingly.
     */
    populateTableData() {
        this.productSnapshotService
            .getProductDetails$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((product) => {
            var _a;
            // Step 1: Sort the share classes alphabetically as per their share class name.
            const sortedShareClasses = ((_a = product === null || product === void 0 ? void 0 : product.shareClasses) === null || _a === void 0 ? void 0 : _a.length)
                ? product.shareClasses.sort((curr, next) => curr.shareClassName.localeCompare(next.shareClassName))
                : [];
            // Step 2: Assign the table head and body details accordingly.
            this.tableData = {
                head: [
                    // Step 2.1: First column header will be table name.
                    {
                        label: 'Sales Charges, Expenses & Fees', // TODO: Make it fetch from translation as a label.
                    },
                    // Step 2.2: Rest follows with the share class name as the column header.
                    ...sortedShareClasses.map((shareClass) => {
                        return {
                            label: shareClass.shareClassName,
                        };
                    }),
                ],
                body: 
                // Step 2.3: Iterate through each 'charges' field listed in 'mappings' const above for currently loaded fund 'fundId'.
                FUND_ID_CHARGES_MAPPING[product.fundId].map((charge) => {
                    return [
                        // Step 2.4: For each iterated charges, row header will be its own name.
                        {
                            value: charge, // TODO: Make it fetch from translation as a label.
                        },
                        // Step 2.5: Rest row cell will be having iterated charges value for each share class as a column.
                        ...sortedShareClasses.map((shareClass) => {
                            var _a;
                            return {
                                value: (_a = shareClass.charges) === null || _a === void 0 ? void 0 : _a[charge],
                            };
                        }),
                    ];
                }),
            };
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.complete();
    }
}
PerfFooterComponent.ɵfac = function PerfFooterComponent_Factory(t) { return new (t || PerfFooterComponent)(i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(i1$1.ProductSnapshotService)); };
PerfFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerfFooterComponent, selectors: [["ft-alts-perf-footer"]], inputs: { component: "component", page: "page" }, decls: 5, vars: 4, consts: [[1, "color--ft-white", "spacing--md", "perf-footer"], ["class", "font-p--b", 4, "ngFor", "ngForOf"], [3, "tableData"], ["class", "padding-top--xs", 4, "ngIf"], ["class", "grid perf-footer__section", 4, "ngIf"], [1, "font-p--b"], [1, "padding-top--xs"], [1, "font-link-underline", "color--ft-white", 3, "href", "target"], [1, "grid", "perf-footer__section"], [1, "row", "perf-footer__section__cta-bg", 3, "ngClass"], [1, "col", "l4", "m8", "s4", "perf-footer__section__col-left"], [1, "perf-footer__section__col-left__content"], [3, "src", "alt", "ngClass"], [1, "col", "l6", "m8", "s4"], [1, "perf-footer__section__col-right__content"], [1, "title--h3", "spacing--md"], [1, "spacing--md", "font-p-lrg"], [3, "link", "variant", "buttonClicked"]], template: function PerfFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PerfFooterComponent_p_1_Template, 2, 1, "p", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "ft-alts-perf-table", 2);
        i0.ɵɵtemplate(3, PerfFooterComponent_div_3_Template, 3, 3, "div", 3);
        i0.ɵɵtemplate(4, PerfFooterComponent_section_4_Template, 14, 16, "section", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.caveats);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("tableData", ctx.tableData);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.disclaimer == null ? null : ctx.disclaimer.text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.title);
    } }, directives: [i3.NgForOf, PerfTableComponent, i3.NgIf, i3.NgClass, i1.ButtonComponent], pipes: [i3.AsyncPipe], styles: [".perf-footer[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:not(:last-child){margin-bottom:1.2em}.perf-footer__section[_ngcontent-%COMP%]{margin:0!important;padding-top:var(--space-xl)}.perf-footer__section__cta-bg[_ngcontent-%COMP%]{padding-top:var(--space-lg);background:var(--ft-gradient-transparent-to-purple-v2);flex-direction:row}.perf-footer__section__cta-bg--mobile[_ngcontent-%COMP%]{flex-direction:column-reverse}.perf-footer__section__col-left[_ngcontent-%COMP%]{margin-bottom:calc(-1 * var(--space-s))}.perf-footer__section__col-left__content[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:flex-end;height:100%}.perf-footer__section__col-left__content[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:344px;height:auto;object-fit:cover;vertical-align:bottom}.perf-footer__section__col-right[_ngcontent-%COMP%]{text-align:left}.perf-footer__section__col-right__content[_ngcontent-%COMP%]{height:100%;display:flex;margin:0;padding-bottom:var(--space-lg);justify-content:center;flex-direction:column;color:var(--ft-white)}.width--max[_ngcontent-%COMP%]{max-width:100%!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfFooterComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-perf-footer',
                templateUrl: './perf-footer.component.html',
                styleUrls: ['./perf-footer.component.scss'],
            }]
    }], function () { return [{ type: i1.ResponsiveService }, { type: i1$1.ProductSnapshotService }]; }, { component: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class PerfFooterModule {
}
PerfFooterModule.ɵfac = function PerfFooterModule_Factory(t) { return new (t || PerfFooterModule)(); };
PerfFooterModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerfFooterModule });
PerfFooterModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, PerfTableModule, ButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerfFooterModule, [{
        type: NgModule,
        args: [{
                declarations: [PerfFooterComponent],
                imports: [CommonModule, PerfTableModule, ButtonModule],
                exports: [PerfFooterComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PerfFooterModule, { declarations: [PerfFooterComponent], imports: [CommonModule, PerfTableModule, ButtonModule], exports: [PerfFooterComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { PERF_CONFIG, PerfChartComponent, PerfChartModule, PerfDropdownComponent, PerfDropdownModule, PerfFooterComponent, PerfFooterModule, PerfHeaderComponent, PerfHeaderModule, PerfTabAverageAnnualComponent, PerfTabAverageAnnualModule, PerfTabCumulativeTotalComponent, PerfTabCumulativeTotalModule, PerfTabDiscreteAverageAnnualComponent, PerfTabDiscreteAverageAnnualModule, PerfTabDistributionsComponent, PerfTabDistributionsModule, PerfTabMapperService, PerfTabMonthlyCalendarComponent, PerfTabMonthlyCalendarModule, PerfTabRiskMeasuresComponent, PerfTabRiskMeasuresModule, PerfTabTotalReturnsComponent, PerfTabTotalReturnsModule, PerfTableComponent, PerfTableModule, PerfTabsComponent, PerfTabsModule, PerfTabsService };
